import { ViewContainerRef } from '@angular/core';
import { DialogPosition } from '@angular/material/dialog';
import * as moment from 'moment';
import { Observable } from 'rxjs';

import {
  Agenzia,
  Albergo,
  AlbergoMaster,
  AlbergoMasterImmagini,
  AlbergoMasterPagina,
  AlbergoMasterPaginaXLingua,
  AlbergoMasterXLingua,
  Allegato,
  Arrotondamento,
  Articolo,
  ArticoloXLingua,
  Banner,
  BannerXLingua,
  BaseAlbergo,
  BloccoHtml,
  BloccoHtmlXLingua,
  Cancellazione,
  CancellazioneXLingua,
  CategoriaPiatto,
  CategoriaPiattoXLingua,
  CausaleOperazione,
  CausaleOperazioneXLingua,
  Cliente,
  ClienteMessaggi,
  CodicePromozione,
  CodicePromozioneXLingua,
  ComponenteXPrenotazione,
  ComponenteXVariazione,
  ComponenteXVariazioneXLingua,
  Comune,
  Dashboard,
  DettaglioArrotondamento,
  DettaglioCancellazione,
  DettaglioPianoTariffario,
  DettaglioPromozione,
  DettaglioTrattamento,
  DisponibilitaXPortaleXAlbergo,
  Evento,
  EventoXLingua,
  Fascia,
  GiorniChiusura,
  ImmagineXTipoCameraOTA,
  Lingua,
  Listino,
  LogDisponibilitaPortaleXAlbergo,
  LogOperazionePortaleXAlbergo,
  LogRicercaPortaleXAlbergo,
  Menu,
  MenuXLingua,
  ModalitaPagamento,
  ModalitaPagamentoXLingua,
  MotivoViaggio,
  MotivoViaggioXLingua,
  MySelfPage,
  MySelfPageXLingua,
  Nazione,
  NazioneXLingua,
  NotificaEmail,
  ParametroRicerca,
  ParametroRicercaXLingua,
  PianoTariffario,
  Piatto,
  PiattoXLingua,
  PortaleParametri,
  PortaleXAlbergo,
  PortaleXAlbergoCancellazioniOTA,
  PortaleXAlbergoFiltri,
  PortaleXAlbergoImmagini,
  PortaleXAlbergoServiziOTA,
  PortaleXAlbergoVariazioni,
  PortaleXAlbergoXLingua,
  Prenotazione,
  PrenotazioneCC,
  PrenotazioneExtra,
  PrenotazioneExtraArticoli,
  PrenotazioneLogBilanciamento,
  PrenotazioneUpSelling,
  Preventivo,
  PreventivoCamere,
  PreventivoCamerePax,
  PreventivoCamereProposte,
  PreventivoCamereProposteDettagli,
  PreventivoTimeLine,
  Promozione,
  PromozioneXLingua,
  Recensione,
  RecensioneXLingua,
  Richiesta,
  RichiestaCamere,
  RichiestaCamerePax,
  Riduzione,
  Risorsa,
  RisorsaXLingua,
  RoomingList,
  Servizio,
  ServizioDms,
  ServizioDmsXLingua,
  ServizioXLingua,
  Sistemazione,
  SistemazioneXLingua,
  Sondaggio,
  SondaggioDomanda,
  SondaggioDomandaXLingua,
  SondaggioRisposta,
  SondaggioXLingua,
  SourceBrandXAgenzia,
  Storico,
  StoricoPrenotazioneWS,
  Supplemento,
  TagCrm,
  TagCrmImmagini,
  TagCrmXLingua,
  TariffaOTA,
  TariffaOTAXLingua,
  TariffaOTAXPortale,
  TariffaOTAXTipoCameraOTA,
  Template,
  TemplateTags,
  TemplateXLingua,
  TipoCamera,
  TipoCameraOTA,
  TipoCameraOTAXLingua,
  TipoCameraXLingua,
  TipoCartaCreditoXAlbergo,
  Transazione,
  Trattamento,
  UbicazioneIstat,
  UbicazioneIstatMenu,
  UbicazioneIstatXLingua,
  UpSelling,
  UpSellingXLingua,
  Utente,
  UtenteXPermesso,
  VariazionePrezzoXArticoloXComponente,
  VariazionePrezzoXArticoloXComponenteXTipoCamera,
  VariazionePrezzoXArticoloXDurata,
  VariazionePrezzoXArticoloXGiorniAnticipo,
  VariazionePrezzoXArticoloXPersona,
  VariazionePrezzoXArticoloXPianoFamiglia,
  VariazionePrezzoXArticoloXTipoCamera,
  VariazionePrezzoXArticoloXTipoPasto,
  VariazionePrezzoXArticoloXTrattamento,
  VariazioneTassaSoggiornoXTrattamento,
  VariazioneTassaSoggiornoXUbicazioneIstat,
  VoceAddebito,
  VoceAddebitoXLingua,
  WorkFlow,
} from './bo.model';
import {
  CampoObbligatorioSelfCheckIn,
  CategoriaAllergene,
  CriteriaOperator,
  FilterValueType,
  FonteRecensione,
  MealPlanType,
  MenuCategory,
  MittenteMessaggio,
  ModalitaCalcoloPrezzo,
  ModalitaSceltaMenuMySelf,
  SortingType,
  StatoContabilizzazione,
  StatoCtaCtd,
  StatoEsecuzioneTransazione,
  StatoMyForecast,
  StatoPortaleXAlbergo,
  StatoPrenotazione,
  StatoPrenotazioneWelcome,
  StatoPreventivo,
  StatoPubblicazionePortale,
  StelleAlbergo,
  TipoApplicazioneSupplemento,
  TipoComponentePrenotazione,
  TipoContabilizzazione,
  TipoDatoClientiProfilati,
  TipoDatoPrenotazioniDashboard,
  TipoDatoPrenotazioniPickup,
  TipoDatoPreventiviDashboard,
  TipoDatoPreventiviPickup,
  TipoDatoStorico,
  TipoDisponibilitaArticolo,
  TipoDomandaSondaggio,
  TipoEsitoOperazionePortaleXAlbergo,
  TipoEsitoSbm,
  TipoFiltroPrenotazioni,
  TipoImmagineAlbergoMaster,
  TipoImmaginePortale,
  TipoImmaginePortaleAdmin,
  TipoImmaginePromozione,
  TipoImmagineTagCrm,
  TipoImmagineUbicazioneIstat,
  TipologiaAlbergo,
  TipoModalitaPagamento,
  TipoModificaStatoPortaliCollegati,
  TipoNotificaEmail,
  TipoOperazionePortaleXAlbergo,
  TipoPaginaMySelf,
  TipoPasto,
  TipoPermesso,
  TipoPortale,
  TipoPrenotazione,
  TipoPrenotazioneXPay,
  TipoProduzioneXComponenteXPrenotazione,
  TipoRichiestaPreventivo,
  TipoScontoProposta,
  TipoStoricoCliente,
  TipoSupplemento,
  TipoTemplate,
  TipoValore,
  TipoVisualizzazioneBanner,
  TipoVisualizzazioneGrigliaDisponibilita,
  VersioneMyPage,
  VersioneSelfCheckIn,
} from './enum';

export class Sessione {
  albergo: Albergo;
  clienteMySelf: ClienteMySelf;
  utente: Utente;
  isMySelf: boolean;
  token: string;
  myForecast: MyForecast[];
  oidAlbergoIniziale: number;
  isPostaAttiva: boolean;
  email: string;
  lingue: Lingua[];
  clientId: string;
}

export class Parametri {
  isRestrizioniChecked: boolean;
  isPercentualeOccupazioneChecked: boolean;
  isDisponibiliChecked: boolean;
  isClientiCheDevonoArrivareChecked: boolean;
  trentinoEmettiCartaRQ: TrentinoEmettiCartaRQ;
  isVisualizzaUrlRichiesta: boolean;
  isSbloccaStatoPortaleCollegatoMaster: boolean;
  isAvviaPubblicazioneAutomaticaChecked: boolean;
  isVisualizzaEventi: boolean;
  tipoFiltroPrenotazioni: TipoFiltroPrenotazioni;
  isEliminataPrenotazioni: boolean;
}

export class WebApiRequest { }

export class WebApiRequestViewSelect {
  filterRequest: WebApiRequestFilter;
  addEmptyItem: boolean;

  constructor(filterRequest: WebApiRequestFilter, addEmptyItem: boolean) {
    this.filterRequest = filterRequest;
    this.addEmptyItem = addEmptyItem;
  }
}

export class WebApiRequestFilter {
  filters: Filter[];
  sorting: Sorting[];
  take: number;
  skip: number;
  fields: string[];

  constructor(sorting?: Sorting) {
    if (sorting != null) {
      this.sorting = [sorting];
    }
  }

  public static fromFilter(field: string, operator: CriteriaOperator, value?: string, valueType?: FilterValueType, sorting?: Sorting) {
    let rq = new WebApiRequestFilter();
    rq.filters = [new Filter(field, operator, value, valueType, value == null && !operator.includes('$v'))];

    if (sorting != null) {
      rq.sorting = [sorting];
    }

    return rq;
  }

  public static fromFilters(filters: Filter[], sorting?: Sorting) {
    let rq = new WebApiRequestFilter();
    rq.addFilters(...filters);

    if (sorting != null) {
      rq.sorting = [sorting];
    }

    return rq;
  }

  public addFilters(...filters: Filter[]) {
    let criteriaOperatorValues: string[] = Object.values(CriteriaOperator);

    filters.filter(x => x.value == null && !criteriaOperatorValues[x.operator].includes('$v')).forEach(x => x.active = true);

    if (this.filters == null) {
      this.filters = filters;
    } else {
      this.filters = this.filters.concat(filters);
    }
  }
}

export class WebApiResponse {
  errori: Errore[];
  data: any;

  constructor(data?: any) {
    this.data = data;
  }
}

export class WebApiResponseFilter extends WebApiResponse {
  totalRecords: number;

  constructor() {
    super();
  }
}

export class WebApiResponseUpdate extends WebApiResponse {
  data: { obj: any }
}

export class WebApiResponseUpdateDetails extends WebApiResponse {
  data: { obj: any, details: any[] }
}

export class Errore {
  messaggio: string;
  idTraduzione: string;
  parameters: TranslateParameter[];

  constructor(idTraduzione?: string, parameters?: TranslateParameter[], messaggio?: string) {
    this.idTraduzione = idTraduzione;
    this.parameters = parameters;
    this.messaggio = messaggio;
  }
}

export class Dimension {
  width: number;
  height: number;

  constructor(dimension?: Dimension) {
    if (dimension != null) {
      this.width = dimension.width;
      this.height = dimension.height;
    }
  }
}

export class ScriptParameter {
  name: string;
  value: string;

  constructor(name: string, value?: string) {
    this.name = name;
    this.value = value;
  }
}

export class TranslateParameter {
  name: string;
  value: string;

  constructor(value: string, name?: string) {
    this.value = value;

    if (!!name) {
      this.name = name;
    } else {
      this.name = 'value';
    }
  }
}

export class NgxStorageEvent {
  key: string;
  value: any;
}

export class ColorPickerModel {
  width: string;
  height: string;
  position: string;
  positionOffset: string;
  positionRelativeToArrow: boolean;
  dialogDisplay: string;
  useRootViewContainer: boolean;
}

export interface CalendarDate {
  mDate: moment.Moment;
  today?: boolean;
  events: CalendarEvent[];
}

export interface CalendarEvent {
  date: moment.Moment;
  color: string;
  name: string;
  description: string;
  customData: any;
}

export interface CalendarEventsDataSource {
  getEventToDisplay(calendarDate: CalendarDate): CalendarEvent;
  events: CalendarEvent[];
}

export class DialogOptions {
  title?: string;
  message: string;
  messageParams: any;
  params?: any;
  okButtonText?: string;
  cancelButtonText?: string;
  isShowCancelButton: boolean;
  dialogPosition: DialogPosition;
  width: string;
  minWidth: string;
  height: string;
  maxHeight: string;
  minHeight: string;
  panelClass: string;
  backdropClass: string;
  isErrore: boolean;
  disableClose: boolean;
  hasBackdrop: boolean;
  viewContainerRef: ViewContainerRef;

  constructor(title?: string) {
    this.title = title;
    this.okButtonText = 'shared.dialog.ok';
    this.cancelButtonText = 'shared.dialog.annulla';
    this.isShowCancelButton = false;
    this.width = '';
    this.minWidth = '';
    this.height = '';
    this.maxHeight = '';
    this.minHeight = '';
    this.panelClass = '';
    this.backdropClass = '';
    this.isErrore = false;
    this.disableClose = false;
    this.hasBackdrop = true;
  }
}

export class FileDto {
  name: string;
  url: string;
  base64: string;
}

export class MenuClickEvent {
  route: RouteInfo;
  replaceUrl: boolean;
  openInNewTab: boolean;
}

export class AuthenticateMySelfRQ {
  oidAlbergo: number;
  oidPortale: number;
  email: string;
  password: string;
  cognome: string;
  codicePrenotazione: string;
  oid: number;
}

export class AuthenticateMySelf {
  albergo: Albergo;
  portaleXAlbergo: PortaleXAlbergo;
  clienteMySelf: ClienteMySelf;
  token: string;
}

export class AuthenticateMySelfRS extends WebApiResponse {
  data: AuthenticateMySelf;
}

export class AuthenticateAlbergoRQ {
  codiceAlbergo: number;
  utente: string;
  password: string;
  clientId: string;
}

export class AuthenticateAlbergoRS extends WebApiResponse {
  data: AuthenticateAlbergo;
}

export class AuthenticateAlbergo {
  albergo: Albergo;
  utente: Utente;
  permessi: string[];
  plugins: RouteInfo[];
  token: string;
  //myForecast: MyForecast[];
  messaggi: string[];
  warnings: string[];
  lingue: Lingua[];
  isPostaAttiva: boolean;
  email: string;
  clientId: string;
}

export class ClienteMySelf {
  oidAnagraficaHotel: number;
  nome: string;
  cognome: string;
  email: string;
  cellulare: string;
  indirizzo: string;
  comune: Comune;
  comuneString: string;
  cap: string;
  provincia: string;
  nazione: Nazione;
  nazioneString: string;
  nazioniXLingua: NazioneXLingua[];
  lingua: string;
  apiKey: string;
  token: string;
  privacy: boolean;
  newsletter: boolean;
  codiceFiscale: string;
  partitaIva: string;
  codiceDestinatario: string;
}

export class SetMySelfPagesXLinguaRQ {
  pagina: MySelfPage;
  pagineXLingua: MySelfPageXLingua[];

  constructor() {
    this.pagina = new MySelfPage();
    this.pagineXLingua = [];
  }
}

export class SetPiattiXLinguaRQ {
  piatto: Piatto;
  piattiXLingua: PiattoXLingua[];

  constructor() {
    this.piatto = new Piatto();
    this.piattiXLingua = [];
  }
}

export class SetMenuXLinguaRQ {
  menu: Menu;
  menuXLingua: MenuXLingua[];

  constructor() {
    this.menu = new Menu();
    this.menuXLingua = [];
  }
}

export class SetCategoriePiattiXLinguaRQ {
  categoriaPiatto: CategoriaPiatto;
  categoriePiattiXLingua: CategoriaPiattoXLingua[];

  constructor() {
    this.categoriaPiatto = new CategoriaPiatto();
    this.categoriePiattiXLingua = [];
  }
}

export class SetTipiCameraXLinguaRQ {
  tipoCamera: TipoCamera;
  tipiCameraXLingua: TipoCameraXLingua[];

  constructor() {
    this.tipoCamera = new TipoCamera();
    this.tipiCameraXLingua = [];
  }
}

export class SetRisorseXLinguaRQ {
  risorsa: Risorsa;
  risorseXLingua: RisorsaXLingua[];

  constructor() {
    this.risorsa = new Risorsa();
    this.risorseXLingua = [];
  }
}

export class SetParametriRicercaXLinguaRQ {
  parametroRicerca: ParametroRicerca;
  parametriRicercaXLingua: ParametroRicercaXLingua[];

  constructor() {
    this.parametroRicerca = new ParametroRicerca();
    this.parametriRicercaXLingua = [];
  }
}

export class TemplateTagsXCategoria {
  categoria: string;
  tags: TemplateTags[];
}

export class TemplateLingua {
  template: Template;
  templatesXLingua: TemplateXLingua[];
  tags: TemplateTagsXCategoria[];
  allegati: Allegato[];

  constructor() {
    this.template = new Template();
    this.templatesXLingua = [];
    this.tags = [];
    this.allegati = [];
  }
}

export class GetTemplateRS extends WebApiResponse {
  data: TemplateLingua
}

export class GetTemplatesRS extends WebApiResponseFilter {
  data: { templates: TemplateLingua[] };
}

export class SetTemplatesXLinguaRQ {
  template: Template;
  templatesXLingua: TemplateXLingua[];

  constructor() {
    this.template = new Template();
    this.templatesXLingua = [];
  }
}

export class SetRecensioniXLinguaRQ {
  recensione: Recensione;
  recensioniXLingua: RecensioneXLingua[];

  constructor() {
    this.recensione = new Recensione();
    this.recensioniXLingua = [];
  }
}

export class SetBlocchiHtmlXLinguaRQ {
  bloccoHtml: BloccoHtml;
  blocchiHtmlXLingua: BloccoHtmlXLingua[];

  constructor() {
    this.bloccoHtml = new BloccoHtml();
    this.blocchiHtmlXLingua = [];
  }
}

export class SetCodiciPromozioneXLinguaRQ {
  codicePromozione: CodicePromozione;
  codiciPromozioneXLingua: CodicePromozioneXLingua[];

  constructor() {
    this.codicePromozione = new CodicePromozione();
    this.codiciPromozioneXLingua = [];
  }
}

export class SetBannerXLinguaRQ {
  banner: Banner;
  bannerXLingua: BannerXLingua[];

  constructor() {
    this.banner = new Banner();
    this.bannerXLingua = [];
  }
}

export class SetNazioniXLinguaRQ {
  nazione: Nazione;
  nazioniXLingua: NazioneXLingua[];

  constructor() {
    this.nazione = new Nazione();
    this.nazioniXLingua = [];
  }
}

export class GetNazioniTradotteRQ {
  lingua: string;
  nome: string;
  addEmptyItem: boolean;
}

export class GetNazioneTradottaRQ {
  oid: number;
  nomeItaliano: string;
  lingua: string;
}

export class SetMotiviViaggioXLinguaRQ {
  motivoViaggio: MotivoViaggio;
  motiviViaggioXLingua: MotivoViaggioXLingua[];

  constructor() {
    this.motivoViaggio = new MotivoViaggio();
    this.motiviViaggioXLingua = [];
  }
}

export class SetTrattamentiXLinguaRQ {
  trattamento: Trattamento;
  trattamentiXLingua: ArticoloXLingua[];

  constructor() {
    this.trattamento = new Trattamento();
    this.trattamentiXLingua = [];
  }
}

export class SetSupplementiXLinguaRQ {
  supplemento: Supplemento;
  supplementiXLingua: ArticoloXLingua[];

  constructor() {
    this.supplemento = new Supplemento();
    this.supplementiXLingua = [];
  }
}

export class SetArticoliXLinguaRQ {
  articolo: Articolo;
  articoliXLingua: ArticoloXLingua[];

  constructor() {
    this.articolo = new Articolo();
    this.articoliXLingua = [];
  }
}

export class SetRiduzioniXLinguaRQ {
  riduzione: Riduzione;
  riduzioniXLingua: ArticoloXLingua[];

  constructor() {
    this.riduzione = new Riduzione();
    this.riduzioniXLingua = [];
  }
}

export class SetCancellazioniXLinguaRQ {
  cancellazione: Cancellazione;
  cancellazioniXLingua: CancellazioneXLingua[];

  constructor() {
    this.cancellazione = new Cancellazione();
    this.cancellazioniXLingua = [];
  }
}

export class SetModalitaPagamentoXLinguaRQ {
  modalitaPagamento: ModalitaPagamento;
  modalitaPagamentoXLingua: ModalitaPagamentoXLingua[];

  constructor() {
    this.modalitaPagamento = new ModalitaPagamento();
    this.modalitaPagamentoXLingua = [];
  }
}

export class SetServiziXLinguaRQ {
  servizio: Servizio;
  serviziXLingua: ServizioXLingua[];

  constructor() {
    this.servizio = new Servizio();
    this.serviziXLingua = [];
  }
}

export class SetTagCrmXLinguaRQ {
  tagCrm: TagCrm;
  tagCrmXLingua: TagCrmXLingua[];

  constructor() {
    this.tagCrm = new TagCrm();
    this.tagCrmXLingua = [];
  }
}

export class SetVociAddebitoXLinguaRQ {
  voceAddebito: VoceAddebito;
  vociAddebitoXLingua: VoceAddebitoXLingua[];

  constructor() {
    this.voceAddebito = new VoceAddebito();
    this.vociAddebitoXLingua = [];
  }
}

export class SetComponentiXVariazioneXLinguaRQ {
  componenteXVariazione: ComponenteXVariazione;
  componentiXVariazioneXLingua: ComponenteXVariazioneXLingua[];

  constructor() {
    this.componenteXVariazione = new ComponenteXVariazione();
    this.componentiXVariazioneXLingua = [];
  }
}

export class SetTipiCameraOTAXLinguaRQ {
  tipoCameraOTA: TipoCameraOTA;
  tipiCameraOTAXLingua: TipoCameraOTAXLingua[];

  constructor() {
    this.tipoCameraOTA = new TipoCameraOTA();
    this.tipiCameraOTAXLingua = [];
  }
}

export class SetTariffeOTAXLinguaRQ {
  tariffaOTA: TariffaOTA;
  tariffeOTAXLingua: TariffaOTAXLingua[];

  constructor() {
    this.tariffaOTA = new TariffaOTA();
    this.tariffeOTAXLingua = [];
  }
}

export class SetPortaliXLinguaRQ {
  portale: PortaleXAlbergo;
  portaliXLingua: PortaleXAlbergoXLingua[];

  constructor() {
    this.portale = new PortaleXAlbergo();
    this.portaliXLingua = [];
  }
}

export class SetEventiXLinguaRQ {
  evento: Evento;
  eventiXLingua: EventoXLingua[];

  constructor() {
    this.evento = new Evento();
    this.eventiXLingua = [];
  }
}

export class SetUbicazioniIstatXLinguaRQ {
  ubicazioneIstat: UbicazioneIstat;
  ubicazioniIstatXLingua: UbicazioneIstatXLingua[];

  constructor() {
    this.ubicazioneIstat = new UbicazioneIstat();
    this.ubicazioniIstatXLingua = [];
  }
}

export class Sorting {
  field: string;
  type: SortingType;

  constructor(field?: string, type?: SortingType) {
    this.field = field;
    this.type = type;
  }
}

export class Filter {
  field: string;
  fields: string[];
  operator: number;
  invertedOperator: number;
  value: string;
  valueType: FilterValueType;
  active: boolean;
  inverted: boolean;

  constructor(field: string | string[], operator: CriteriaOperator, value?: string, filterValueType?: FilterValueType, active: boolean = false, invertedOperator?: CriteriaOperator, inverted: boolean = false) {
    if (Array.isArray(field)) {
      this.fields = field;
    } else {
      this.field = field;
    }

    let criteriaOperatorValues: string[] = Object.values(CriteriaOperator);

    if (!!operator) {
      let index: number = criteriaOperatorValues.indexOf(operator);

      if (index >= 0) {
        this.operator = index;
      }
    }

    if (!!invertedOperator) {
      let index: number = criteriaOperatorValues.indexOf(invertedOperator);

      if (index >= 0) {
        this.invertedOperator = index;
      }
    }

    this.value = value;
    this.valueType = filterValueType;
    this.active = active;
    this.inverted = inverted;
  }
}

export class ViewPreventivoRQ {
  oidPreventivo: number;

  constructor(oidPreventivo: number) {
    this.oidPreventivo = oidPreventivo;
  }
}

export class PaymentMethod {
  paymentId: number;
  nome: string;
  descrizione: string;
  testoBottonePaga: string;
  note: string;
  caparra: number;
  isCaparraPercentuale: boolean;
  numeroNottiCaparra: number;
  isCaparraPerCamera: boolean;
  importoMinimoCaparra: number;
  caparraTotale: number;
  email: string;
  isTest: boolean;
  isUsePost: boolean;
  tipo: TipoModalitaPagamento;
  iban: string;
  banca: string;
  intestatarioConto: string;
  swift: string;
  intestazione: string;
  token: string;
  xPayAlias: string;
  xPaySecretKey: string;
  xPayTipoPrenotazione: TipoPrenotazioneXPay;
  xPayCodiceStruttura: string;
  payWayTerminalId: string;
  payWaySecretKey: string;
  unicreditTerminalId: string;
  unicreditSecretKey: string;
  tPayTerminalId: string;
  tPaySecretKey: string;
  stripeSecretKey: string;
  stripePublicKey: string;
  gestpayApiKey: string;
  gestpayShopId: string;
  paypalClientId: string;
  paypalSecretKey: string;
  sumUpMerchantId: string;
  sumUpClientId: string;
  sumUpSecretKey: string;
  addonPaymentsMerchantId: string;
  addonPaymentsSecretKey: string;
  beSafePayApiKey: string;
  satispayKeyId: string;
  hobexEntityId: string;
  hobexAccessToken: string;
  axeptaApiKey: string;
  axeptaApiKeySmartCheckout: string;
  axeptaAccessToken: string;
  holipayHotelId: string;
  holipaySecretKey: string;
  siapayShopId: string;
  siapaySecretKey: string;
  scalaPayApiKey: string;
  virtualPayMerchantId: string;
  virtualPayABI: string;
  virtualPaySecretKey: string;
  myPOSWalletNumber: string;
  myPOSSID: string;
  myPOSKeyIndex: number;
  myPOSPrivateKey: string;
  myPOSPublicCertificate: string;
  vivaWalletClientId: string;
  vivaWalletSecretKey: string;
  tipoContabilizzazione: TipoContabilizzazione;

  constructor(oid: number) {
    this.paymentId = oid;
  }
}

export class DashboardRQ {
  dal: string;
  al: string;
}

export class DashboardHotelRS extends WebApiResponse {
  data: { dashboards: ViewDashboard[] };
}

export class PlanningTipoCameraRS {
  oid: number;
  nome: string;
  tipoCameraHotel: string;
  isUsoSingola: boolean;
  disponibiliMassime: number;
  tariffe: PlanningTariffaRS[];
  giorni: PlanningGiornoTipoCameraRS[];
  inputVisibleDisponibili: number = -1;
  inputVisibleVariazioneDisponibili: number = -1;
  inputVisiblePrezzoBase: number = -1;
  selectVisibleFascia: number = -1;
  inputVisibleDurataMinimaSoggiorno: number = -1;
  inputVisibleDurataMassimaSoggiorno: number = -1;
}

export class PlanningTariffaRS {
  oid: number;
  nome: string;
  isPrezzoModificabile: boolean;
  prezzi: PlanningPrezziTariffaRS[];
  hidden: boolean;
  inputVisiblePrezzo: number = -1;
  inputVisiblePrezzoUsoSingola: number = -1;
  inputVisibleDurataMinimaSoggiorno: number = -1;
  inputVisibleDurataMassimaSoggiorno: number = -1;
}

export class PlanningPrezziTariffaRS {
  oid: number;
  data: string;
  stato: StatoPortaleXAlbergo;
  statoPubblicazione: StatoPubblicazionePortale;
  durataMinimaSoggiorno: number;
  durataMassimaSoggiorno: number;
  statoCta: StatoCtaCtd;
  statoCtd: StatoCtaCtd;
  prezzo: number;
  prezzoUsoSingola: number;
  infoRiga: string;
  empty: boolean;
  oidFascia: number;
  isStatoBloccato: boolean;
  isPrezzoBloccato: boolean;

  constructor(disponibilita: DisponibilitaXPortaleXAlbergo) {
    this.oid = disponibilita.oid;
    this.data = disponibilita.giorno;
    this.stato = disponibilita.statoPortaleXAlbergo;
    this.statoPubblicazione = disponibilita.statoPubblicazione;
    this.durataMinimaSoggiorno = disponibilita.durataMinimaSoggiorno;
    this.durataMassimaSoggiorno = disponibilita.durataMassimaSoggiorno;
    this.statoCta = disponibilita.statoCta;
    this.statoCtd = disponibilita.statoCtd;
    this.prezzo = disponibilita.prezzo;
    this.prezzoUsoSingola = disponibilita.prezzoUsoSingola;

    this.infoRiga = '';

    let variazioniDisponibili = disponibilita.portaleXAlbergo != null && disponibilita.portaleXAlbergo.isAttivoVariazioneDisponibili ? disponibilita.variazioneDisponibili : 0;

    if (disponibilita.disponibili + variazioniDisponibili <= 0) {
      this.infoRiga = '!';
    } else if (disponibilita.durataMinimaSoggiorno > 0 || disponibilita.durataMassimaSoggiorno > 0) {
      this.infoRiga = '*';
    }

    if (disponibilita.statoPubblicazione != StatoPubblicazionePortale.Pubblicato) {
      if (!this.infoRiga) {
        this.infoRiga = "#";
      } else {
        this.infoRiga += " #";
      }
    }

    this.empty = false;

    if (disponibilita.fasciaAttiva != null) {
      this.oidFascia = disponibilita.fasciaAttiva.oid
    } else {
      this.oidFascia = -1;
    }

    this.isStatoBloccato = disponibilita.isStatoPortaleXAlbergoBloccato;
    this.isPrezzoBloccato = disponibilita.isPrezzoBloccato;
  }
}

export class PlanningGiornoTipoCameraRS {
  oid: number;
  data: string;
  isStatoTariffeDifferente: boolean;
  stato: StatoPortaleXAlbergo;
  isStatoPortaleXAlbergoBloccato: boolean;
  statoPubblicazione: StatoPubblicazionePortale;
  disponibiliHotel: number;
  disponibili: number;
  variazioneDisponibili: number;
  variazioneDisponibiliHotel: number;
  durataMinimaSoggiorno: number;
  durataMassimaSoggiorno: number;
  prezzoBase: number;
  fascia: Fascia;
  prenotate: number;
  percentualeOccupazione: string;
  empty: boolean;
}

export class PlanningRQ {
  dal: string;
  al: string;
  oidTipoCamera: number;
  oidTariffa: number;
  filtroTipiCameraTariffe: FiltroTipoCameraTariffe[];
  oidAlbergo: number;
  oidPortaleXAlbergo: number;
  isDisponibilitaMobile: boolean;
}

export class EventoPlanning {
  nome: string;
  colore: string;
  durata: number;
}

export class Planning {
  tipiCamere: PlanningTipoCameraRS[];
  giorni: string[];
  giorniChiusura: GiorniChiusura[];
  eventi: EventoPlanning[];
  filtri: PortaleXAlbergoFiltri[];
}

export class PlanningRS extends WebApiResponse {
  data: Planning;
}

export class GiornoPlanning {
  giorno: string;
  isWeekend: boolean;
  isGiornoChiusura: boolean;
  noteGiornoChiusura: string;
  isPrimoGiornoChiusura: boolean;
  viewMonth: boolean;
  dateNumber: number;

  constructor(date: string, al: string, giorniChiusura?: GiorniChiusura[], isPrimoGiorno?: boolean) {
    let d = moment(date);
    let alDate = moment(al);

    let giornoChiusura: GiorniChiusura;

    if (giorniChiusura != null && giorniChiusura.length > 0) {
      giornoChiusura = giorniChiusura.find(x => d.isBetween(moment(x.dal), moment(x.al), null, '[]'));
    }

    this.giorno = date;
    this.isWeekend = d.day() == 6 || d.day() == 0;
    this.isGiornoChiusura = giornoChiusura != null;
    this.noteGiornoChiusura = giornoChiusura?.note;
    this.isPrimoGiornoChiusura = giornoChiusura != null && (isPrimoGiorno || date == giornoChiusura.dal);

    if (d.month() == alDate.month()) {
      this.viewMonth = alDate.date() - d.date() >= 2;
    } else {
      this.viewMonth = d.daysInMonth() - d.date() >= 2;
    }

    this.dateNumber = d.date();
  }
}

export class PrezziRQ {
  dal: string;
  al: string;
  oidPortaleXAlbergo: number;
  camere: PrezziCamereRQ[];
}

export class PrezziCamereRQ {
  pax: PrezziCamerePaxRQ[];
}

export class PrezziCamerePaxRQ {
  oid: number;
  quantita: number;
  eta: number;
}

export class PrezziRS {
  camere: PrezziCamereRS[];
}

export class PrezziCamereRS {
  oid: number;
  nome: string;
  tariffe: PrezziCamereTariffeRS[];
}

export class PrezziCamereTariffeRS {
  oid: number;
  nome: string;
  prezzi: PrezziCamereTariffeXGiornoRS[]
  totale: number;
}

export class PrezziCamereTariffeXGiornoRS {
  data: string;
  prezzo: number;
  disponibili: number;
}

export class NgxChartSerie {
  name: string;
  value: number;

  constructor(name?: string, value?: number) {
    this.name = name;
    this.value = value;
  }
}

export class NgxAdvancedChartSerie {
  name: string;
  series: NgxChartSerie[];
}

export class NgxChart {
  results: NgxChartSerie[];
}

export class NgxAdvancedChart {
  results: NgxAdvancedChartSerie[];
}

export class ViewDashboard {
  dashboard: Dashboard;
  ngxChart: NgxChart;
  ngxAdvancedChart: NgxAdvancedChart;
}

export class AlbergoMySelf {
  oid: number;
  nome: string;

  constructor(oid?: number) {
    this.oid = oid;
  }
}

export class PortaleMySelf {
  oid: number;
  nome: string;
  nomeStruttura: string;
  oidUbicazioneIstat: number;
  urlImmagineSfondo: string;
  urlImmagineLogo: string;
  urlIFrameGoogleMap: string;
  email: string;
  telefono: string;
  telefonoWhatsapp: string;
  indirizzo: string;
  cap: string;
  citta: string;
  provincia: string;
  coloreSelfCheckIn: string;
  isAttivaBookingExtraSelfCheckIn: boolean;
  isAttivaUpSellingSelfCheckIn: boolean;
  isAttivaCancellazioneSelfCheckIn: boolean;
  isVisualizzaTuttiDatiSelfCheckIn: boolean;
  templateStampaOid: number;
  isAccettaContrattoPrenotazioneStep2: boolean;
  isVerificaCartaCredito: boolean;
  isVisualizzaCRO: boolean;
  condizioniContratto: string;
  recaptchaAttiva: boolean;
  isBloccaModificaDatiCheckIn: boolean;
  isNascondiChat: boolean;
  orarioDiArrivoMinimo: string;
  orarioDiArrivoMassimo: string;
  campiObbligatori: CampoObbligatorioSelfCheckIn[];
  testoSelfCheckIn: string;
  isVisualizzaPrenotazioneEliminata: boolean;
  isNascondiImportiDopoCheckOut: boolean;
  isEliminaPrenotazione: boolean;
  isRichiediPasswordCancellazionePrenotazione: boolean;
  versioneSelfCheckIn: VersioneSelfCheckIn;
}

export class UbicazioneIstatMySelf {
  oid: number;
  oidAlbergo: number;
  nome: string;
  isRichiediPagamentoArticoliECommerce: boolean;
  isVisualizzaFiltroAllergeni: boolean;
  isSceltaMenuAttiva: boolean;
  modalitaSceltaMenuMySelf: ModalitaSceltaMenuMySelf;
  isRoomServiceAttivo: boolean;
  coloreMySelf: string;
  urlImmagineSfondo: string;
  urlHeaderMySelf: string;
  testoIniziale: string;
  testoIniziale2: string;
}

export class PrezzoGiornoMySelf {
  data: string;
  prezzo: number;
  selected: boolean;
}

export class ArticoloMySelf {
  oid: number;
  nome: string;
  descrizione: string;
  tipo: TipoSupplemento;
  tipoApplicazione: TipoApplicazioneSupplemento;
  urlImmagine: string;
  quantita: number;
  quantitaMassima: number;
  prezzo: number;
  sconto: number;
  prezzoPieno: number;
  totale: number;
  giorni: PrezzoGiornoMySelf[];
  giorniString: string;
  isApplicaATuttiComponenti: boolean;
  note: string;
  noteVisible: boolean;
}

export class ContenutoMySelf {
  oid: number;
  titolo: string;
  testo: string;
  urlImmagine: string;
}

export class EventoMySelf {
  nome: string;
  descrizione: string;
  urlImmagine: string;
  dal: string;
  al: string;
}

export class VoceAddebitoMySelf {
  nome: string;
  descrizione: string;
  urlImmagine: string;
}

export class ArticoliXVoceAddebitoMySelf {
  voceAddebito: VoceAddebitoMySelf;
  articoli: ArticoloMySelf[];
}

export class PrenotazioneMySelfDettaglio {
  nome: string;
  quantita: number;
  totale: number;
  giorni: string;
  giorniString: PrezzoGiornoMySelf[];
}

export class VoceEstrattoConto {
  descrizione: string;
  quantita: number;
  totale: number;
}

export class GiornoMenuMySelf {
  data: string;
  oidOrdiniPiatti: number[];
  piattiSelected: CategoriePiattiXTipoPastoMySelf[];
  menu: MenuMySelf[];
}

export class CategoriePiattiXTipoPastoMySelf {
  tipoPasto: TipoPasto;
  categoriePiatti: PiattiXCategoriaPiattoMySelf[];
}

export class PiattiXCategoriaPiattoMySelf {
  oid: number;
  nome: string;
  descrizione: string;
  quantitaMassima: number;
  piatti: PiattoMySelf[];
}

export class MenuMySelf {
  oid: number;
  nome: string;
  descrizione: string;
  tipiPasto: CategoriePiattiXTipoPastoMySelf[];
}

export class PiattoMySelf {
  oid: number;
  oidCategoria: number;
  nome: string;
  descrizione: string;
  urlImmagine: string;
  quantita: number;
  quantitaSelected: number;
  note: string;
  quantitaMassima: number;
  quantitaMassimaCategoria: number;
  noteVisible: boolean;
  allergeni: CategoriaAllergene[];
  oidMenu: number;
}

export class PiattiXTipoPastoMySelf {
  tipoPasto: TipoPasto;
  piatti: PiattoMySelf[];
}

export class PrenotazioneMySelf {
  oid: number;
  data: string;
  arrivo: string;
  partenza: string;
  notti: number;
  importo: number;
  sconto: number;
  scontoVoucher: number;
  caparra: number;
  cliente: Cliente;
  agenzia: Agenzia;
  azienda: Agenzia;
  modalitaPagamento: ModalitaPagamento;
  nomeModalitaPagamento: string;
  statoPrenotazione: StatoPrenotazione;
  statoPrenotazioneWelcome: StatoPrenotazioneWelcome;
  codicePrenotazione: string;
  politicaCancellazione: string;
  dataCancellazioneGratuita: string;
  isCancellazioneGratuita: boolean;
  hasSondaggio: boolean;
  hasTipoCameraOTA: boolean;
  hasTariffaOTA: boolean;
  dettagli: PrenotazioneMySelfDettaglio[];
  tipoCamera: TipoCameraMySelf;
  tariffa: TariffaMySelf;
  articoli: ArticoloMySelf[];
  articoliUpSelling: ArticoliXVoceAddebitoMySelf[];
  articoliRoomService: ArticoliXVoceAddebitoMySelf[];
  numeroAdulti: number;
  numeroBambini: number;
  etaBambini: string;
  isSondaggioCompilato: boolean;
  ospiti: ComponenteXPrenotazione[];
  upSellingRooms: BookingSolutionRoomRS[];
  dataUpSelling: string;
  cameraUpSelling: string;
  isEliminata: boolean;
  estrattoConto: VoceEstrattoConto[];
  giorniMenu: GiornoMenuMySelf[];
  upSellingRichiesto: string;
  indiceCamera: number;
  isCheckInPossibile: boolean;
}

export class TipoCameraImmagineMySelf {
  immagine: string;
  descrizione: string;
}

export class ServizioMySelf {
  nome: string;
  icona: string;
  immagineIcona: string;
}

export class SistemazioneMySelf {
  oid: number;
  nome: string;
}

export class TipoCameraMySelf {
  nome: string;
  descrizione: string;
  descrizioneDettagliata: string;
  urlImmagine: string;
  immagini: TipoCameraImmagineMySelf[];
  servizi: ServizioMySelf[];
  sistemazioni: SistemazioneMySelf[];
}

export class CancellazioneMySelf {
  descrizione: string;
}

export class TariffaMySelf {
  descrizione: string;
  descrizioneDettagliata: string;
  nomePromozione: string;
  descrizionePromozione: string;
  descrizioneDettagliataPromozione: string;
  servizi: ServizioMySelf[];
  cancellazione: CancellazioneMySelf;
}

export class RichiestaCameraMySelf {
  numeroAdulti: number;
  numeroBambini: number;
}

export class RichiestaMySelf {
  data: string;
  dal: string;
  al: string;
  uidPreventivo: string;
  codicePreventivo: string;
  statoPreventivo: StatoPreventivo;
  camere: RichiestaCameraMySelf[];
}

export class VoucherMySelf {
  codice: string;
  validoDal: string;
  validoAl: string;
  prenotazioneDal: string;
  prenotazioneAl: string;
  sconto: number;
  isScontoPercentuale: boolean;
  isUtilizzato: boolean;
}

export class RecensioneMySelf {
  data: string;
  voto: number;
  titolo: string;
  testo: string;
}

export class MessaggioMySelf {
  oid: number;
  mittente: MittenteMessaggio;
  data: string;
  messaggio: string;
  parametri: string;
  codicePrenotazione: string;
  codicePreventivo: string;
  isVisualizzato: boolean;
}

export class TransazioneMySelf {
  oid: number;
  uid: string;
  data: string;
  importo: number;
  codicePrenotazione: string;
  isPagamentoEffettuato: boolean;
}

export class PaginaMySelf {
  colore: string;
  isHome: boolean;
  tipoPaginaMySelf: TipoPaginaMySelf;
  titolo: string;
  testo: string;
  url: string;
  icona: string;
  immagineIcona: string;
}

export class SondaggioMySelf {
  data: string;
  punteggio: number;
  risposte: DomandaRispostaSondaggio[];
}

export class GetMySelfConfigRQ {
  oidUbicazioneIstat: number;
}

export class GetMySelfConfigRS extends WebApiResponse {
  data: {
    ubicazioneIstat: UbicazioneIstatMySelf
  };
}

export class GetMySelfRS extends WebApiResponse {
  data: {
    portale: PortaleMySelf,
    ubicazioneIstat: UbicazioneIstatMySelf;
    prenotazioni: PrenotazioneMySelf[],
    prenotazione: PrenotazioneMySelf,
    richieste: RichiestaMySelf[],
    voucher: VoucherMySelf[],
    recensioni: RecensioneMySelf[],
    messaggi: MessaggioMySelf[],
    transazioni: TransazioneMySelf[],
    sondaggi: SondaggioMySelf[],
    contenuti: ContenutoMySelf[],
    lingue: Lingua[],
    lingua: Lingua,
    cliente: Cliente,
    traduzioni: string,
    condizioniPrenotazione: string,
    pagine: PaginaMySelf[],
    eventi: EventoMySelf[],
    articoli: ArticoliXVoceAddebitoMySelf[],
    modalitaPagamento: PaymentMethod[],
    oidAlbergo: number,
    isCheckInSemplificato: boolean
  };
}

export class GetMySelfRQ {
  oidAlbergo: number;
  oidUbicazioneIstat: number;
  oidCliente: number;
  all: boolean;
  isMobile: boolean;
  oidPortale: number;
  lingua: string;
  isMySelf: boolean;
}

export class GetMySelfBookingRS extends WebApiResponse {
  data: {
    albergo: AlbergoMySelf,
    portale: PortaleMySelf,
    prenotazioni: PrenotazioneMySelf[],
    messaggi: MessaggioMySelf[],
    contenuti: ContenutoMySelf[],
    lingue: Lingua[],
    lingua: Lingua,
    traduzioni: string,
    password: string,
    condizioniPrenotazione: string,
    modalitaPagamentoPrenotazioni: PaymentMethod[],
    isCheckInSemplificato: boolean
  };
}

export class GetMySelfBookingRQ {
  uid: string;
  isMobile: boolean;
  oidPortale: number;
  lingua: string;
}

export class PortaleXTariffeRisorse {
  portale: PortaleXAlbergo;
  tariffe: TariffaOTA[];
  risorse: TipoCameraOTA[];
  recensioni: Recensione[];
  blocchiHtml: BloccoHtml[];
  risorseTariffe: TariffaOTAXTipoCameraOTA[];
  immagini: PortaleXAlbergoImmagini[];
  portaliCollegati: PortaleXAlbergo[];
  sourceBrands: SourceBrandXAgenzia[];
  serviziOTA: PortaleXAlbergoServiziOTA[];
  cancellazioniOTA: PortaleXAlbergoCancellazioniOTA[];
  filtri: PortaleXAlbergoFiltri[];
  associazioniTipiCamereTariffe: AssociazioneTipoCameraTariffe[];

  constructor() {
    this.portale = new PortaleXAlbergo();
    this.tariffe = [];
    this.risorse = [];
    this.recensioni = [];
    this.blocchiHtml = [];
    this.risorseTariffe = [];
    this.immagini = [];
    this.portaliCollegati = [];
    this.sourceBrands = [];
    this.serviziOTA = [];
    this.cancellazioniOTA = [];
    this.filtri = [];
    this.associazioniTipiCamereTariffe = [];
  }
}

export class GetPortaleXAlbergoRS extends WebApiResponse {
  data: { portale: PortaleXTariffeRisorse }
}

export class PortaleXLinguaTariffeRisorse {
  portale: PortaleXTariffeRisorse;
  portaliXLingua: PortaleXAlbergoXLingua[];

  constructor() {
    this.portale = new PortaleXTariffeRisorse();
    this.portaliXLingua = [];
  }
}

export class GetPortaliXAlbergoXLinguaRS extends WebApiResponse {
  data: { portale: PortaleXLinguaTariffeRisorse }
}

export interface ViewUbicazioneIstat {
  oid: number;
  nome: string;
}

export interface ViewPortaleXAlbergo {
  oid: number;
  nome: string;
  icona: string;
  oidUbicazioneIstat: number;
}

export interface ViewTipoCameraOTA {
  oid: number;
  descrizione: string;
}

export interface ViewTariffaOTA {
  oid: number;
  descrizione: string;
}

export interface ViewFascia extends BaseAlbergo {
  nome: string;
  colore: number;
  coloreHex: string;
  ubicazioneIstat: ViewUbicazioneIstat;
  ordinamento: number;
  descrizioneVariazione: string;
  politicaCancellazione: Cancellazione;
}

export interface ViewDisponibilitaXCalendarioFasce {
  oid: number;
  data: string,
  oidTipoCamera: number;
  oidFascia?: number;
  oidPortale?: number;
  disponibili: number;
  percentualeOccupazione: string;
}

export interface ViewMeseXDisponibilitaDto {
  year: number;
  month: number;
  listaDisponibilita: ViewDisponibilitaXCalendarioFasce[];
  firstDate: string;
}

export class CalendarioFasceFormRQ {
  firstYear?: number;
  selectedYear?: number;
  oidPortale?: number;
  oidUbicazioneIstat?: number;
  oidAlbergo: number;
  data: string;
}

export class CalendarioFasceFormRS {
  years: number[];
  portale: ViewPortaleXAlbergo;
  oidPortale?: number;
  oidUbicazioneIstat?: number;
  tipiCamera: ViewTipoCameraOTA[];
  fasce: ViewFascia[];
  selectedYear: number;
  mesiXDisponibilita: ViewMeseXDisponibilitaDto[];
}

export class DayOfWeeks {
  isLun: boolean;
  isMar: boolean;
  isMer: boolean;
  isGio: boolean;
  isVen: boolean;
  isSab: boolean;
  isDom: boolean;

  constructor() {
    this.selezionaTutti();
  }

  selezionaTutti() {
    this.isLun = true;
    this.isMar = true;
    this.isMer = true;
    this.isGio = true;
    this.isVen = true;
    this.isSab = true;
    this.isDom = true;
  }

  deselezionaTutti() {
    this.isLun = false;
    this.isMar = false;
    this.isMer = false;
    this.isGio = false;
    this.isVen = false;
    this.isSab = false;
    this.isDom = false;
  }

  isGiornoSelezionato() {
    return this.isLun || this.isMar || this.isMer || this.isGio || this.isVen || this.isSab || this.isDom;
  }
}

export class SalvaFasceRQ {
  oidTipiCamera: number[];
  oidPortale: number;
  oidFascia?: number;
  dal: string;
  al: string;
  dayOfWeeks: DayOfWeeks;
  disponibili: number;
  percentualeOccupazione: string;
}

export class SalvaFasceRS {
  listaDisponibilita: ViewDisponibilitaXCalendarioFasce[];
}

export class GetFasciaRQ {
  oid: number;
}

export class FasciaEventsDataSource implements CalendarEventsDataSource {
  events: CalendarEvent[];

  constructor() {
    this.events = [];
  }

  getEventToDisplay(calendarDate: CalendarDate): CalendarEvent {
    if (calendarDate != null && calendarDate.events != null && calendarDate.events.length > 0) {
      let sortedEvents = calendarDate.events.filter(x => x.customData != null && x.customData.oidFascia > 0).sort((a, b): number => {
        let customDataA = <ViewDisponibilitaXCalendarioFasce>a.customData;
        let customDataB = <ViewDisponibilitaXCalendarioFasce>b.customData;

        let oidFasciaA = customDataA.oidFascia;
        let oidFasciaB = customDataB.oidFascia;

        if (oidFasciaA == oidFasciaB) {
          let oidTipoCameraA = customDataA.oidTipoCamera;
          let oidTipoCameraB = customDataB.oidTipoCamera;

          return (oidTipoCameraA < oidTipoCameraB) ? -1 : (oidTipoCameraA > oidTipoCameraB) ? 1 : 0;
        } else {
          return (oidFasciaA > oidFasciaB) ? -1 : 1;
        }
      });

      if (sortedEvents.length > 0) {
        return sortedEvents[0];
      }
    }

    return null;
  }
}

export class RouteInfo {
  path?: string;
  url?: string;
  title?: string;
  icon?: string;
  iconImage?: string;
  parameters?: any;
  childs?: RouteInfo[];
  color?: string;
  hidden?: boolean;
  categories?: MenuCategory[];
  info?: string;
  isImportant?: boolean;
  isCustomClick?: boolean;
}

export class GetPreventivoRS extends WebApiResponse {
  data: {
    preventivo: Preventivo,
    prenotazione: Prenotazione,
    camere: GetPreventivoRSCameraPropostePax[],
    messaggi: ClienteMessaggi[],
    notificheEmail: NotificaEmail[],
    richiesta: PreventivoRichiestaRS,
    tags: TagCrmLingua[],
    modalitaPagamento: ModalitaPagamento[],
    risorse: TipoCameraOTA[],
    tariffe: TariffaOTA[],
    workFlows: WorkFlow[],
    workFlowsEseguiti: WorkFlow[],
    supplementiInserimentoRapido: Supplemento[],
    preventivi: Preventivo[],
    timeline: LogPreventivo[],
    sistemazioni: string,
    tipoScontoDefaultDettagliPreventivo: TipoValore,
    oidModalitaPagamentoRichiestaCaparra: number[],
    templateRichiestaCaparra: Template,
    isInviaMailConfermaPagamentoManualeCrm: boolean,
    giorniScadenzaCaparraPreventivo: number
  }
}

export class GetPreventivoRSCameraPropostePaxBambini {
  eta: number;
  quantita: number;
}

export class GetPreventivoRSCameraPropostePax {
  camera: PreventivoCamere;
  proposte: GetPreventivoRSPropostaDettagli[];
  pax: PreventivoCamerePax[];
  numeroAdulti: number;
  numeroBambini: number;
  etaBambini: string;
  bambini: GetPreventivoRSCameraPropostePaxBambini[];
}

export class GetPreventivoRSPropostaDettagli {
  proposta: PreventivoCamereProposte;
  dettagli: PreventivoCamereProposteDettagli[];
}

export class PreventivoRichiestaRS {
  dal: string;
  al: string;
  notti: number;
  note: string;
  camere: PreventivoRichiestaCameraRS[];
}

export class PreventivoRichiestaCameraRS {
  descrizione: string;
  numeroAdulti: number;
  numeroBambini: number;
  etaBambini: string;
}

export class CreaProposteRQ {
  oidAlbergo: number;
  oidCamera: number;
  dettagli: CreaProposteDettaglioRQ[];

  constructor() {
    this.dettagli = [];
  }
}

export class CreaProposteDettaglioRQ {
  oidTipoCamera: number;
  oidTrattamento: number;

  constructor(oidTipoCamera: number, oidTrattamento: number) {
    this.oidTipoCamera = oidTipoCamera;
    this.oidTrattamento = oidTrattamento;
  }
}

export class CreaRichiestaRQ {
  richiesta: Richiesta;
  isInviaEmail: boolean;
  isInviaClienteWelcome: boolean;
  portaliXAlbergo: PortaleXAlbergo[];
}

export class CreaRichiestaRS extends WebApiResponse {
  data: { oidRichiesta: number };
}

export class CreaPreventivoRQ {
  oidRichiesta: number;
  oidUtente: number;
  oidCodicePromozione: number;
  opzioni: OpzioniCamera[];
}

export class CreaPreventivoRS extends WebApiResponse {
  data: { oidPreventivo: number };
}

export class GetPayMailRQ {
  uid: string;
  isMobile: boolean;
}

export class AlbergoPayMail {
  oid: number;
  nome: string;
  isRecaptchaAttiva: boolean;
  isVisualizzaBottoniSocialLoginStep2: boolean;
}

export class PortalePayMail {
  oid: number;
  nome: string;
  nomeStruttura: string;
  oidUbicazioneIstat: number;
  urlImmagineSfondo: string;
  urlImmagineLogo: string;
  urlIFrameGoogleMap: string;
  email: string;
  telefono: string;
  indirizzo: string;
  cap: string;
  citta: string;
  provincia: string;
  isVisualizzaCondizioniPrenotazioneStep2: boolean;
  isAccettaContrattoPrenotazioneStep2: boolean;
  isVerificaCartaCredito: boolean;
  isVisualizzaCRO: boolean;
}

export class ClienteTransazionePayMail {
  nome: string;
  cognome: string;
  email: string;
  cellulare: string;
  privacy: boolean;
  newsletter: boolean;
}

export class PrenotazioneTransazionePayMail {
  codice: string;
  cliente: string;
  data: string;
  arrivo: string;
  partenza: string;
  numeroAdulti: number;
  numeroBambini: number;
  notti: number;
}

export class TransazionePayMail {
  oid: number;
  importo: number;
  note: string;
  lingua: string;
  isPagamentoEffettuato: boolean;
  cliente: ClienteTransazionePayMail;
  prenotazione: PrenotazioneTransazionePayMail;
}

export class MessaggioPayMail {
  oid: number;
  mittente: MittenteMessaggio;
  data: string;
  messaggio: string;
  parametri: string;
}

export class GetPayMailRS extends WebApiResponse {
  data: {
    transazione: TransazionePayMail,
    albergo: AlbergoPayMail,
    portale: PortalePayMail,
    modalitaPagamento: PaymentMethod[],
    messaggi: MessaggioPayMail[],
    condizioniPrenotazione: string,
    condizioniContratto: string,
    traduzioni: string
  };
}

export class GetMyPageRQ {
  uid: string;
  isMobile: boolean;
  isHotel: boolean;
}

export class GetMyPageRS extends WebApiResponse {
  data: {
    preventivo: MyPagePreventivoRS,
    camere: MyPageCameraRS[],
    contenuti: MyPageContenutoRS[],
    articoli: MyPageArticoloRS[],
    recensioni: MyPageRecensioneRS[],
    albergo: MyPageAlbergoRS,
    portale: MyPagePortaleRS,
    richiesta: MyPageRichiestaRS,
    messaggi: MyPageMessaggioRS[],
    prenotazione: MyPagePrenotazioneRS,
    condizioniPrenotazione: string,
    condizioniContratto: string,
    traduzioni: string,
    bulletPoints: string[],
    isPrenotabile: boolean,
    modalitaPagamento: PaymentMethod[],
    numeroVoucher: number,
    numeroMessaggiNonLetti: number,
    causaliOperazione: CausaleOperazione[]
  };
}

export class MyPageAlbergoRS {
  oid: number;
  nome: string;
  codice: number;
  isRecaptchaAttiva: boolean;
  isVisualizzaBottoniSocialLoginStep2: boolean;
}

export class MyPagePortaleRS {
  oid: number;
  nome: string;
  nomeStruttura: string;
  oidUbicazioneIstat: number;
  descrizione: string;
  url: string;
  urlImmagineSfondo: string;
  urlImmagineLogo: string;
  urlIFrameGoogleMap: string;
  email: string;
  telefono: string;
  telefonoWhatsApp: string;
  indirizzo: string;
  cap: string;
  citta: string;
  provincia: string;
  googleGTM: string;
  googleUA: string;
  isVisualizzaCondizioniPrenotazioneStep2: boolean;
  isAccettaContrattoPrenotazioneStep2: boolean;
  facebookPageId: string;
  isVerificaCartaCredito: boolean;
  isVisualizzaCRO: boolean;
  versioneMyPage: VersioneMyPage;
  isVisualizzaDettaglioGiornaliero: boolean;
  isVisualizzaProposteEspanse: boolean;
  templateStampaOid: number;
  isCellulareObbligatorio: boolean;
  isSistemazioneObbligatoria: boolean;
  isNazioneObbligatoria: boolean;
  isRichiediInformazioniOspiti: boolean;
  isVisualizzaDescrizionePoliticaCancellazione: boolean;
  isVisualizzaDescrizioneDettagliataTariffa: boolean;
  isVisualizzaRiepilogoPagamentoMyPage: boolean;
  isVisualizzaInformazioniPropostaMyPage: boolean;
  orarioDiArrivoMinimo: string;
  orarioDiArrivoMassimo: string;
  isNascondiChat: boolean;
  isVisualizzaRifiutaOfferta: boolean;
  urlFacebook: string;
  urlInstagram: string;
}

export class MyPagePreventivoRS {
  oid: number;
  oidTagCrm: number;
  nomeTagCrm: string;
  codicePreventivo: string;
  lingua: string;
  arrivo: string;
  cliente: MyPageClienteRS;
  testoIniziale: string;
  testoIniziale2: string;
  testoUpSelling: string;
  testoPrimaProposte: string;
  testoDopoProposte: string;
  testoFinale: string;
  noteCliente: string;
  statoPreventivo: StatoPreventivo;
  dataScadenza: string;
  dataScadenzaAccontoCaparra: string;
  caparra: number;
  isCaparraPercentuale: boolean;
  urlHeaderMyPage: string;
  immaginiTagCrm: TagCrmImmagini[];
  urlImmagineSfondo: string;
  isVisualizzaContenutiSeparati: boolean;
  isVisualizzaRichiesta: boolean;
  isVisualizzaPeriodoProposte: boolean;
  coloreMyPage: string;
  coloreSecondarioMyPage: string;
  dataPreventivo: string;
  modalitaPagamento: ModalitaPagamento;
  dataConfermaPagamento: string;
  totale: number;
  isAccettaConPagamentoImmediato: boolean;
  isEliminato: boolean;
}

export class MyPageClienteRS {
  oid: number;
  nome: string;
  cognome: string;
  email: string;
  password: string;
  cellulare: string;
  nazione: Nazione;
  privacy: boolean;
  newsletter: boolean;
  cortesia: string;
}

export class MyPageMessaggioRS {
  oid: number;
  mittente: MittenteMessaggio;
  data: string;
  messaggio: string;
  parametri: string;
}

export class MyPageArticoloRS {
  oid: number;
  nome: string;
  descrizione: string;
  prezzo: number;
  sconto: number;
  prezzoPieno: number;
  urlImmagine: string;
  quantitaMassima: number;
  tipo: TipoSupplemento;
  tipoApplicazione: TipoApplicazioneSupplemento;
  isApplicaATuttiComponenti: boolean;
  isDisattivaSceltaGiorni: boolean;
}

export class MyPageArticoloGiornoRS {
  data: string;
  prezzo: number;
  tariffa: string;
  selected: boolean;

  constructor(data?: string, prezzo?: number, tariffa?: string) {
    this.data = data;
    this.prezzo = prezzo;
    this.tariffa = tariffa;
  }
}

export class MyPageExtra {
  oid: number;
  nome: string;
  quantita: number;
  giorni: MyPageArticoloGiornoRS[];
  totale: number;
}

export class MyPageRecensioneRS {
  oid: number;
  nome: string;
  url: string;
  titolo: string;
  descrizione: string;
  data: string;
  voto: number;
  fonte: FonteRecensione;
  limiteCaratteri: number;
}

export class MyPageContenutoRS {
  oid: number;
  titolo: string;
  testo: string;
  urlImmagine: string;
  coloreSfondo: string;
  imagePosition: 'left' | 'right';
}

export class MyPageCameraRS {
  oid: number;
  numeroAdulti: number;
  numeroBambini: number;
  etaBambini: string;
  bambini: MyPageBambinoRS[];
  proposte: MyPageProposteXTipoCameraRS[];
}

export class MyPageProposteXTipoCameraRS {
  descrizione: string;
  arrivo: string;
  partenza: string;
  tipoCamera: MyPageTipoCameraRS;
  proposte: MyPagePropostaRS[];
}

export class MyPageBambinoRS {
  oid: number;
  eta: number;
  quantita: number;
}

export class MyPagePropostaRS {
  oid: number;
  oidPreventivo: number;
  codicePreventivo: string;
  descrizione: string;
  arrivo: string;
  partenza: string;
  totale: number;
  sconto: number;
  totaleScontato: number;
  note: string;
  cancellazione: MyPageCancellazioneRS;
  extra: MyPagePropostaExtraRS[];
  tipoCamera: MyPageTipoCameraRS;
  tariffa: MyPageTariffaRS;
  numeroAdulti: number;
  numeroBambini: number;
  bambini: MyPageBambinoRS[];
  isPrenotabile: boolean;
  isPrezziPersona: boolean;
  isHolipayDisponibile: boolean;
  isScalaPayDisponibile: boolean;
  modalitaPagamento: PaymentMethod[];
  tipoScontoProposta: TipoScontoProposta;
  oidSistemazione: number;
  isVisualizzaDettagli: boolean;
}

export class MyPagePropostaExtraRS {
  oid: number;
  totale: number;
  sconto: number;
  totaleScontato: number;
  quantita: number;
  descrizione: string;
  articolo: MyPagePropostaExtraArticoloRS;
}

export class MyPageTipoCameraImmagineRS {
  immagine: string;
  descrizione: string;
}

export class MyPageTipoCameraRS {
  oid: number;
  nome: string;
  descrizione: string;
  descrizioneDettagliata: string;
  descrizioneComponentiXVariazione: string;
  dimensione: string;
  immagini: MyPageTipoCameraImmagineRS[];
  servizi: MyPageServizioRS[];
  sistemazioni: MyPageTipoCameraSistemazioneRS[];
}

export class MyPageTariffaRS {
  oid: number;
  descrizione: string;
  descrizioneDettagliata: string;
  oidPromozione: number;
  nomePromozione: string;
  descrizionePromozione: string;
  descrizioneDettagliataPromozione: string;
  isVisualizzaServiziBooking: boolean;
  totale: number;
  sconto: number;
  totaleScontato: number;
  servizi: MyPageServizioRS[];
  giorni: MyPageArticoloGiornoRS[];
  cancellazione: MyPageCancellazioneRS;
  dataCancellazioneGratuita: string;
  pianoTariffario: string;
}

export class MyPageCancellazioneRS {
  oid: number;
  nome: string;
  descrizione: string;
  isCancellazioneGratuita: boolean;
  isNonRimborsabile: boolean;
  isPagaHotel: boolean;
  isCartaCreditoGaranzia: boolean;
}

export class MyPagePropostaExtraArticoloRS {
  oid: number;
  nome: string;
  descrizione: string;
}

export class MyPageServizioRS {
  oid: number;
  nome: string;
  descrizione: string;
  icona: string;
  immagineIcona: string;
}

export class MyPageTipoCameraSistemazioneRS {
  oid: number;
  nome: string;
  descrizione: string;
  icona: string;
  immagineIcona: string;
}

export class MyPageRichiestaRS {
  oid: number;
  arrivo: string;
  partenza: string;
  camere: MyPageRichiestaCameraRS[];
  noteRichiesta: string;
}

export class MyPageRichiestaCameraRS {
  oid: number;
  numeroAdulti: number;
  numeroBambini: number;
  etaBambini: string;
}

export class MyPagePrenotazioneRS {
  oids: number[];
  arrivo: string;
  partenza: string;
  stato: StatoPrenotazione;
  statoWelcome: StatoPrenotazioneWelcome;
  codice: string;
  urlCheckinOnline: string;
  urlReport: string;
  totale: number;
  modalitaPagamento: ModalitaPagamento;
  nomeModalitaPagamento: string;
}

export class GetPrivacyPortaleRQ {
  oidPortale: number;
  lingua: string;
}

export class PrivacyPortale {
  html: string;
  url: string;
}

export class GetPrivacyPortaleRS extends WebApiResponse {
  data: PrivacyPortale;
}

export class NewsLetterPortale {
  html: string;
  url: string;
}

export class DisponibilitaTipoCamera {
  tipoCameraOid: number;
  disponibili: number;
  oidFascia: number;
  stato: StatoPortaleXAlbergo;
  tipoModificaStatoPortaliCollegati: TipoModificaStatoPortaliCollegati;
  variazionePrezzo: number;
  tipoVariazionePrezzo: TipoValore;
  durataMinimaSoggiorno: number;
  durataMassimaSoggiorno: number;
  prezzoBase: number;

  constructor() {
    this.disponibili = -1;
    this.oidFascia = -1;
    this.stato = null;
    this.variazionePrezzo = 0;
    this.tipoVariazionePrezzo = TipoValore.Euro;
    this.durataMinimaSoggiorno = -1;
    this.durataMassimaSoggiorno = -1;
    this.prezzoBase = -1;
  }
}

export class DisponibilitaTariffa {
  tipoCameraOid: number;
  tariffaOid: number;
  disponibili: number;
  variazioneDisponibili: number;
  prezzo: number;
  prezzoUsoSingola: number;
  variazionePrezzo: number;
  tipoVariazionePrezzo: TipoValore;
  prezzoBase: number;
  durataMinimaSoggiorno: number;
  durataMassimaSoggiorno: number;
  statoCta: StatoCtaCtd;
  statoCtd: StatoCtaCtd;
  oidFascia: number;
  isApplicaPrezzoListino: boolean;
  isSovrascriviPrezziBloccati: boolean;
  isBloccaPrezzo: boolean;
  stato: StatoPortaleXAlbergo;
  isBloccaStato: boolean;
  //isPropagaBloccoStatoPortaliCollegati: boolean;
  isSbloccaStatoPortaleCollegatoMaster: boolean;

  constructor(tipoPortale?: TipoPortale) {
    this.disponibili = -1;
    this.variazioneDisponibili = null;
    this.prezzo = -1;
    this.prezzoUsoSingola = -1;
    this.variazionePrezzo = 0;
    this.tipoVariazionePrezzo = TipoValore.Euro;
    this.prezzoBase = -1;
    this.durataMinimaSoggiorno = -1;
    this.durataMassimaSoggiorno = -1;
    this.statoCta = null;
    this.statoCtd = null;
    this.oidFascia = -1;
    this.isApplicaPrezzoListino = false;
    this.isSovrascriviPrezziBloccati = false;
    this.isBloccaPrezzo = null;
    this.stato = null;
    this.isBloccaStato = null;
    this.isSbloccaStatoPortaleCollegatoMaster = false;
    //this.isPropagaBloccoStatoPortaliCollegati = tipoPortale == TipoPortale.Master ? true : null;
  }
}

export class UpdateAllDisponibilitaRQ {
  dal: string;
  al: string;
  oidPortale: number;
  giorni: DayOfWeeks;
  tipiCamera: DisponibilitaTipoCamera[];
  tariffe: DisponibilitaTariffa[];

  constructor() {
    this.tipiCamera = [];
    this.tariffe = [];
  }
}

export class PrezzoTariffa {
  oidPortale: number;
  nomePortale: string;
  iconaPortale: string;
  tariffaOid: number;
  nomeTariffa: string;
  tipoCameraOid: number;
  disponibili: number;
  variazioneDisponibili: number;
  prezzo: number;
  prezzoUsoSingola: number;
  variazionePrezzo: number;
  tipoVariazionePrezzo: TipoValore;
  fascia: Fascia;
  oidFascia: number;
  isBloccaPrezzo: boolean;
  statoCta: StatoCtaCtd;
  statoCtd: StatoCtaCtd;
  isApplicaPrezzoListino: boolean;
  durataMinimaSoggiorno: number;
  durataMassimaSoggiorno: number;
  stato: StatoPortaleXAlbergo;
  isBloccaStato: boolean;

  constructor() {
    this.disponibili = -1;
    this.variazioneDisponibili = null;
    this.prezzo = -1;
    this.prezzoUsoSingola = -1;
    this.variazionePrezzo = 0;
    this.tipoVariazionePrezzo = TipoValore.Euro;
    this.oidFascia = -1;
    this.isBloccaPrezzo = null;
    this.statoCta = null;
    this.statoCtd = null;
    this.isApplicaPrezzoListino = false;
    this.durataMinimaSoggiorno = -1;
    this.durataMassimaSoggiorno = -1;
    this.stato = null;
    this.isBloccaStato = null;
  }
}

export class UpdatePrezziRQ {
  oidPortale: number;
  dal: string;
  al: string;
  isAggiornaTariffeCollegate: boolean;
  giorni: DayOfWeeks;
  prezzi: PrezzoTariffa[];
}

export class UpdateDisponibilitaRQ {
  oidPortale: number;
  disponibilita: DisponibilitaXPortaleXAlbergo;
  tariffe: PlanningTariffaRS[];
  isUpdateAllTariffe: boolean;
}

export class GetPrenotazioniRQ {
  dal: string;
  al: string
  cognome: string;
}

export class PortaleDms {
  oid: number;
  nome: string;
  nomeStruttura: string;
  urlImmagine: string;
  tipologia: TipologiaAlbergo;
  telefono: string;
  email: string;
  linkSitoWeb: string;
  stelle: StelleAlbergo;
  indirizzo: string;
  cap: string;
  citta: string;
  provincia: string;
  prezzoMinimo: number;
  oidAlbergo: number;
}

export class ImmaginiXPortale {
  portale: PortaleDms;
  immagini: string[];
}

export class GetPortaliViewRS extends WebApiResponse {
  data: {
    servizi: Servizio[],
    articoli: Articolo[],
    supplementi: Supplemento[],
    sistemazioni: Sistemazione[],
    modalitaPagamento: ModalitaPagamento[],
    promozioni: Promozione[],
    componentiXVariazione: ComponenteXVariazione[],
    tipiCamera: TipoCamera[],
    trattamenti: Trattamento[],
    listini: Listino[]
  };
}

export class GetCreaPromozioneViewRS extends WebApiResponse {
  data: {
    portali: PortaleXAlbergo[],
    tipiCamere: TipoCamera[],
    trattamenti: Trattamento[],
    modalitaPagamento: ModalitaPagamento[]
  };
}

export class GetCodiciPromozioneViewRS extends WebApiResponse {
  data: {
    tipiCameraOTA: TipoCameraOTA[],
    tariffeOTA: TariffaOTA[],
    articoli: Articolo[],
    modalitaPagamento: ModalitaPagamento[],
    componentiXVariazione: ComponenteXVariazione[]
  };
}

export class GetPromozioniViewRS extends WebApiResponse {
  data: {
    componentiXVariazione: ComponenteXVariazione[],
    modalitaPagamento: ModalitaPagamento[],
    tipiCamera: TipoCamera[],
    trattamenti: Trattamento[],
    supplementi: Supplemento[]
  };
}

export class GetUpSellingViewRS extends WebApiResponse {
  data: {
    tipiCamera: TipoCamera[],
    trattamenti: Trattamento[],
    articoli: Articolo[]
  };
}

export class GetTagCrmViewRS extends WebApiResponse {
  data: {
    contenuti: Template[],
    articoli: Articolo[]
  };
}

export class GetImpostazioniMySelfViewRS extends WebApiResponse {
  data: {
    contenuti: Template[],
    articoli: Articolo[]
  };
}

export class GetImpostazioniViewRS extends WebApiResponse {
  data: {
    albergo: Albergo,
    codiciPartner: string[]
  };
}

export class GetTipoCameraOTA {
  tipiCameraOTAXLingua: TipoCameraOTAXLingua[];
  immaginiXTipoCameraOTA: ImmagineXTipoCameraOTA[];
}

export class GetTipoCameraOTARS extends WebApiResponse {
  data: GetTipoCameraOTA;
}

export class SetImmaginePortaleRQ {
  oid: number;
  tipoImmagine: TipoImmaginePortale;
  base64: string;
}

export class SetImmagineUbicazioneIstatRQ {
  oid: number;
  tipoImmagine: TipoImmagineUbicazioneIstat;
  base64: string;
}

export class SetImmaginePromozioneRQ {
  oid: number;
  tipoImmagine: TipoImmaginePromozione;
  base64: string;
}

export class SetImmaginePortale {
  url: string;
}

export class SetImmaginePortaleRS extends WebApiResponse {
  data: SetImmaginePortale;
}

export class SetImmagineUbicazioneIstat {
  url: string;
}

export class SetImmagineUbicazioneIstatRS extends WebApiResponse {
  data: SetImmagineUbicazioneIstat;
}

export class SetImmaginePromozione {
  url: string;
}

export class SetImmaginePromozioneRS extends WebApiResponse {
  data: SetImmaginePromozione;
}

export class SetImmagineTagCrmRQ {
  oid: number;
  tipoImmagine: TipoImmagineTagCrm;
  base64: string;
}

export class SetImmagineTagCrmRS extends WebApiResponse {
  data: { url: string };
}

export class SetImmagineVoceAddebitoRQ {
  oid: number;
  base64: string;
}

export class SetImmagineVoceAddebitoRS extends WebApiResponse {
  data: { url: string };
}

export class SetImmagineSupplementoRQ {
  oid: number;
  base64: string;
}

export class SetImmagineSupplementoRS extends WebApiResponse {
  data: { url: string };
}

export class SetImmagineArticoloRQ {
  oid: number;
  base64: string;
}

export class SetImmagineArticoloRS extends WebApiResponse {
  data: { url: string };
}

export class SetImmagineTemplateRQ {
  oid: number;
  base64: string;
}

export class SetImmagineTemplateRS extends WebApiResponse {
  data: { url: string };
}

export class SetImmagineAlbergoMasterRQ {
  oid: number;
  tipoImmagine: TipoImmagineAlbergoMaster;
  base64: string;
}

export class SetImmagineTipoCameraRQ {
  oid: number;
  base64: string;
}

export class SetImmagineEventoRQ {
  oid: number;
  base64: string;
}

export class SetImmagineAlbergoMasterRS extends WebApiResponse {
  data: { url: string };
}

export class SetImmagineUtenteRQ {
  oid: number;
  base64: string;
}

export class SetImmagineUtenteRS extends WebApiResponse {
  data: { url: string };
}

export class SetImmagineTipoCameraRS extends WebApiResponse {
  data: { url: string };
}

export class SetImmagineEventoRS extends WebApiResponse {
  data: { url: string };
}

export class SetImmaginePortaleAdminRQ {
  oid: number;
  tipoImmagine: TipoImmaginePortaleAdmin;
  base64: string;
}

export class SetImmaginePortaleAdminRS extends WebApiResponse {
  data: { url: string };
}

export class SetImmagineServizioRQ {
  oid: number;
  base64: string;
}

export class SetImmagineServizioRS extends WebApiResponse {
  data: { url: string };
}

export class SetImmagineSistemazioneRQ {
  oid: number;
  base64: string;
}

export class SetImmagineSistemazioneRS extends WebApiResponse {
  data: { url: string };
}

export class SetImmagineTutorialRQ {
  oid: number;
  base64: string;
}

export class SetImmagineTutorialRS extends WebApiResponse {
  data: { url: string };
}

export class SetImmaginePaginaMySelfRQ {
  oid: number;
  base64: string;
}

export class SetImmaginePaginaMySelfRS extends WebApiResponse {
  data: { url: string };
}

export class SetImmaginePiattoMySelfRQ {
  oid: number;
  base64: string;
}

export class SetImmaginePiattoMySelfRS extends WebApiResponse {
  data: { url: string };
}

export class DuplicaPropostaRS extends WebApiResponse {
  data: GetPreventivoRSPropostaDettagli;
}

export class DeleteAllProposteRQ {
  oidCamera: number;
}

export class SetTipiCarteCreditoRQ {
  oidAlbergo: number;
  tipiCarteCredito: TipoCartaCreditoXAlbergo[];

  constructor(oidAlbergo: number, tipiCarteCredito: TipoCartaCreditoXAlbergo[]) {
    this.oidAlbergo = oidAlbergo;
    this.tipiCarteCredito = tipiCarteCredito;
  }
}

export class GetPrezzoArticoloRQ {
  arrivo: string;
  partenza: string;
  oidArticolo: number;
  oidListino: number;
  oidTipoCameraOTA: number;
  oidPortale: number;
  oidProposta: number;
  sconto: number;
  isScontoPercentuale: boolean;
}

export class GetPrezzoArticoloRS extends WebApiResponse {
  data: { giorni: BookingSolutionDayRateRS[] };
}

export class BookingSolutionRQ {
  arrivo: string;
  partenza: string;
  codicePromozione: string;
  oidMotivoViaggio: number;
  lingua: string;
  oidAlbergo: number;
  oidPortale: number;
  oidTipoCamera: number;
  oidTrattamento: number;
  oidTipoCameraOTA: number;
  oidPromozione: number;
  oidTariffaOTA: number;
  oidTariffe: number[];
  oidServizi: number[];
  isDayUse: boolean;
  isControllaDisponibili: boolean;
  isVisualizzaCamerePaxNonValide: boolean;
  isMobile: boolean;
  isLog: boolean;
  isBooking: boolean;
  isGoogleHotelsTravel: boolean;
  isTrivago: boolean;
  mealPlanType: MealPlanType;
  bookingSolutionUid: string;
  isV2: boolean;
  camere: BookingSolutionRoomRQ[];

  constructor(adultiDefault?: number) {
    this.camere = [];
    this.camere.push(new BookingSolutionRoomRQ(adultiDefault));
  }
}

export class BookingSolution {
  portale: BookingSolutionPortaleRS;
  promozioni: BookingSolutionHighlightedOfferRS[];
  camere: BookingSolutionRoomRS[];
  tariffePortali: BookingSolutionPortalRS[];
  dateAlternative: BookingSolutionDataAlternativaRS[];
  bannerPromozionali: BookingSolutionBannerRS[];
  mealTypes: MealPlanType[];
  errori: string[];
  oidCodicePromozione: number;
  uid: string;
}

export class BookingSolutionRS extends WebApiResponse {
  data: BookingSolution;
}

export class BookingSolutionsRS extends WebApiResponse {
  data: BookingSolution[];
}

export class BookingSolutionPortaleRS {
  oid: number;
  nome: string;
}

export class BookingSolutionRoomImageRS {
  immagine: string;
  descrizione: string;
}

export class BookingSolutionHighlightedOfferRS {
  camera: BookingSolutionRoomRS;
  tariffa: BookingSolutionRateRS;
}

export class BookingSolutionBannerRS {
  titolo: string;
  testo: string;
}

export class BookingSolutionRoomRS {
  roomId: number;
  paxMin: number;
  paxMax: number;
  enfantMax: number;
  dimensione: string;
  nome: string;
  nomeTipoCamera: string;
  descrizione: string;
  descrizioneDettagliata: string;
  descrizioneComponentiXVariazione: string
  disponibili: number;
  camereWelcomeDisponibiliXTipoCamera: number;
  disponibiliHotel: number;
  isIllimitata: boolean;
  prezzoMinimo: number;
  tipoCameraId: number;
  tipoCameraIdHotel: number;
  roomUpgradeId: number;
  roomUpgrade: string;
  ubicazioneIstat: string;
  oidHotelUbicazioneIstat: number;
  maggiorazionePrezzo: number;
  immagini: BookingSolutionRoomImageRS[];
  tariffe: BookingSolutionRateRS[];
  servizi: BookingSolutionServiceRS[];
  sistemazioni: BookingSolutionAccomodationRS[];
}

export class BookingSolutionRateRS {
  rateId: number;
  descrizione: string;
  descrizioneDettagliata: string;
  nomePromozione: string;
  descrizionePromozione: string;
  descrizioneDettagliataPromozione: string;
  urlImmaginePromozione: string
  disponibili: number;
  disponibiliHotel: number;
  mealPlanType: MealPlanType;
  prezzo: number;
  sconto: number;
  scontoPercentuale: number;
  prezzoScontato: number;
  prezzoSenzaExtra: number;
  prezzoScontatoSenzaExtra: number;
  isOffertaSegreta: boolean;
  isVisualizzaServiziBooking: boolean;
  roomIndices: number[];
  pax: BookingSolutionPaxRateRS[];
  numeroAdulti: number;
  numeroBambini: number;
  giorni: BookingSolutionDayRateRS[];
  disponibilita: BookingSolutionAvailabilityRateRS[];
  cancellazione: BookingSolutionCancellationRS;
  modalitaPagamento: PaymentMethod[];
  servizi: BookingSolutionServiceRS[];
  extras: BookingSolutionRateExtraRS[];
  isColazione: boolean;
  isPranzo: boolean;
  isCena: boolean;
  isPrenotabile: boolean;
  testoNonPrenotabile: string;
  valoreNonPrenotabile: number;
  testoTradottoNonPrenotabile: string;
  dataCancellazioneGratuita: string;
  pianoTariffario: string;
  oidPromozione: number;
  ordinamento: number;
  isHolipayDisponibile: boolean;
  isScalaPayDisponibile: boolean;
  codicePromozione: string;
  supplementi: BookingSolutionExtrasXTypeRS[];
  group: string;
  isBestPrice: boolean;
}

export class RispostaListinoXPersona {
  data: string;
  guestId: number;
  guestIndex: number;
  indiceComponente: number;
  eta: number;
  prezzo: number;
  prezzoTotale: number;
}

export class BookingSolutionPaxRateRS {
  guestId: number;
  tipo: TipoComponentePrenotazione;
  eta: number;
  indiceComponente: number;
  isReferenteCamera: boolean;
  prezziPersona: RispostaListinoXPersona[];
}

export class BookingSolutionAvailabilityRateRS {
  oid: number;
  data: string;
  disponibili: number;
  disponibiliHotel: number;
  prezzo: number;
  statoCta: StatoCtaCtd;
  statoCtd: StatoCtaCtd;
  statoPortaleXAlbergo: StatoPortaleXAlbergo;
}

export class BookingSolutionDayRateRS {
  data: string;
  prezzo: number;
  prezzoScontato: number;
  info: string;
  selected: boolean;
  quantita: number;
  quantitaDisponibile: number

  constructor(data?: string, prezzo?: number, prezzoScontato?: number) {
    if (data != null && prezzo != null && prezzoScontato != null) {
      this.data = data;
      this.prezzo = prezzo;
      this.prezzoScontato = prezzoScontato;
      this.selected = true;
    }
  }
}

export class BookingSolutionCancellationRS {
  cancellationId: number;
  nome: string;
  descrizione: string;
  isCancellazioneGratuita: boolean;
  isNonRimborsabile: boolean;
  isPagaHotel: boolean;
  isCartaCreditoGaranzia: boolean;
}

export class BookingSolutionAccomodationRS {
  accomodationId: number;
  nome: string;
  descrizione: string;
  icona: string;
  immagineIcona: string;
}

export class BookingSolutionServiceRS {
  serviceId: number;
  nome: string;
  descrizione: string;
  icona: string;
  immagineIcona: string;
}

export class BookingSolutionExtrasXTypeRS {
  voceAddebito: BookingDebitEntryConfigRS;
  extras: BookingSolutionExtraRS[];
}

export class BookingSolutionExtraRS {
  extraId: number;
  oidWelcome: number;
  nome: string;
  descrizione: string;
  tipo: TipoSupplemento;
  urlImmagine: string;
  quantitaMassima: number;
  quantitaMassimaGiornaliera: number;
  isControllaSupplementoWelcome: boolean;
  prezzo: number;
  sconto: number;
  prezzoPieno: number;
  prezzoScontato: number;
  isExtraAutomatico: boolean;
  giorni: BookingSolutionDayRateRS[];
  totale: number;
  isVisualizzaGiorniWeb: boolean;
  modalitaCalcoloPrezzo: ModalitaCalcoloPrezzo;
  tipoDisponibilitaArticolo: TipoDisponibilitaArticolo;
  indexComponente: number;
  isPerPersona: boolean;
  tipoProduzione: TipoProduzioneXComponenteXPrenotazione;
  isExtraIncluso: boolean;
  isApplicaATuttiComponenti: boolean;
  tipoApplicazione: TipoApplicazioneSupplemento;
  quantita: number;

  constructor() {
    this.isExtraAutomatico = false;
  }
}

export class BookingSolutionRateExtraRS {
  extraId: number;
  nome: string;
  descrizione: string;
  urlImmagine: string;
  quantita: number;
  prezzo: number;
  modalitaCalcoloPrezzo: ModalitaCalcoloPrezzo;
  giorni: BookingSolutionDayRateRS[];
  tipoDisponibilitaArticolo: TipoDisponibilitaArticolo;
  isPerPersona: boolean;
  indexComponente: number;
  tipoProduzione: TipoProduzioneXComponenteXPrenotazione;
  isExtraIncluso: boolean;
}

export class BookingSolutionOfferRS {
  offerId: number;
  nome: string;
  descrizione: string;
  descrizioneDettagliata: string;
  codice: string;
  urlImmagineEvidenza: string;
  prezzo: number;
  sconto: number;
  scontoPercentuale: number;
  prezzoScontato: number;
  cancellazione: BookingSolutionCancellationRS;
  prenotabileDal: string;
  prenotabileAl: string;
  validaDal: string;
  validaAl: string;
  validaDalDate: string;
  validaAlDate: string;
  arrivoDefault: string;
  nottiDefault: number;
}

export class BookingSolutionPortalRS {
  nome: string;
  prezzo: number;
}

export class BookingSolutionDataAlternativaRS {
  arrivo: string;
  partenza: string
  prezzoMinimo: number;
}

export class BookingSolutionRoomRQ {
  pax: BookingSolutionPaxRQ[];

  constructor(adultiDefault?: number) {
    this.pax = [];
    this.pax.push(new BookingSolutionPaxRQ(adultiDefault));
  }

  getNumeroPax(): number {
    if (this.pax != null) {
      let n = 0;

      for (let pax of this.pax) {
        n += pax.quantita;
      }

      return n;
    }

    return 0;
  }

  get numeroAdulti(): number {
    if (this.pax != null) {
      let n = 0;

      for (let pax of this.pax.filter(x => x.eta < 0)) {
        n += pax.quantita;
      }

      return n;
    }

    return 0;
  }

  get numeroBambini(): number {
    if (this.pax != null) {
      let n = 0;

      for (let pax of this.pax.filter(x => x.eta >= 0)) {
        n += pax.quantita;
      }

      return n;
    }

    return 0;
  }
}

export class BookingSolutionPaxRQ {
  oid: number;
  eta: number;
  quantita: number;

  constructor(adultiDefault?: number) {
    this.eta = -1;

    if (adultiDefault > 0) {
      this.quantita = adultiDefault;
    } else {
      this.quantita = 1;
    }
  }
}

export class GetDisponibilitaRQ {
  dal: string;
  al: string;
  oidPortale: number;
  dayUse: boolean;
}

export class GetDisponibilita {
  data: string;
  cssClass: string;
  durataMinimaSoggiorno: number;
  durataMassimaSoggiorno: number;
  prezzoMin: number;
}

export class GetDisponibilitaRS extends WebApiResponse {
  data: { disponibilita: GetDisponibilita[] };
}

export class BookingSolutionConfigRS extends WebApiResponse {
  data: BookingConfig;
}

export class BookingConfig {
  albergo: BookingConfigAlbergoRS;
  portale: BookingConfigPortaleRS;
  immagini: string[];
  descrizione: string;
  descrizioneBookingDayUse: string;
  descrizioneBookingExtra: string;
  descrizioneFinale: string;
  condizioniContratto: string;
  traduzioni: string;
  numeroUltimePrenotazioni: number;
  numeroCodiciPromozionali: number;
  numeroVoucher: number;
  descrizionePopup: string;
  condizioniPrenotazione: string;
  servizi: BookingServiceConfigRS[];
  recensioni: BookingReviewConfigRS[];
  promozioni: BookingSolutionOfferRS[];
  riduzioni: BookingReductionConfigRS[];
  modalitaPagamento: PaymentMethod[];
  bulletPoints: string[];
  lingue: Lingua[];
  lingua: Lingua;
  cliente: Cliente;
  arrivo: string;
  partenza: string;
  motiviViaggio: BookingTravelReasonConfigRS[];
  mealTypes: MealPlanType[];
  bannerPromozionali: BookingSolutionBannerRS[];
  createPrenotazioneRQ: CreatePrenotazioneRQ;
}

export class BookingConfigAlbergoRS {
  oid: number;
  nome: string;
  codice: number;
  isRecaptchaAttiva: boolean;
  isVisualizzaBottoniSocialLoginStep2: boolean;
  isVisualizzaTipoCameraTariffaCalcolaRetta: boolean;
  isVisualizzaFiltroServiziCalcolaRetta: boolean;
  isVisualizzaSelezioneClientePreventivoCalcolaRetta: boolean;
  isAttivaSelezionaCameraPreventivo: boolean;
}

export class BookingConfigPortaleRS {
  oid: number;
  nome: string;
  nomeStruttura: string;
  oidUbicazioneIstat: number;
  isVisualizzaPrezzoCalendario: boolean;
  isVisualizzaDisponibilitaCalendario: boolean;
  isVisualizzaTotaleSoggiornoSeNonDisponibile: boolean;
  isVisualizzaLogo: boolean;
  urlImmagineLogo: string;
  telefono: string;
  telefonoWhatsapp: string;
  email: string;
  urlIFrameGoogleMap: string;
  linkSitoWeb: string;
  isFiltroTariffaAttivo: boolean;
  isEtaRiduzioniAttiva: boolean;
  googleGTM: string;
  googleUA: string;
  facebookPageId: string;
  facebookPixel: string;
  stelle: StelleAlbergo;
  urlImmagineSfondo: string;
  indirizzo: string;
  cap: string;
  citta: string;
  provincia: string;
  tipoVisualizzazioneGrigliaDisponibilita: TipoVisualizzazioneGrigliaDisponibilita;
  isVisualizzaCondizioniPrenotazioneStep2: boolean;
  isAccettaContrattoPrenotazioneStep2: boolean;
  isVisualizzaCalendarioMobile: boolean;
  numeroPersoneCollegate: number;
  isRichiediDisponibilitaStep1Visualizzata: boolean;
  isPaxStep1Visualizzate: boolean;
  isPaxRichiestaStep1Visualizzate: boolean;
  isCamereLibereStep1Visualizzate: boolean;
  adultiDefault: number;
  numeroMassimoAdulti: number;
  numeroMassimoBambini: number;
  etaMinimaBambini: number;
  etaMassimaBambini: number;
  camerePrenotabili: number;
  camerePrenotabiliCrm: number;
  isVerificaCartaCredito: boolean;
  isVisualizzaCRO: boolean;
  isVisualizzaDettaglioGiornaliero: boolean;
  isAttivaSpedizioneBookingExtra: boolean;
  isVisualizzaPrezzoMinimo: boolean;
  tipoVisualizzazioneBanner: TipoVisualizzazioneBanner;
  timeoutChiusuraBanner: number;
  isOraArrivoObbligatoria: boolean;
  isRichiesteObbligatorie: boolean;
  isSistemazioneObbligatoria: boolean;
  isNazioneObbligatoria: boolean;
  isCellulareObbligatorio: boolean;
  isRichiediInformazioniOspiti: boolean;
  isVisualizzaDescrizionePoliticaCancellazione: boolean;
  isVisualizzaDescrizioneDettagliataTariffa: boolean;
  isVisualizzaTariffeEspanse: boolean;
  valuta: string;
  orarioDiArrivoMinimo: string;
  orarioDiArrivoMassimo: string;
  isDisattivaRichiestaBambini: boolean;
  dataInizioGestione: string
  isControllaDurateSoggiornoSulGiornoDiArrivo: boolean;
  isVisualizzaBannerCookies: boolean;
  isRichiediDatiFatturazione: boolean;
  isDatiFatturazioneObbligatori: boolean;
  isProponiNottiCalendario: boolean;
  newsLetter: NewsLetterPortale;
  isVisualizzaStep: boolean;
  testoNoDisponibilita: string;
  isVisualizzaLinkBookingExtra: boolean;
  isVisualizzaBottoniFiltroVoceAddebitoBookingExtra: boolean;
  isAttivaBuonoRegaloBookingExtra: boolean;
  urlFavicon: string;
  isVisualizzaCamereCompatte: boolean;
  isVisualizzaPasti: boolean;
  isVisualizzaPopupSalvataggioRicerca: boolean;
  isPro: boolean;
}

export class BookingDebitEntryConfigRS {
  debitEntryId: number;
  nome: string;
  isVisualizzaEspanso: boolean;
}

export class BookingReductionConfigRS {
  reductionId: number;
  nome: string;
}

export class BookingServiceConfigRS {
  nome: string;
  descrizione: string;
}

export class BookingReviewConfigRS {
  oid: number;
  nome: string;
  url: string;
  titolo: string;
  descrizione: string;
  data: string;
  voto: number;
  fonte: FonteRecensione;
  limiteCaratteri: number;
}

export class BookingTravelReasonConfigRS {
  oid: number;
  nome: string;
  descrizione: string;
}

export class BookingSolutionConfigRQ {
  lingua: string;
  oidPortale: number;
  oidAlbergo: number;
  isDayUse: boolean;
  isMobile: boolean;
  isBooking: boolean;
  isGoogleHotelsTravel: boolean;
  isTrivago: boolean;
  extraSelect: boolean;
  uid: string;
  bookingSolutionUid: string;
}

export class SliderImage {
  image: string;
  thumbImage: string;
}

export class TariffaTipoCameraBooking {
  tipoCamera: BookingSolutionRoomRS;
  tariffa: BookingSolutionRateRS;
  quantity: number;
}

export class TariffaQuantityBooking {
  tariffa: BookingSolutionRateRS;
  quantity: number;
}

export class TariffaQuantitySelectBooking {
  tariffaOid: number;
  oidPromozione: number;
  numeroAdulti: number;
  numeroBambini: number;
  disabled: boolean;
  quantity: number;
  viewValue: string;
}

export class PrenotazioneDetailsBooking {
  oid: number;
  nome: string;
  cognome: string;
  email: string;
  cellulare: string;
  nazione: Nazione;
  richieste: string;
  codiceFiscale: string;
  partitaIva: string;
  indirizzo: string;
  cap: string;
  citta: string;
  provincia: string;
  codiceDestinatario: string;
}

export class ExtrasXTypeBooking {
  voceAddebito: BookingDebitEntryConfigRS;
  extras: ExtraBooking[];

  constructor() {
    this.extras = [];
  }
}

export class ExtraBooking {
  voceAddebito: BookingDebitEntryConfigRS;
  extra: BookingSolutionExtraRS;
  quantita: number;
  isApplicaTuttiGiorniCamere: boolean;
}

export class DisponibilitaCamereRS {
  camera: DisponibilitaCamereRoomRS;
  disponibilita: GetDisponibilita[];
}

export class GetCalendarioDisponibilitaCamereRS extends WebApiResponse {
  data: { disponibilita: DisponibilitaCamereRS[] };
}

export class GetCalendarioDisponibilitaCamereRQ {
  dal: string;
  al: string;
  oidPortale: number;
  dayUse: boolean;
  lingua: string;
}

export class DisponibilitaCamereRoomRS {
  nome: string;
  paxMin: number;
  paxMax: number;
  letti: number;
}

export class PrenotazioneDetailsRoom {
  cliente: PrenotazioneDetailsBooking;
  tipoCamera: BookingSolutionRoomRS;
  tariffa: BookingSolutionRateRS;
  extras: ExtraBooking[];
  selectedExtras: ExtraBooking[];
  pax: BookingSolutionRoomRQ;
  oidSistemazione: number;
  totaleSenzaExtra: number;
  totaleScontatoSenzaExtra: number;
}

export class CreatePrenotazioneRQ {
  arrivo: string;
  partenza: string;
  oraArrivo: string;
  cliente: PrenotazioneDetailsBooking;
  camere: PrenotazioneDetailsRoom[];
  pagamento: PaymentModel;
  oidPortale: number;
  lingua: string;
  oidCodicePromozione: number;
  oidMotivoViaggio: number;
  oidVoucher: number;
  isGoogleHotelsTravel: boolean;
  isTrivago: boolean;
  isCalcolaRetta: boolean;
  isInviaEmail: boolean;
  oidTemplate: number;
  bookingSolutionUid: string;
}

export class CreatePrenotazioneExtraRQ {
  cliente: Cliente;
  extra: ExtraBooking[];
  pagamento: PaymentModel;
  oidPortale: number;
  oidCodicePromozionale: number;
  lingua: string;
  indirizzo: string;
  citta: string;
  cap: string;
  nazione: string;
  provincia: string;
  totale: number;
  uid: string;
  richieste: string;
  messaggioBuonoRegalo: string;
  nomeRiceventeBuonoRegalo: string;
  emailRiceventeBuonoRegalo: string;
  dataAppuntamento: string;
  oraAppuntamento: string;
  voucher: string;
  importoVoucher: number;
}

export class CreateBuonoScontoRQ {
  cliente: Cliente;
  extra: ExtraBooking[];
  pagamento: PaymentModel;
  oidPortale: number;
  lingua: string;
  totale: number;
  messaggioBuonoRegalo: string;
  nomeRiceventeBuonoRegalo: string;
  emailRiceventeBuonoRegalo: string;
}

export class PrenotazioneAccessoriRQ {
  risorsa: Risorsa;
  tariffa: TariffaXQuadroGraficoWelcome;
  supplementi: SupplementoXTariffaXQuadroGraficoWelcome[];
  prezzo: number;
}

export class CreatePrenotazioneAccessoriRQ {
  cliente: Cliente;
  pagamento: PaymentModel;
  oidPortale: number;
  lingua: string;
  totale: number;
  richieste: string;
  uidPrenotazione: string;
  dal: string;
  al: string;
  prenotazioni: PrenotazioneAccessoriRQ[];
}

export class CreatePrenotazioneRS extends WebApiResponse {
  data: {
    prenotazioni: Prenotazione[],
    transazione: Transazione,
    bookingIdGA: number,
    bookingCode: string
  };
}

export class GetPrezzoMinimoRQ {
  arrivo: string;
  partenza: string;
  oidMotivoViaggio: number;
  oidPortale: number;
  isDayUse: boolean;
  isGetPrezziPortali: boolean;
  camere: BookingSolutionRoomRQ[];

  constructor(adultiDefault?: number) {
    this.camere = [];
    this.camere.push(new BookingSolutionRoomRQ(adultiDefault));
  }
}

export class GetPrezzoMinimoBookingV2RS extends WebApiResponse {
  data: {
    prezzoMinimo: number,
    prezziMinimiPortali: BookingSolutionPortalRS[]
  };
}

export class PaymentModel {
  modalitaPagamento: PaymentMethod;
  codiceRiferimentoOperazione: string;
  tipoCarta: TipoCartaCreditoXAlbergo;
  numeroCarta: string;
  codiceSicurezza: string;
  scadenzaCartaMese: number;
  scadenzaCartaAnno: number;
  titolareCarta: string;
  oidTransazione: number;
  privacy: boolean;
  newsletter: boolean;
  isPrenotazioneCreata: boolean;
  codicePrenotazione: string;

  constructor() {
    this.modalitaPagamento = new PaymentMethod(-1);
    this.privacy = false;
    this.newsletter = false;
  }
}

export class PaymentCustomer {
  name: string;
  surname: string;
  email: string;
  tokenCC: string;
  telephone: string;
  language: string;
  privacy: boolean;
  newsletter: boolean;
  nazione: string;
  codiceFiscale: string;
  partitaIva: string;
  indirizzo: string;
  citta: string;
  provincia: string;
  CAP: string;
  codiceDestinatario: string;
}

export class PaymentTransaction {
  id: number;
  description: string;
  amount: number;
  currency: string;
  accountingType: 'I' | 'D';
}

export class PaymentCreditCard {
  id: string;
  holder: string;
  number: string;
  exp_month: string;
  exp_year: string;
  cvv: string;
}

export class PaymentReservationRoomChild {
  oid: number;
  age: number;
  quantity: number;
}

export class PaymentReservationRoomDay {
  date: string;
  price: number;
  discountedPrice: number;
  quantity: number;
}

export class PaymentReservationRoomExtra {
  oid: number;
  name: string;
  quantity: number;
  days: PaymentReservationRoomDay[];
  productionType: TipoProduzioneXComponenteXPrenotazione;
  guestIndex: number;
  type: TipoSupplemento;
  priceCalculationModality: ModalitaCalcoloPrezzo;
  isIncluded: boolean;
}

export class PaymentReservationRoom {
  roomId: number;
  rateId: number;
  promotionId: number;
  cancellationId: number;
  room: string;
  rate: string;
  promotion: string;
  cancellation: string;
  adultsNumber: number;
  childrenNumber: number;
  days: PaymentReservationRoomDay[];
  children: PaymentReservationRoomChild[];
  extras: PaymentReservationRoomExtra[];
  total: number;
  discountedTotal: number;
  discount: number;
  proposalId: number;
  roomUpgradeId: number;
  roomUpgrade: string;
  roomAccomodationId: number;
  ratePlan: string;
}

export class PaymentReservation {
  code: string;
  preventive_id: number;
  preventive_code: string;
  structure_code: string;
  date: string;
  arrival: string;
  departure: string;
  nights: string;
  reservation_type: string;
  notes: string;
  promotionCodeId: number;
  travelReasonId: number;
  rooms: PaymentReservationRoom[];
  deposit: number;
  bookingSolutionUid: string;
  voucherId: number;
  isGoogleHotelsTravel: boolean;
  isTrivago: boolean;
}

export class PaymentConfig {
  api_key: string;
  key: string;
  id: string;
  locale: string;
  success_url: string;
  error_url: string;
  brand_name: string;
  requires_capture: boolean;
  private_key: string;
  public_certificate: string;
}

export class PaymentRQParameters {
  oidAlbergo: number;
  oidPortale: number;
  oidModalitaPagamento: number;
  cliente: Cliente;
  lingua: string;
  dataPrenotazione: string;
  arrivo: string;
  partenza: string;
  camere: (PrenotazioneDetailsRoom | MyPagePropostaRS)[];
  extras: MyPageExtra[][];
  note: string;
  oidCodicePromozione: number;
  oidMotivoViaggio: number;
  caparra: number;
  privacy: boolean;
  newsletter: boolean;
  bookingSolutionUid: string;
  oidVoucher: number;
  isGoogleHotelsTravel: boolean;
  isTrivago: boolean;
}

export class PaymentRQ {
  oidAlbergo: number;
  oidPortale: number;
  oidModalitaPagamento: number;
  type: string;
  operation: string;
  transaction_id: string;
  transaction_token: string;
  token: string;
  version: number;
  test: boolean;
  customer: PaymentCustomer;
  transaction: PaymentTransaction;
  credit_card: PaymentCreditCard;
  reservation: PaymentReservation;
  config: PaymentConfig;
  url: string;

  constructor(type: string, operation: string, parameters: PaymentRQParameters) {
    this.transaction = new PaymentTransaction();
    this.credit_card = new PaymentCreditCard();
    this.config = new PaymentConfig();
    this.url = window.location.href;
    this.type = type;
    this.operation = operation;
    this.oidAlbergo = parameters.oidAlbergo;
    this.oidPortale = parameters.oidPortale;
    this.oidModalitaPagamento = parameters.oidModalitaPagamento;

    this.customer = new PaymentCustomer();

    if (parameters.cliente != null) {
      this.customer.name = parameters.cliente.nome;
      this.customer.surname = parameters.cliente.cognome;
      this.customer.email = parameters.cliente.email;
      this.customer.tokenCC = parameters.cliente.tokenCC;
      this.customer.telephone = parameters.cliente.cellulare;
      this.customer.privacy = parameters.privacy;
      this.customer.newsletter = parameters.newsletter;
      this.customer.language = parameters.lingua;
      this.customer.nazione = parameters.cliente.nazione;
      this.customer.codiceFiscale = parameters.cliente.codiceFiscale
      this.customer.partitaIva = parameters.cliente.partitaIva;
      this.customer.indirizzo = parameters.cliente.indirizzo
      this.customer.citta = parameters.cliente.citta;
      this.customer.provincia = parameters.cliente.provincia;
      this.customer.CAP = parameters.cliente.CAP;
      this.customer.codiceDestinatario = parameters.cliente.codiceDestinatario;
    }

    this.reservation = new PaymentReservation();

    if (!!parameters.dataPrenotazione) {
      this.reservation.date = moment(parameters.dataPrenotazione).format('YYYY-MM-DD');
    }

    if (!!parameters.arrivo) {
      this.reservation.arrival = moment(parameters.arrivo).format('YYYY-MM-DD');
    }

    if (!!parameters.partenza) {
      this.reservation.departure = moment(parameters.partenza).format('YYYY-MM-DD');
    }

    if (!!parameters.arrivo && !!parameters.partenza) {
      this.reservation.nights = Math.max(moment(parameters.partenza).startOf('day').diff(moment(parameters.arrivo).startOf('day'), 'days'), 1).toString();
    }

    this.reservation.deposit = parameters.caparra;

    this.reservation.bookingSolutionUid = parameters.bookingSolutionUid;

    let preventive_code: string;
    let preventive_id: number;

    if (parameters.camere != null && parameters.camere.length > 0) {
      let roomIndex: number = 0;

      this.reservation.rooms = [];

      for (let camera of parameters.camere) {
        let room: PaymentReservationRoom = new PaymentReservationRoom();

        if (camera.tipoCamera != null) {
          room.room = camera.tipoCamera.nome;
          room.roomId = camera.tipoCamera['oid'] != null ? camera.tipoCamera['oid'] : camera.tipoCamera['roomId'];
        } else {
          room.room = '';
          room.roomId = -1;
        }

        room.roomAccomodationId = camera.oidSistemazione;

        if (camera.tariffa != null) {
          room.rate = camera.tariffa.descrizione;
          room.rateId = camera.tariffa['oid'] != null ? camera.tariffa['oid'] : camera.tariffa['rateId'];
          room.promotion = camera.tariffa.nomePromozione;
          room.promotionId = camera.tariffa.oidPromozione;

          if (camera.tariffa.cancellazione != null) {
            room.cancellation = camera.tariffa.cancellazione.nome;
            room.cancellationId = camera.tariffa.cancellazione['oid'] != null ? camera.tariffa.cancellazione['oid'] : camera.tariffa.cancellazione['cancellationId'];
          } else {
            room.cancellation = '';
            room.cancellationId = -1;
          }

          if (camera.tariffa.giorni != null && camera.tariffa.giorni.length > 0) {
            room.days = [];

            for (let g of camera.tariffa.giorni) {
              let giorno = new PaymentReservationRoomDay();
              giorno.date = g.data;
              giorno.price = g.prezzo;
              giorno.discountedPrice = g['prezzoScontato'];
              room.days.push(giorno);
            }
          }

          room.ratePlan = camera.tariffa.pianoTariffario;
        } else {
          room.rate = '';
          room.rateId = -1;
          room.promotion = '';
          room.promotionId = -1;
          room.cancellation = '';
          room.cancellationId = -1;
          room.ratePlan = '';
        }

        room.proposalId = camera['oid'];

        if (camera['roomUpgradeId'] > 0) {
          room.roomUpgradeId = camera['roomUpgradeId'];
          room.roomUpgrade = camera['roomUpgrade'];
        } else {
          room.roomUpgradeId = -1;
          room.roomUpgrade = '';
        }

        let bambini: any[];

        //caso PrenotazioneDetailsRoom
        if (camera['pax'] != null) {
          room.adultsNumber = camera['pax'].numeroAdulti;
          room.childrenNumber = camera['pax'].numeroBambini;

          if (camera['pax'].pax != null && camera['pax'].pax.length > 0) {
            bambini = camera['pax'].pax.filter(x => x.eta >= 0);
          }

          room.total = camera.tariffa['prezzo'];
          room.discountedTotal = camera.tariffa['prezzoScontato'] > 0 ? camera.tariffa['prezzoScontato'] : camera.tariffa['prezzo'];
          room.discount = camera.tariffa['sconto'];

          //caso MyPagePropostaRS
        } else {
          room.adultsNumber = camera['numeroAdulti'];
          room.childrenNumber = camera['numeroBambini'];
          bambini = camera['bambini'];
          room.total = camera['totale'];
          room.discountedTotal = camera['totaleScontato'];
          room.discount = room.total - room.discountedTotal;

          if (!preventive_code) {
            preventive_code = camera['codicePreventivo'];
          }

          if (preventive_id == null) {
            preventive_id = camera['oidPreventivo'];
          }
        }

        if (bambini != null && bambini.length > 0) {
          room.children = [];

          for (let bambino of bambini) {
            let child = new PaymentReservationRoomChild();
            child.oid = bambino.oid;
            child.age = bambino.eta;
            child.quantity = bambino.quantita;
            room.children.push(child);
          }
        }

        let extraSelected: (ExtraBooking | MyPageExtra)[] = null;

        //caso MyPagePropostaRS
        if (parameters.extras != null && parameters.extras.length > 0) {
          extraSelected = parameters.extras[roomIndex];

          //caso PrenotazioneDetailsRoom
        } else if (camera['extras'] != null && camera['extras'].length > 0) {
          extraSelected = camera['extras'];
        }

        if (extraSelected != null) {
          if (extraSelected.length > 0) {
            room.extras = [];

            for (let e of extraSelected) {
              let ex: BookingSolutionExtraRS | MyPageExtra;

              //caso ExtraBooking
              if (e['extra'] != null) {
                ex = e['extra'];

                //caso MyPageExtra
              } else {
                ex = e as MyPageExtra;
              }

              if (ex != null && ex.giorni != null && (e.quantita > 0 || (ex.giorni.some(y => y['quantita'] != null && y['quantita'] > 0)))) {
                let giorni = (ex.giorni as (MyPageArticoloGiornoRS | BookingSolutionDayRateRS)[]).filter(x => (x['quantita'] == null && x.selected) || (x['quantita'] != null && x['quantita'] > 0));

                if (giorni.length > 0) {
                  let extra = new PaymentReservationRoomExtra();
                  extra.oid = ex['oid'] != null ? ex['oid'] : ex['extraId'];
                  extra.quantity = e.quantita;

                  //caso ExtraBooking
                  if (e['extra'] != null) {
                    extra.name = ex['nome'];
                    extra.productionType = ex['tipoProduzione'];
                    extra.guestIndex = ex['isPerPersona'] ? ex['indexComponente'] : null;
                    extra.type = ex['tipo'];
                    extra.priceCalculationModality = ex['modalitaCalcoloPrezzo'];
                    extra.isIncluded = ex['isExtraIncluso'];
                  }

                  extra.days = [];

                  for (let g of giorni) {
                    let giorno = new PaymentReservationRoomDay();
                    giorno.date = g.data;
                    giorno.price = g.prezzo;
                    giorno.discountedPrice = g['prezzoScontato'];
                    giorno.quantity = g['quantita'];
                    extra.days.push(giorno);
                  }

                  room.extras.push(extra);
                }
              }
            }
          }
        }

        this.reservation.rooms.push(room);

        roomIndex++;
      }
    }

    this.reservation.preventive_code = preventive_code;
    this.reservation.preventive_id = preventive_id;
    this.reservation.notes = parameters.note;
    this.reservation.promotionCodeId = parameters.oidCodicePromozione;
    this.reservation.travelReasonId = parameters.oidMotivoViaggio;
    this.reservation.voucherId = parameters.oidVoucher;
    this.reservation.isGoogleHotelsTravel = parameters.isGoogleHotelsTravel;
    this.reservation.isTrivago = parameters.isTrivago;
  }

  public static getPaypalCreateRQ(parameters: PaymentRQParameters, id: string, key: string, amount: number, test: boolean = false, description?: string, locale?: string, successUrl?: string, errorUrl?: string, brandName?: string, currency: string = 'EUR', version: number = 2): PaymentRQ {
    let rq = new PaymentRQ('paypal', 'create', parameters);
    rq.version = version;
    rq.test = test;
    rq.transaction.description = description;
    rq.transaction.amount = amount;
    rq.transaction.currency = currency;
    rq.config.locale = locale;
    rq.config.success_url = successUrl;
    rq.config.error_url = errorUrl;
    rq.config.brand_name = brandName;
    rq.config.id = id;
    rq.config.key = key;
    return rq;
  }

  public static getPaypalCaptureRQ(parameters: PaymentRQParameters, id: string, key: string, transactionId: string, token: string, test: boolean = false, version: number = 2): PaymentRQ {
    let rq = new PaymentRQ('paypal', 'capture', parameters);
    rq.version = version;
    rq.test = test;
    rq.transaction_id = transactionId;
    rq.token = token;
    rq.config.id = id;
    rq.config.key = key;
    return rq;
  }

  public static getGestpayEncryptRQ(parameters: PaymentRQParameters, id: string, apiKey: string, amount: number, transactionId: number, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('gestpay', 'encrypt', parameters);
    rq.test = test;
    rq.transaction.amount = amount;
    rq.config.id = id;
    rq.config.api_key = apiKey;
    rq.transaction.id = transactionId;
    return rq;
  }

  public static getGestpayDecryptRQ(parameters: PaymentRQParameters, id: string, apiKey: string, cryptedString: string, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('gestpay', 'decrypt', parameters);
    rq.test = test;
    rq.config.id = id;
    rq.config.api_key = apiKey;
    rq.transaction_id = cryptedString;
    return rq;
  }

  public static getXPayCreateRQ(parameters: PaymentRQParameters, alias: string, secretKey: string, amount: number, successUrl: string, errorUrl: string, transactionId: number, test: boolean = false, currency: string = 'EUR', accountingType: 'I' | 'D' = 'I'): PaymentRQ {
    let rq = new PaymentRQ('xpay', 'create', parameters);
    rq.test = test;
    rq.config.api_key = alias;
    rq.config.key = secretKey;
    rq.config.success_url = successUrl;
    rq.config.error_url = errorUrl;
    rq.transaction.amount = amount;
    rq.transaction.currency = currency;
    rq.transaction.accountingType = accountingType;
    rq.transaction.id = transactionId;
    return rq;
  }

  public static getXPayContabilizzaRQ(parameters: PaymentRQParameters, alias: string, secretKey: string, amount: number, transactionId: string, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('xpay', 'contabilizza', parameters);
    rq.test = test;
    rq.config.api_key = alias;
    rq.config.key = secretKey;
    rq.transaction.amount = amount;
    rq.transaction_id = transactionId;
    return rq;
  }

  public static getXPayStornaRQ(parameters: PaymentRQParameters, alias: string, secretKey: string, amount: number, transactionId: string, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('xpay', 'storna', parameters);
    rq.test = test;
    rq.config.api_key = alias;
    rq.config.key = secretKey;
    rq.transaction.amount = amount;
    rq.transaction_id = transactionId;
    return rq;
  }

  public static getXPayRiepilogoRQ(parameters: PaymentRQParameters, alias: string, secretKey: string, amount: number, transactionOid: number, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('xpay', 'riepilogo', parameters);
    rq.test = test;
    rq.config.api_key = alias;
    rq.config.key = secretKey;
    rq.transaction.amount = amount;
    rq.transaction.id = transactionOid;
    return rq;
  }

  public static getXPayScontrinoRQ(parameters: PaymentRQParameters, alias: string, secretKey: string, amount: number, transactionOid: number, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('xpay', 'scontrino', parameters);
    rq.test = test;
    rq.config.api_key = alias;
    rq.config.key = secretKey;
    rq.transaction.amount = amount;
    rq.transaction.id = transactionOid;
    return rq;
  }

  public static getXPayCreateReservationRQ(parameters: PaymentRQParameters, alias: string, secretKey: string, reservationType: string, structureCode: string, amount: number, successUrl: string, errorUrl: string, transactionId: number, test: boolean = false, currency: string = 'EUR', accountingType: 'I' | 'D' = 'I', reservationCode?: string): PaymentRQ {
    let rq = new PaymentRQ('xpay', 'createReservation', parameters);
    rq.test = test;
    rq.config.api_key = alias;
    rq.config.key = secretKey;
    rq.transaction.amount = amount;
    rq.reservation.code = reservationCode;
    rq.reservation.reservation_type = reservationType;
    rq.reservation.structure_code = structureCode;
    rq.config.success_url = successUrl;
    rq.config.error_url = errorUrl;
    rq.transaction.currency = currency;
    rq.transaction.accountingType = accountingType;
    rq.transaction.id = transactionId;
    return rq;
  }

  public static getXPayAutenticazione3DSRQ(parameters: PaymentRQParameters, alias: string, secretKey: string, amount: number, successUrl: string, transactionId: number, numeroCarta: string, scadenzaCartaMese: string, scadenzaCartaAnno: string, cvv: string, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('xpay', 'autenticazione3DS', parameters);
    rq.test = test;
    rq.config.api_key = alias;
    rq.config.key = secretKey;
    rq.config.success_url = successUrl;
    rq.transaction.amount = amount;
    rq.transaction.id = transactionId;
    rq.credit_card.number = numeroCarta;
    rq.credit_card.exp_month = scadenzaCartaMese;
    rq.credit_card.exp_year = scadenzaCartaAnno;
    rq.credit_card.cvv = cvv;
    return rq;
  }

  public static getXPayPagamento3DSRQ(parameters: PaymentRQParameters, alias: string, secretKey: string, amount: number, transactionId: string, nonce: string, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('xpay', 'pagamento3DS', parameters);
    rq.test = test;
    rq.config.api_key = alias;
    rq.config.key = secretKey;
    rq.transaction.amount = amount;
    rq.transaction_id = transactionId;
    rq.transaction_token = nonce;
    return rq;
  }

  public static getAddonPaymentsConfigurationRQ(parameters: PaymentRQParameters, merchantId: string, secretKey: string, amount: number, notifyUrl: string, test: boolean = false, locale: string = 'IT', currency: string = 'EUR'): PaymentRQ {
    let rq = new PaymentRQ('addonpayments', 'config', parameters);
    rq.test = test;
    rq.config.api_key = merchantId;
    rq.config.key = secretKey;
    rq.config.locale = locale;
    rq.config.success_url = notifyUrl;
    rq.transaction.amount = amount;
    rq.transaction.currency = currency;
    return rq;
  }

  public static getSatispayCreateRQ(parameters: PaymentRQParameters, keyId: string, amount: number, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('satispay', 'create', parameters);
    rq.config.api_key = keyId;
    rq.transaction.amount = amount;
    rq.test = test;
    return rq;
  }

  public static getSatispayCreateKeyIdRQ(parameters: PaymentRQParameters, token: string, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('satispay', 'createKey', parameters);
    rq.token = token;
    rq.test = test;
    return rq;
  }

  public static getSatispayVerifyRQ(parameters: PaymentRQParameters, keyId: string, paymentId: string, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('satispay', 'verify', parameters);
    rq.config.api_key = keyId;
    rq.transaction_id = paymentId;
    rq.test = test;
    return rq;
  }

  public static getSatispayCancelRQ(parameters: PaymentRQParameters, keyId: string, paymentId: string, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('satispay', 'cancel', parameters);
    rq.config.api_key = keyId;
    rq.transaction_id = paymentId;
    rq.test = test;
    return rq;
  }

  public static getStripeCreateRQ(parameters: PaymentRQParameters, secretKey: string, amount: number, transactionId: number, test: boolean = false, description?: string, currency: string = 'EUR', requires_capture: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('stripe', 'create', parameters);
    rq.test = test;
    rq.transaction.description = description;
    rq.transaction.amount = amount;
    rq.transaction.currency = currency;
    rq.config.requires_capture = requires_capture;
    rq.config.key = secretKey;
    rq.transaction.id = transactionId;
    return rq;
  }

  public static getStripeCaptureRQ(parameters: PaymentRQParameters, secretKey: string, amount: number, transaction_id: string, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('stripe', 'capture', parameters);
    rq.test = test;
    rq.transaction_id = transaction_id
    rq.transaction.amount = amount;
    rq.config.key = secretKey;
    return rq;
  }

  public static getPayWayCreateRQ(parameters: PaymentRQParameters, terminalId: string, secretKey: string, successUrl: string, errorUrl: string, amount: number, paymentId: number, test: boolean = false, locale: string = 'IT', currency: string = 'EUR', accountingType: 'I' | 'D' = 'I'): PaymentRQ {
    let rq = new PaymentRQ('payway', 'create', parameters);
    rq.test = test;
    rq.transaction.id = paymentId;
    rq.transaction.amount = amount;
    rq.transaction.currency = currency;
    rq.transaction.accountingType = accountingType;
    rq.config.api_key = terminalId;
    rq.config.key = secretKey;
    rq.config.success_url = successUrl;
    rq.config.error_url = errorUrl;
    rq.config.locale = locale;
    return rq;
  }

  public static getPayWayVerifyRQ(parameters: PaymentRQParameters, terminalId: string, secretKey: string, transactionId: string, paymentId: number, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('payway', 'verify', parameters);
    rq.test = test;
    rq.transaction_id = transactionId;
    rq.config.api_key = terminalId;
    rq.config.key = secretKey;
    rq.transaction.id = paymentId;
    return rq;
  }

  public static getPayWayContabilizzaRQ(parameters: PaymentRQParameters, terminalId: string, secretKey: string, amount: number, transactionId: string, paymentId: number, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('payway', 'contabilizza', parameters);
    rq.test = test;
    rq.config.api_key = terminalId;
    rq.config.key = secretKey;
    rq.transaction.amount = amount;
    rq.transaction_id = transactionId;
    rq.transaction.id = paymentId;
    return rq;
  }

  public static getPayWayAnnullaPreAuthRQ(parameters: PaymentRQParameters, terminalId: string, secretKey: string, amount: number, transactionId: string, paymentId: number, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('payway', 'annullaPreAuth', parameters);
    rq.test = test;
    rq.config.api_key = terminalId;
    rq.config.key = secretKey;
    rq.transaction.amount = amount;
    rq.transaction_id = transactionId;
    rq.transaction.id = paymentId;
    return rq;
  }

  public static getPayWayStornaRQ(parameters: PaymentRQParameters, terminalId: string, secretKey: string, amount: number, transactionId: string, paymentId: number, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('payway', 'storna', parameters);
    rq.test = test;
    rq.config.api_key = terminalId;
    rq.config.key = secretKey;
    rq.transaction.amount = amount;
    rq.transaction_id = transactionId;
    rq.transaction.id = paymentId;
    return rq;
  }

  public static getUnicreditCreateRQ(parameters: PaymentRQParameters, terminalId: string, secretKey: string, successUrl: string, errorUrl: string, amount: number, paymentId: number, test: boolean = false, locale: string = 'IT', currency: string = 'EUR', accountingType: 'I' | 'D' = 'I'): PaymentRQ {
    let rq = new PaymentRQ('unicredit', 'create', parameters);
    rq.test = test;
    rq.transaction.id = paymentId;
    rq.transaction.amount = amount;
    rq.transaction.currency = currency;
    rq.transaction.accountingType = accountingType;
    rq.config.api_key = terminalId;
    rq.config.key = secretKey;
    rq.config.success_url = successUrl;
    rq.config.error_url = errorUrl;
    rq.config.locale = locale;
    return rq;
  }

  public static getUnicreditVerifyRQ(parameters: PaymentRQParameters, terminalId: string, secretKey: string, transactionId: string, paymentId: number, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('unicredit', 'verify', parameters);
    rq.test = test;
    rq.transaction_id = transactionId;
    rq.config.api_key = terminalId;
    rq.config.key = secretKey;
    rq.transaction.id = paymentId;
    return rq;
  }

  public static getTPayCreateRQ(parameters: PaymentRQParameters, terminalId: string, secretKey: string, successUrl: string, errorUrl: string, amount: number, paymentId: number, test: boolean = false, locale: string = 'IT', currency: string = 'EUR', accountingType: 'I' | 'D' = 'I'): PaymentRQ {
    let rq = new PaymentRQ('tpay', 'create', parameters);
    rq.test = test;
    rq.transaction.id = paymentId;
    rq.transaction.amount = amount;
    rq.transaction.currency = currency;
    rq.transaction.accountingType = accountingType;
    rq.config.api_key = terminalId;
    rq.config.key = secretKey;
    rq.config.success_url = successUrl;
    rq.config.error_url = errorUrl;
    rq.config.locale = locale;
    return rq;
  }

  public static getTPayVerifyRQ(parameters: PaymentRQParameters, terminalId: string, secretKey: string, transactionId: string, paymentId: number, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('tpay', 'verify', parameters);
    rq.test = test;
    rq.transaction_id = transactionId;
    rq.config.api_key = terminalId;
    rq.config.key = secretKey;
    rq.transaction.id = paymentId;
    return rq;
  }

  public static getBeSafePayCreateRQ(parameters: PaymentRQParameters, apiKey: string, amount: number, descrizione: string, successUrl: string, errorUrl: string, transactionId: number): PaymentRQ {
    let rq = new PaymentRQ('besafepay', 'create', parameters);
    rq.transaction.description = descrizione;
    rq.transaction.amount = amount;
    rq.config.api_key = apiKey;
    rq.config.success_url = successUrl;
    rq.config.error_url = errorUrl;
    rq.transaction.id = transactionId;
    return rq;
  }

  public static getSumUpCreateRQ(parameters: PaymentRQParameters, merchantId: string, id: string, key: string, amount: number, test: boolean = false, currency: string = 'EUR'): PaymentRQ {
    let rq = new PaymentRQ('sumup', 'create', parameters);
    rq.test = test;
    rq.transaction.amount = amount;
    rq.transaction.currency = currency;
    rq.config.api_key = merchantId;
    rq.config.id = id;
    rq.config.key = key;
    return rq;
  }

  public static getSumUpSubmitRQ(parameters: PaymentRQParameters, token: string, transactionId: string, id: string, key: string, titolareCarta: string, numeroCarta: string, scadenzaCartaMese: string, scadenzaCartaAnno: string, cvv: string, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('sumup', 'submit', parameters);
    rq.test = test;
    rq.config.id = id;
    rq.config.key = key;
    rq.transaction_id = transactionId;
    rq.token = token;
    rq.credit_card.holder = titolareCarta;
    rq.credit_card.number = numeroCarta;
    rq.credit_card.exp_month = scadenzaCartaMese;
    rq.credit_card.exp_year = scadenzaCartaAnno;
    rq.credit_card.cvv = cvv;
    return rq;
  }

  public static getSumUpVerifyRQ(parameters: PaymentRQParameters, token: string, transactionId: string, id: string, key: string, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('sumup', 'verify', parameters);
    rq.test = test;
    rq.config.id = id;
    rq.config.key = key;
    rq.transaction_id = transactionId;
    rq.token = token;
    return rq;
  }

  public static getHobexCreateRQ(parameters: PaymentRQParameters, entityId: string, accessToken: string, amount: number, test: boolean = false, currency: string = 'EUR', accountingType: 'I' | 'D' = 'I'): PaymentRQ {
    let rq = new PaymentRQ('hobex', 'create', parameters);
    rq.test = test;
    rq.transaction.amount = amount;
    rq.transaction.currency = currency;
    rq.transaction.accountingType = accountingType;
    rq.config.api_key = entityId;
    rq.config.key = accessToken;
    return rq;
  }

  public static getHobexVerifyRQ(parameters: PaymentRQParameters, entityId: string, accessToken: string, transactionId: string, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('hobex', 'verify', parameters);
    rq.test = test;
    rq.config.api_key = entityId;
    rq.config.key = accessToken;
    rq.transaction_id = transactionId;
    return rq;
  }

  public static getAxeptaCreateRQ(parameters: PaymentRQParameters, apiKey: string, accessToken: string, amount: number, test: boolean = false, locale: string = 'IT', currency: string = 'EUR', accountingType: 'I' | 'D' = 'I'): PaymentRQ {
    let rq = new PaymentRQ('axepta', 'create', parameters);
    rq.test = test;
    rq.transaction.amount = amount;
    rq.transaction.currency = currency;
    rq.transaction.accountingType = accountingType;
    rq.config.api_key = apiKey;
    rq.config.key = accessToken;
    rq.config.locale = locale;
    return rq;
  }

  public static getHolipayCreateRQ(parameters: PaymentRQParameters, hotelId: string, secretKey: string, amount: number, successUrl: string, errorUrl: string, transactionId: number, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('holipay', 'create', parameters);
    rq.test = test;
    rq.transaction.amount = amount;
    rq.config.api_key = hotelId;
    rq.config.key = secretKey;
    rq.config.success_url = successUrl;
    rq.config.error_url = errorUrl;
    rq.transaction.id = transactionId;
    return rq;
  }

  public static getSiapayCreateRQ(parameters: PaymentRQParameters, shopId: string, secretKey: string, amount: number, successUrl: string, errorUrl: string, transactionId: number, test: boolean = false, locale: string = 'ITA', accountingType: 'I' | 'D' = 'I'): PaymentRQ {
    let rq = new PaymentRQ('siapay', 'create', parameters);
    rq.test = test;
    rq.transaction.amount = amount;
    rq.transaction.accountingType = accountingType;
    rq.config.api_key = shopId;
    rq.config.key = secretKey;
    rq.config.success_url = successUrl;
    rq.config.error_url = errorUrl;
    rq.config.locale = locale;
    rq.transaction.id = transactionId;
    return rq;
  }

  public static getScalaPayCreateRQ(parameters: PaymentRQParameters, apiKey: string, amount: number, successUrl: string, errorUrl: string, transactionId: number, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('scalapay', 'create', parameters);
    rq.test = test;
    rq.transaction.amount = amount;
    rq.config.api_key = apiKey;
    rq.config.success_url = successUrl;
    rq.config.error_url = errorUrl;
    rq.transaction.id = transactionId;
    return rq;
  }

  public static getScalaPayCaptureRQ(parameters: PaymentRQParameters, apiKey: string, token: string, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('scalapay', 'capture', parameters);
    rq.test = test;
    rq.config.api_key = apiKey;
    rq.token = token;
    return rq;
  }

  public static getVirtualPayCreateRQ(parameters: PaymentRQParameters, merchantId: string, ABI: string, secretKey: string, amount: number, successUrl: string, errorUrl: string, transactionId: number): PaymentRQ {
    let rq = new PaymentRQ('virtualpay', 'create', parameters);
    rq.transaction.amount = amount;
    rq.config.api_key = merchantId;
    rq.token = ABI;
    rq.config.key = secretKey;
    rq.config.success_url = successUrl;
    rq.config.error_url = errorUrl;
    rq.transaction.id = transactionId;
    return rq;
  }

  public static getMyPOSCreateRQ(parameters: PaymentRQParameters, walletNumber: string, SID: string, keyIndex: number, privateKey: string, publicCertificate: string, amount: number, locale: string, description: string, successUrl: string, errorUrl: string, transactionId: number, test: boolean = false): PaymentRQ {
    let rq = new PaymentRQ('mypos', 'create', parameters);
    rq.test = test;
    rq.transaction.amount = amount;
    rq.transaction.description = description;
    rq.config.api_key = walletNumber;
    rq.token = SID;
    rq.config.key = keyIndex.toString();
    rq.config.success_url = successUrl;
    rq.config.error_url = errorUrl;
    rq.config.locale = locale;
    rq.transaction.id = transactionId;
    rq.config.private_key = privateKey;
    rq.config.public_certificate = publicCertificate;
    return rq;
  }

  public static getVivaWalletCreateRQ(parameters: PaymentRQParameters, clientId: string, secretKey: string, amount: number, locale: string, accountingType: 'I' | 'D', transactionId: number, test: boolean): PaymentRQ {
    let rq = new PaymentRQ('vivawallet', 'create', parameters);
    rq.test = test;
    rq.transaction.amount = amount;
    rq.transaction.accountingType = accountingType;
    rq.config.locale = locale;
    rq.config.id = clientId;
    rq.config.key = secretKey;
    rq.transaction.id = transactionId;
    return rq;
  }

  public static getVivaWalletVerifyRQ(parameters: PaymentRQParameters, clientId: string, secretKey: string, transactionId: string, test: boolean): PaymentRQ {
    let rq = new PaymentRQ('vivawallet', 'verify', parameters);
    rq.test = test;
    rq.transaction_id = transactionId;
    rq.config.id = clientId;
    rq.config.key = secretKey;
    return rq;
  }
}

export class PaymentRS {
  success: boolean;
  error: string;
  redirect_url: string;
  transaction_id: string;
  transaction_token: string;
  token: string;
  client_secret: string;
  form: string;
  config: any;
  key_id: string;
  payment_status: string;
}

export class LinguaPortaleAlbergo {
  lingua: string;
  oidPortale: number;
  oidAlbergo: number;
}

export class BookingInput {
  camerePax: BookingSolutionRoomRQ[];
  extraSelected: ExtrasXTypeBooking[][];
  tariffeTipiCamera: TariffaTipoCameraBooking[];
  sistemazioni: number[];
  vociAddebito: BookingDebitEntryConfigRS[];
  scontoVoucher: number;
  notti: number;

  constructor() {
    this.camerePax = [];
    this.extraSelected = [];
    this.tariffeTipiCamera = [];
    this.sistemazioni = [];
    this.vociAddebito = [];
  }
}

export class BookingExtraInput {
  extras: ExtrasXTypeBooking[];
  extraSelected: ExtraBooking[];
  vociAddebito: BookingDebitEntryConfigRS[];

  constructor(extras?: ExtrasXTypeBooking[], extraSelected?: ExtraBooking[], vociAddebito?: BookingDebitEntryConfigRS[]) {
    this.extras = extras;
    this.extraSelected = extraSelected;
    this.vociAddebito = vociAddebito;
  }
}

export class PrenotazioneDetailsOutput {
  totale: number;
  totaleScontato: number;
  rooms: PrenotazioneDetailsRoom[];
}

export class CheckTokenRQ {
  token: string;
  clientId: string;
}

export class CheckTokenRS extends WebApiResponse {
  data: {
    utente: Utente,
    albergo: Albergo,
    token: string,
    plugins: RouteInfo[],
    permessi: string[],
    //myForecast: MyForecast[],
    messaggi: string[],
    warnings: string[],
    lingue: Lingua[],
    isPostaAttiva: boolean,
    email: string,
    clientId: string
  };
}

export class DmsSolutionRQ {
  arrivo: string;
  partenza: string;
  camere: BookingSolutionRoomRQ[];
  comune: string;
  servizi: number[];
  tipologie: number[];
  stelle: number[];
  oidAlbergoMaster: number;

  constructor() {
    this.servizi = [];
    this.tipologie = [];
    this.stelle = [];
  }
}

export class DmsSolutionRS extends WebApiResponse {
  data: { portali: ImmaginiXPortale[] };
}

export class DettagliPortaleRQ {
  lingua: string;
  oidAlbergoMaster: number;
  oidPortale: number;
}

export class DettagliPortale {
  portale: PortaleDms;
  albergoMaster: AlbergoMaster;
  immagini: string[];
  descrizione: string;
  tariffe: string[];
  servizi: string[];
  urlWebBooking: string;
  codiceAlbergo: number;
}

export class DettagliPortaleRS extends WebApiResponse {
  data: DettagliPortale;
}

export class GetImmaginiPortaliServiziXAlbergoMasterRQ {
  oidAlbergo: number;
  lingua: string;
  arrivo: string;
  partenza: string;
  camere: BookingSolutionRoomRQ[];
}

export class ServizioAlbergoMaster {
  oid: number;
  nome: string;
}

export class PaginaAlbergoMaster {
  nome: string;
  testo: string;
  url: string;
  isModale: boolean;
}

export class GetImmaginiPortaliServiziXAlbergoMaster {
  albergo: AlbergoMaster;
  portali: ImmaginiXPortale[];
  immagini: string[];
  servizi: ServizioAlbergoMaster[];
  pagine: PaginaAlbergoMaster[];
  tipologieAlbergo: number[];
  stelleAlbergo: number[];
  testoPrimaHotel: string;
  testoDopoHotel: string;
  overlayImmagine: string;
}

export class GetImmaginiPortaliServiziXAlbergoMasterRS extends WebApiResponse {
  data: GetImmaginiPortaliServiziXAlbergoMaster;
}

export class SetServiziDmsXLinguaRQ {
  servizioDms: ServizioDms;
  serviziDmsXLingua: ServizioDmsXLingua[];

  constructor() {
    this.servizioDms = new ServizioDms();
    this.serviziDmsXLingua = [];
  }
}

export class SetPagineAlbergoMasterXLinguaRQ {
  pagina: AlbergoMasterPagina;
  pagineXLingua: AlbergoMasterPaginaXLingua[];

  constructor() {
    this.pagina = new AlbergoMasterPagina();
    this.pagineXLingua = [];
  }
}

export class HtmlEditorExport {
  design: any;
  html: string;
}

export class SetSistemazioniXLinguaRQ {
  sistemazione: Sistemazione;
  sistemazioniXLingua: SistemazioneXLingua[];

  constructor() {
    this.sistemazione = new Sistemazione();
    this.sistemazioniXLingua = [];
  }
}

export class SetUpSellingXLinguaRQ {
  upSelling: UpSelling;
  upSellingXLingua: UpSellingXLingua[];

  constructor() {
    this.upSelling = new UpSelling();
    this.upSellingXLingua = [];
  }
}

export class OpzioniCamera {
  tipoCamera: TipoCameraOTA;
  tariffa: TariffaOTA;
  numeroAdulti: number;
  numeroBambini: number;
  opzioni: BookingSolutionRoomRS[];
}

export class GeneraOpzioniRS extends WebApiResponse {
  data: OpzioniCamera[];
  oidPortale: number;
}

export class GeneraOpzioniRQ {
  oidRichiesta: number;
  oidPortale: number;
  isVisualizzaTutteLeSoluzioni: boolean;
  isVisualizzaSoloCamereDisponibili: boolean;
  isVisualizzaCamerePaxNonValide: boolean;
  codicePromozione: string;
}

export class BookingExtraSolutionRQ {
  lingua: string;
  oidAlbergo: number;
  oidPortale: number;
  gift: boolean;
}

export class BookingExtraSolution {
  extras: BookingSolutionExtrasXTypeRS[];
  modalitaPagamento: PaymentMethod[];
}

export class BookingExtraSolutionRS extends WebApiResponse {
  data: BookingExtraSolution;
}

export class ArticoliXPrenotazioneExtra {
  prenotazione: PrenotazioneExtra;
  articoli: PrenotazioneExtraArticoli[];
}

export class GetPrenotazioniExtraFilterRS extends WebApiResponseFilter {
  data: ArticoliXPrenotazioneExtra[];
}

export class GetPrenotazioniExtraRS extends WebApiResponse {
  data: ArticoliXPrenotazioneExtra[];
}

export class GetStatiPreventiviRQ {
  dal: string;
  al: string;
  isIncludiPreventiviCancellati: boolean;
  oidUbicazione: number;
}

export class StatoPreventivoRS {
  stato: StatoPreventivo;
  numero: number;
  numeroFlag: number;
  importo: number;
}

export class GetStatiPreventiviRS extends WebApiResponse {
  data: {
    numeroPreventivi: number,
    numeroPrenotazioni: number,
    percentualeConversione: number,
    statiRichieste: StatoPreventivoRS[],
    statiPreventivi: StatoPreventivoRS[],
    statiPrenotazioni: StatoPreventivoRS[]
  }
}

export class SetAlberghiMasterXLinguaRQ {
  albergoMaster: AlbergoMaster;
  alberghiMasterXLingua: AlbergoMasterXLingua[];

  constructor() {
    this.albergoMaster = new AlbergoMaster();
    this.alberghiMasterXLingua = [];
  }
}

export class CameraBookingUrlParameter {
  adulti: number;
  bambini: BambinoCameraBookingUrlParameter[];

  //Usato per Google Hotels Travel
  quantitaBambini: number;
}

export class BambinoCameraBookingUrlParameter {
  eta: number;
  quantita: number;
}

export class UtentiRS {
  utente: Utente;
  permessi: TipoPermesso[];
  isAccountBloccato: boolean;

  constructor() {
    this.utente = new Utente();
    this.permessi = [];
  }
}

export class ArrotondamentiRS {
  arrotondamento: Arrotondamento;
  dettagli: DettaglioArrotondamento[];
}

export class CancellazioniRS {
  cancellazione: Cancellazione;
  dettagli: DettaglioCancellazione[];
}

export class TrattamentiRS {
  trattamento: Trattamento;
  dettagli: DettaglioTrattamento[];
}

export class MenuRS {
  menu: Menu;
  piattiColazione: Piatto[];
  piattiPranzo: Piatto[];
  piattiCena: Piatto[];
}

export class PianiTariffariRS {
  pianoTariffario: PianoTariffario;
  dettagli: DettaglioPianoTariffario[];
}

export class PrezziXArticoloRS {
  oidListinoXPeriodo: number;
  oidPrezzoXArticolo: number;
  dal: string;
  al: string;
  articolo: Articolo;
  prezzo: number;
  tipoValore: TipoValore;
  fascia: string;
  durataMinimaSoggiorno: number;
  durataMassimaSoggiorno: number;
  politicaCancellazione: Cancellazione;
  variazioniTipoCamera: VariazionePrezzoXArticoloXTipoCamera[];
  variazioniTrattamento: VariazionePrezzoXArticoloXTrattamento[];
  variazioniDurata: VariazionePrezzoXArticoloXDurata[];
  variazioniComponente: VariazionePrezzoXArticoloXComponente[];
  variazioniTipoPasto: VariazionePrezzoXArticoloXTipoPasto[];
  variazioniComponenteTipoCamera: VariazionePrezzoXArticoloXComponenteXTipoCamera[];
  variazioniPersona: VariazionePrezzoXArticoloXPersona[];
  variazioniPianoFamiglia: VariazionePrezzoXArticoloXPianoFamiglia[];
  variazioniGiorniAnticipo: VariazionePrezzoXArticoloXGiorniAnticipo[];
}

export class GetArrotondamentiRS extends WebApiResponse {
  data: ArrotondamentiRS[];
}

export class GetCancellazioniRS extends WebApiResponse {
  data: CancellazioniRS[];
}

export class GetTrattamentiRS extends WebApiResponse {
  data: TrattamentiRS[];
}

export class GetMenuRS extends WebApiResponse {
  data: MenuRS[];
}

export class GetPianiTariffariRS extends WebApiResponse {
  data: PianiTariffariRS[];
}

export class GetArrotondamentiFilterRS extends WebApiResponseFilter {
  data: ArrotondamentiRS[];
}

export class GetCancellazioniFilterRS extends WebApiResponseFilter {
  data: CancellazioniRS[];
}

export class GetTrattamentiFilterRS extends WebApiResponseFilter {
  data: TrattamentiRS[];
}

export class GetMenuFilterRS extends WebApiResponseFilter {
  data: MenuRS[];
}

export class GetPianiTariffariFilterRS extends WebApiResponseFilter {
  data: PianiTariffariRS[];
}

export class GetUtentiRS extends WebApiResponse {
  data: UtentiRS[];
}

export class GetUtentiFilterRS extends WebApiResponseFilter {
  data: UtentiRS[];
}

export class UpdateTotalsPreventivoRQ {
  oid: number;
  totale: number;
  camere: UpdateTotalsPreventivoCamereRQ[];

  constructor() {
    this.camere = [];
  }
}

export class UpdateTotalsPreventivoCamereRQ {
  oid: number;
  totale: number;
  proposte: UpdateTotalsPreventivoCamereProposteRQ[];

  constructor() {
    this.proposte = [];
  }
}

export class UpdateTotalsPreventivoCamereProposteRQ {
  oid: number;
  totale: number;
  totaleScontato: number;
  dettagli: UpdateTotalsPreventivoCamereProposteDettagliRQ[];

  constructor() {
    this.dettagli = [];
  }
}

export class UpdateTotalsPreventivoCamereProposteDettagliRQ {
  oid: number;
  totale: number;
}

export class PubblicaDisponibilitaRQ {
  oidPortale: number;
  dal: string;
  al: string;
  oidTipiCamera: number[];
  oidTariffe: number[];
  oidDisponibilita: number[];
  isForzaPubblicazione: boolean;

  constructor() {
    this.oidTipiCamera = [];
    this.oidTariffe = [];
    this.oidDisponibilita = [];
  }
}

export class PubblicaDisponibilitaGiornoRQ {
  oidPortale: number;
  data: string;
}

export class GetGiorniDaPubblicareRQ {
  oidPortale: number;
  oidPortali: number[];
  dal: string;
  al: string;
}

export class BloccaPubblicazioneAutomaticaRQ {
  oidPortale: number;
  dal: string;
  al: string;
}

export class SbloccaPubblicazioneAutomaticaRQ {
  oid: number;
  oidAlbergo: number;
  oidPortale: number;
}

export class PubblicaDisponibilitaResultRS {
  oid: number;
  portale: string;
  giorno: string;
  statoPubblicazione: string;
  statoPortale: string;
  tipoCamera: string;
  tariffa: string;
  disponibili: number;
}

export class PubblicaDisponibilitaRS {
  tipoEsito: TipoEsitoSbm;
  descrizione: string;
  dettaglioErrore: string;
  dettaglioWarning: string;
  risultati: PubblicaDisponibilitaResultRS[];
  giorni: string[];
}

export class RecuperaPasswordRQ {
  email: string;
  oidCliente: number;
  oidAlbergo: number;
  oidPortale: number;
}

export class RecuperaPasswordRS extends WebApiResponse {
  data: { success: boolean };
}

export class InviaPreventivoRQ {
  oidPreventivo: number;
  oidTemplate: number;
  oggetto: string;
  testo: string;
  cc: string;
  replaceTags: boolean;
}

export class InviaPreventivoRS extends WebApiResponse {
  data: {
    preventivo: Preventivo,
    success: boolean
  };
}

export class RifiutaPreventivoRQ {
  oidPreventivo: number;
  oidTemplate: number;
  oidCausale: number;
  oggetto: string;
  testo: string;
  cc: string;
  replaceTags: boolean;
}

export class RifiutaPreventivoRS extends WebApiResponse {
  data: { success: boolean };
}

export class CancellaPreventivoRQ extends RifiutaPreventivoRQ { }

export class CancellaPreventivoRS extends RifiutaPreventivoRS { }

export class RifiutaRichiestaRQ {
  oidRichiesta: number;
  oidTemplate: number;
  oidCausale: number;
  oggetto: string;
  testo: string;
  cc: string;
  replaceTags: boolean;
}

export class RifiutaRichiestaRS extends WebApiResponse {
  data: { success: boolean };
}

export class InviaEmailClienteRQ {
  oidCliente: number;
  oidClienti: number[];
  oidTemplate: number;
  oidPreventivo: number;
  oidPrenotazione: number;
  oggetto: string;
  testo: string;
  cc: string;
  replaceTags: boolean;
}

export class InviaEmailClienteRS extends WebApiResponse {
  data: { success: boolean };
}

export class InviaEmailPrenotazioneRQ {
  oidPrenotazione: number;
  oidTemplate: number;
  oggetto: string;
  testo: string;
  cc: string;
  replaceTags: boolean;
}

export class InviaEmailPrenotazioneRS extends WebApiResponse {
  data: { success: boolean };
}

export class InviaEmailTransazioneRQ {
  oidTransazione: number;
  oidTemplate: number;
  oggetto: string;
  testo: string;
  cc: string;
  replaceTags: boolean;
}

export class InviaEmailTransazioneRS extends WebApiResponse {
  data: { success: boolean };
}

export class EmettiVoucherRQ {
  oidPrenotazione: number;
  codicePromozione: CodicePromozione;
}

export class CreaPromozioneRQ {
  promozione: Promozione;
  dal: string;
  al: string;
  portali: number[];
  tipiCamere: number[];
  trattamenti: number[];
  modalitaPagamento: number[];
  sconto: number;
  durataMinimaSoggiorno: number;
}

export class SendMessagePreventivoRQ {
  oidMessaggio: number;
  oidPreventivo: number;
  testo: string;
}

export class SendMessagePrenotazioneRQ {
  oidMessaggio: number;
  oidPrenotazione: number;
  testo: string;
}

export class SendMessageTransazioneRQ {
  oidMessaggio: number;
  oidTransazione: number;
  testo: string;
}

export class SendMessageClienteRQ {
  oidMessaggio: number;
  oidCliente: number;
  oidPortale: number;
  testo: string;
  isMySelf: boolean;
}

export class EliminaMessaggioRQ {
  oidMessaggio: number;

  constructor(oidMessaggio: number) {
    this.oidMessaggio = oidMessaggio;
  }
}

export class ImpostaLettoMessaggioRQ {
  oidMessaggio: number;

  constructor(oidMessaggio: number) {
    this.oidMessaggio = oidMessaggio;
  }
}

export class ImpostaDaLeggereMessaggioRQ {
  oidMessaggio: number;

  constructor(oidMessaggio: number) {
    this.oidMessaggio = oidMessaggio;
  }
}

export class AccettaPreventivoRQ {
  oidPreventivo: number;
  cliente: Cliente;
  oidProposte: number[];
  oidSistemazioni: number[];
  extras: MyPageExtra[][];
}

export class ConfermaPreventivoRQ {
  oidPreventivo: number;
  oidPrenotazioni: number[];
  pagamento: PaymentModel;
  oidSistemazioni: number[];
  ospiti: Cliente[];
  oidVoucher: number;
  note: string;
}

export class RinnovaRichiestaRQ {
  oidPreventivo: number;
}

export class PrenotaPreventivoRQ {
  oidProposte: number[];
  cliente: Cliente;
  pagamento: PaymentModel;
  extras: MyPageExtra[][];
  oidSistemazioni: number[];
  ospiti: Cliente[];
  note: string;
  isRichiediPagamento: boolean;
  oidModalitaPagamento: string;
  caparra: number;
  isCaparraPercentuale: boolean;
  dataScadenzaCaparra: string;
  oidTemplate: number;
  oraArrivo: string;
  isPrenotazioneExtranet: boolean;
  isInviaEmailPreventivoPrenotato: boolean;
  isInviaEmailHotel: boolean;
  oidVoucher: number;
  isRimuoviCamera: boolean[];
}

export class PrenotaPreventivoRS extends WebApiResponse {
  data: {
    preventivo: Preventivo,
    prenotazioni: Prenotazione[],
    transazione: Transazione,
    bookingCode: string
  };
}

export class RequestPickupRQ {
  oidAlbergo: number;

  dataPrenotazioneDal: string;
  dataPrenotazioneAl: string;

  arrivoDal: string;
  arrivoAl: string;

  oidUbicazioneIstat: number;
  oidMercato: number;
  oidCanaleVendita: number;

  tipoDato: TipoDatoPrenotazioniPickup;
}

export class RequestPickupRSDati {
  key: string;

  prenotazioni: number;
  roomNight: number;
  revenue: number;
  ADR: number;

  cancellazioni: number;
  roomNightCancellazioni: number;
  revenueCancellazioni: number;
  ADRCancellazioni: number;

  datiAnnoPrecedente: RequestPickupRSDati;
}

export class RequestPickupRS extends WebApiResponse {
  data: {
    dati: RequestPickupRSDati[],
    grafico: NgxAdvancedChart
  };
}

export class RequestPickupPreventiviRQ {
  oidAlbergo: number;

  dataPreventivoDal: string;
  dataPreventivoAl: string;

  arrivoDal: string;
  arrivoAl: string;

  oidUbicazioneIstat: number;
  oidMercato: number;
  oidCanaleVendita: number;
  oidTagCrm: number;

  tipoDato: TipoDatoPreventiviPickup;

  isRaggruppaPerArrivo: boolean;
}

export class RequestPickupPreventiviRSDati {
  key: string;

  preventivi: number;
  roomNight: number;
  revenue: number;
  ADR: number;

  prenotazioni: number;
  roomNightPrenotazioni: number;
  revenuePrenotazioni: number;
  ADRPrenotazioni: number;

  cancellazioni: number;
  roomNightCancellazioni: number;
  revenueCancellazioni: number;
  ADRCancellazioni: number;

  indiceConversione: number;

  datiAnnoPrecedente: RequestPickupPreventiviRSDati;
}

export class RequestPickupPreventiviRS extends WebApiResponse {
  data: {
    dati: RequestPickupPreventiviRSDati[],
    grafico: NgxAdvancedChart
  };
}

export class GetClientiProfilatiRQ {
  oidAlbergo: number;
  tipoDato: TipoDatoClientiProfilati;
}

export class GetClientiProfilatiRSDati {
  key: string;
  totale: number;
  totaleEmail: number;
  totaleCellulare: number;
}

export class GetClientiProfilatiRS extends WebApiResponse {
  data: GetClientiProfilatiRSDati[];
}

export class UpdatePermessiRQ {
  utente: Utente;
  permessi: UtenteXPermesso[];
}

export class GetContatoriMenu {
  richieste: number;
  preventivi: number;
  messaggi: number;
  prenotazioniExtra: number;
  roomService: number;
  upSelling: number;
  conteggioPiatti: number;
}

export class GetContatoriMenuRS extends WebApiResponse {
  data: GetContatoriMenu;
}

export class GetFormV1ViewRQ {
  oidAlbergo: number;
  oidAlbergoMaster: number;
  oidPortale: number;
  lingua: string;
}

export class GetFormV1ViewRSTipoCamera {
  oid: number;
  nome: string;
  isDayUse: boolean;
  oidTariffe: number[];
  portaleXAlbergo: PortaleXAlbergo;
}

export class GetFormV1ViewRSTariffa {
  oid: number;
  descrizione: string;
  isDayUse: boolean;
  portaleXAlbergo: PortaleXAlbergo;
}

export class GetFormV1ViewRSMotivoViaggio {
  oid: number;
  nome: string;
  descrizione: string;
}

export class GetFormV1ViewRS extends WebApiResponse {
  data: {
    tipiCamera: GetFormV1ViewRSTipoCamera[],
    tariffe: GetFormV1ViewRSTariffa[],
    parametriRicercaMercato: ParametroRicerca[],
    parametriRicercaCanaleVendita: ParametroRicerca[],
    portali: PortaleXAlbergo[],
    motiviViaggio: GetFormV1ViewRSMotivoViaggio[],
    traduzioni: string,
    newsLetterPortale: NewsLetterPortale,
    etaMassimaBambini: number,
    banner: string,
    urlRedirect: string;
  };
}

export class DetailPrenotazioneRS extends WebApiResponse {
  data: {
    notificheMail: NotificaEmail[],
    logBilanciamento: PrenotazioneLogBilanciamento[],
    storicoPrenotazione: StoricoPrenotazioneWS[],
    transazioni: Transazione[],
    logOperazioni: LogOperazionePortaleXAlbergo[],
    logDisponibilita: LogDisponibilitaPortaleXAlbergo[],
    ospiti: ComponenteXPrenotazione[],
    messaggi: ClienteMessaggi[],
    cartaCredito: PrenotazioneCC,
    workFlows: WorkFlow[],
    workFlowsEseguiti: WorkFlow[],
    voucher: CodicePromozione[],
    voucherUtilizzato: CodicePromozione,
    upSellingCamera: PrenotazioneUpSelling,
    prenotazioniExtra: ArticoliXPrenotazioneExtra[],
    importoPrimaNotte: number,
    importiGiornalieri: number[],
    noteSelfCheckin: string,
    urlMySelfHotel: string,
    isVisualizzaUrlAccessori: boolean,
    causaliCancellazione: CausaleOperazione[]
  };
}

export class DetailCodicePromozioneRS extends WebApiResponse {
  data: {
    prenotazione: Prenotazione
  };
}

export class ClienteAttivitaXData {
  data: string;
  attivita: ClienteAttivita[];
}

export class ClienteAttivita {
  ora: string;
  descrizione: string;
  icona: string;
}

export class DetailClienteRS extends WebApiResponse {
  data: {
    attivita: ClienteAttivitaXData[],
    prenotazioni: Prenotazione[],
    preventivi: Preventivo[],
    richieste: Richiesta[],
    transazioni: Transazione[],
    risposteSondaggi: SondaggioRisposta[],
    notificheEmail: NotificaEmail[],
    voucher: CodicePromozione[],
    isAccountBloccato: boolean
  };
}

export class RichiestaCameraRS {
  descrizione: string;
  numeroAdulti: number;
  numeroBambini: number;
  etaBambini: string;
}

export class DetailRichiestaRS extends WebApiResponse {
  data: {
    camere: RichiestaCameraRS[],
    camereRichiesta: RichiestaCamere[],
    workFlowsEseguiti: WorkFlow[],
    pax: RichiestaCamerePax[][]
  };
}

export class CreaRichiestaPreventivoRQProposta {
  tipoCamera: BookingSolutionRoomRS;
  tariffa: BookingSolutionRateRS;
  giorniChiusi: string;
  selected: boolean;
  camera: string;
}

export class CreaRichiestaPreventivoRQCamera {
  pax: BookingSolutionPaxRQ[];
  proposte: CreaRichiestaPreventivoRQProposta[];
}

export class CreaRichiestaPreventivoRQ {
  camere: CreaRichiestaPreventivoRQCamera[];
  dal: string;
  al: string;
  oidPortale: number;
  oidUtente: number;
  oidMotivoViaggio: number;
  oidCodicePromozione: number;
  oidCliente: number;
  isCreaPreventivo: boolean;
  tipoRichiesta: TipoRichiestaPreventivo;
  anagrafica: Cliente;
}

export class CreaRichiestaPreventivoRS extends WebApiResponse {
  data: { oidPreventivo: number };
}

export class PrezziXPortale {
  portale: PortaleXAlbergo;
  prezzoMinimo: number;
  prezzoMassimo: number;
  prezzoUsoSingolaMinimo: number;
  prezzoUsoSingolaMassimo: number;
  nonDisponibile: boolean;
}

export class PrezziXGiorno {
  data: string;
  prezzi: PrezziXPortale[];
}

export class GetPrezziRS extends WebApiResponse {
  data: PrezziXGiorno[];
}

export class RicercheRS {
  ricerche: LogRicercaPortaleXAlbergo[];
  grafico: NgxAdvancedChart;
}

export class GetRicercheRQ {
  filter: FiltroLogRicerca;
  isRaggruppaPerArrivo: boolean;

  constructor() {
    this.filter = new FiltroLogRicerca();
  }
}

export class GetRicercheRS extends WebApiResponse {
  data: RicercheRS;
}

export class PrenotazioniRS {
  prenotazioni: Prenotazione[];
  revenue: number;
  roomNight: number;
  ADR: number;
}

export class GetPrenotazioniRS extends WebApiResponse {
  data: PrenotazioniRS;
}

export class GetPrenotazioniFilterRS extends WebApiResponseFilter {
  data: PrenotazioniRS;
}

export class GetRichiesteRQ {
  filter: WebApiRequestFilter;
  filterStati: WebApiRequestFilter;
  isIncludiRichiesteRifiutate: boolean;
}

export class RichiesteRS {
  richieste: Richiesta[];
  richiesteDaGestire: number;
  richiesteConPreventivo: number;
  richiesteRifiutate: number;
}

export class GetRichiesteRS extends WebApiResponse {
  data: RichiesteRS;
}

export class GetRichiesteFilterRS extends WebApiResponseFilter {
  data: RichiesteRS;
}

/*export class AggiornaSorgentiMyForecastRQ {
  oidAlbergo: number;
  codiceStruttura: string;
  tipoParametro: TipoParametroRicerca;
}

export class AggiornaSorgentiMyForecastRS extends WebApiResponse {
  data: { success: boolean };
}

export class AttivaMyForecastRQ {
  codiceStruttura: string;
  oidAlbergo: number;
  username: string;
  password: string;
  email: string;
  sitoWeb: string;
  nomeHotel: string;
  indirizzo: string;
  cap: string;
  citta: string;
  provincia: string;
  regione: string;
  nazione: string;
  telefono: string;
  totaleCamere: number;
  tipoParametro: TipoParametroRicerca;
  tipiCameraOid: number[];
}

export class AttivaMyForecastRS extends WebApiResponse {
  data: { myForecast: MyForecast[] };
  dettaglioErrore: string;
}

export class AggiornaMyForecastRS extends WebApiResponse {
  data: { success: boolean };
}

export class LeggiStrutturaMyForecastRQ {
  username: string;
  password: string;
}

export class LeggiRisorseMyForecastRQ {
  username: string;
  password: string;
}

export class LeggiSorgentiMyForecastRQ {
  username: string;
  password: string;
}

export class StrutturaMyForecast {
  codice: string;
  nome: string;
  email: string;
  telefono: string;
  sito: string;
  indirizzo: string;
  cap: string;
  citta: string;
  provincia: string;
  nazione: string;
  regione: string;
  numeroCamere: string;
  lingua: string;
}

export class CameraMyForecast {
  codice: string;
  descrizione: string;
  occupazione: string;
  disponibili: number;
  alias: string;
}

export class SorgenteMyForecast {
  codice: string;
  descrizione: string;
  alias: string;
  isDiretto: boolean;
}

export class LeggiStrutturaMyForecastRS extends WebApiResponse {
  data: StrutturaMyForecast;
}

export class LeggiRisorseMyForecastRS extends WebApiResponse {
  data: CameraMyForecast[];
}

export class LeggiSorgentiMyForecastRS extends WebApiResponse {
  data: SorgenteMyForecast[];
}*/

export class RisorseRQ {
  oidPortaleXAlbergo: number;
  codiciRisorse: string[];

  constructor(oidPortaleXAlbergo: number) {
    this.oidPortaleXAlbergo = oidPortaleXAlbergo;
  }
}

export class RisorseRS extends WebApiResponse {
  data: { risorse: TipoCameraOTA[] };
}

export class TariffeRQ {
  oidPortaleXAlbergo: number;
  codiciTariffe: string[];

  constructor(oidPortaleXAlbergo: number) {
    this.oidPortaleXAlbergo = oidPortaleXAlbergo;
  }
}

export class TariffeRS {
  data: { tariffe: TariffaOTA[] };
}

export class ImportaRisorseRQ {
  oidPortale: number;
  risorse: TipoCameraOTA[];
}

export class ImportaRisorseRS extends WebApiResponse {
  data: {
    risorse: TipoCameraOTA[],
    associazioniTipiCamereTariffe: AssociazioneTipoCameraTariffe[]
  };
}

export class ImportaTariffeRQ {
  oidPortale: number;
  tariffe: TariffaOTA[];
}

export class ImportaTariffeRS extends WebApiResponse {
  data: {
    tariffe: TariffaOTA[],
    risorseTariffe: TariffaOTAXTipoCameraOTA[],
    associazioniTipiCamereTariffe: AssociazioneTipoCameraTariffe[]
  };
}

export class GetDashboardRQ {
  oidAlbergo: number;
  oidUbicazioneIstat: number;
  tipoDatoPrenotazioni: TipoDatoPrenotazioniDashboard;
  tipoDatoPreventivi: TipoDatoPreventiviDashboard;
  oidTipoCamera: number;
  isRaggruppaPerMese: boolean;
  dal: string;
  al: string;
  isFiltraArrivo: boolean;
}

export class GetTotaliPrenotazioniDashboardRS extends WebApiResponse {
  data: TotaliPrenotazioniDashboardRS;
}

export class GetInfoDashboard {
  codiceWeb: string;
  dataUltimaPubblicazioneDisponibilitaHotel: string;
  dataUltimoAggiornamentoPrenotazioni: string;
  dataUltimaPubblicazione: string;
  tipoPubblicazioneAttivitaAutomatica: string;
  ultimoErroreAttivitaAutomatica: string;
  dataUltimoErroreAttivitaAutomatica: string;
  oidErrore: number;
}

export class GetInfoDashboardRS extends WebApiResponse {
  data: GetInfoDashboard;
}

export class TotaliPrenotazioniDashboardRS {
  prenotazioni: number;
  roomNight: number;
  pax: number;
  roomRevenue: number;
  extraRevenue: number;
  ADR: number;
}

export class PrenotazioneDashboardRS {
  name: string;
  prenotazioni: number;
  roomNight: number;
  pax: number;
  roomRevenue: number;
  extraRevenue: number;
  ADR: number;
  percentuale: number;
}

export class GetPrenotazioniDashboardRS extends WebApiResponse {
  data: {
    prenotazioni: PrenotazioneDashboardRS[],
    grafico: NgxChart
  };
}

export class PreventivoDashboardRS {
  name: string;
  preventivi: number;
  prenotazioni: number;
  percentualeConversione: number;
  roomNight: number;
  pax: number;
  revenue: number;
  ADR: number;
  percentuale: number;
}

export class GetPreventiviDashboardRS extends WebApiResponse {
  data: {
    preventivi: PreventivoDashboardRS[],
    grafico: NgxChart
  };
}

export class DisponibilitaDataDashboardRS {
  data: string;
  disponibili: number;
}

export class DisponibilitaDashboardRS {
  tipoCamera: string;
  date: DisponibilitaDataDashboardRS[];
}

export class GetDisponibilitaDashboardRS extends WebApiResponse {
  data: DisponibilitaDashboardRS[];
}

export class GetDisponibilitaPrezziDashboardRS extends WebApiResponse {
  data: NgxAdvancedChart;
}

export class GetNotificheEmailDashboardRS extends WebApiResponse {
  data: NgxAdvancedChart;
}

export class GetChiusureGiornaliereDashboardRS extends WebApiResponse {
  data: NgxAdvancedChart;
}

export class GetDashboardAdminRQ {
  dal: string;
  al: string;
  isFiltraArrivo: boolean;
}

export class GetAlberghiDashboardAdminRS extends WebApiResponse {
  data: AlberghiDashboardAdminRS;
}

export class AlberghiDashboardAdminRS {
  numero: number;
  numeroPortali: number;
  numeroRicercheWeb: number;
  grafico: NgxChart;
}

export class NumeroPrenotazioniDashboardAdminRS {
  tipo: TipoPrenotazione;
  numero: number;
  totale: number;
}

export class GetPrenotazioniDashboardAdminRS extends WebApiResponse {
  data: NumeroPrenotazioniDashboardAdminRS[];
}

export class NumeroTransazioniDashboardAdminRS {
  tipo: TipoModalitaPagamento;
  numero: number;
  importo: number;
}

export class GetTransazioniDashboardAdminRS extends WebApiResponse {
  data: NumeroTransazioniDashboardAdminRS[];
}

export class GetNumeroPreventiviDashboardAdminRS extends WebApiResponse {
  data: {
    numeroAlberghiCrm: number,
    numeroCreati: number,
    numeroInviati: number
  };
}

export class GetNumeroSondaggiDashboardAdminRS extends WebApiResponse {
  data: {
    numero: number,
    numeroRisposte: number
  };
}

export class NumeroNotificheEmailDashboardAdminRS {
  tipo: TipoNotificaEmail;
  numero: number;
}

export class GetNotificheEmailDashboardAdminRS extends WebApiResponse {
  data: NumeroNotificheEmailDashboardAdminRS[];
}

export class NumeroPortaliDashboardAdminRS {
  nome: string;
  numero: number;
}

export class GetPortaliDashboardAdminRS extends WebApiResponse {
  data: NumeroPortaliDashboardAdminRS[];
}

export class GetErroriDashboardAdminRS extends WebApiResponse {
  data: {
    numero: number,
    errori: NumeroErroriPortaleDashboardAdminRS[]
  };
}

export class NumeroErroriPortaleDashboardAdminRS {
  descrizione: string;
  numero: number;
}

export class GetTariffeCollegateRQ {
  tipoCameraOid: number;

  constructor(tipoCameraOid: number) {
    this.tipoCameraOid = tipoCameraOid;
  }
}

export class GetTariffeCollegateRS extends WebApiResponse {
  data: ViewTipoCameraTariffa[];
}

export class SetSondaggiXLinguaRQ {
  sondaggio: Sondaggio;
  sondaggiXLingua: SondaggioXLingua[];
  domande: SetDomandeXLinguaRQ[];

  constructor() {
    this.sondaggio = new Sondaggio();
    this.sondaggiXLingua = [];
    this.domande = [];
  }
}

export class SetDomandeXLinguaRQ {
  domanda: SondaggioDomanda
  domandeXLingua: SondaggioDomandaXLingua[];
}

export class GetDomandeXLinguaRS {
  domanda: SondaggioDomanda;
  domandeXLingua: SondaggioDomandaXLingua[];
}

export class GetSondaggiXLinguaRS extends WebApiResponse {
  data: {
    sondaggi: SondaggioXLingua[],
    domande: GetDomandeXLinguaRS[]
  };
}

export class DomandaRispostaSondaggio {
  domanda: string;
  risposta: string;
  numeroStelle: number;
  numeroFaccine: number;
}

export class GetSondaggioPrenotazioneRQ {
  uid: string;
  oidPrenotazione: number;
  isMobile: boolean;
  lingua: string;
}

export class GetSondaggioPrenotazioneDomandaRS {
  tipo: TipoDomandaSondaggio;
  isObbligatoria: boolean;
  titolo: string;
  valori: string;
  valoriArray: string[];
  valoriArraySelected: string[];
  numeroStelle: number;
  numeroStelleHover: number;
}

export class PortaleSondaggioPrenotazione {
  nome: string;
  nomeStruttura: string;
  urlImmagineSfondo: string;
  urlImmagineLogo: string;
  urlIFrameGoogleMap: string;
  email: string;
  telefono: string;
  indirizzo: string;
  cap: string;
  citta: string;
  provincia: string;
  oidUbicazioneIstat: number;
}

export class GetSondaggioPrenotazioneRS extends WebApiResponse {
  data: {
    risposta: SondaggioRisposta,
    sondaggio: SondaggioXLingua,
    domande: GetSondaggioPrenotazioneDomandaRS[],
    portale: PortaleSondaggioPrenotazione,
    sogliaPunteggio: number,
    traduzioni: string,
    oidAlbergo: number
  };
}

export class SetTransazioneRQ {
  oid: number;
  isErrore: boolean;
  descrizioneEsito: string;
  token: string;
  isNotificaGestionale: boolean;
  oidModalitaPagamento: number;
  statoEsecuzione: StatoEsecuzioneTransazione;
  statoContabilizzazione: StatoContabilizzazione;
  oidTransazioneEseguita: number;
  numeroCarta: string;
  codiceSicurezza: string;
  scadenzaCartaMese: number;
  scadenzaCartaAnno: number;
  titolareCarta: string;
  codiceRiferimentoOperazione: string;
}

export class AutocompleteDataLoader {
  dataLoader: Observable<WebApiResponseFilter>;

  constructor(dataLoader: Observable<WebApiResponseFilter>) {
    this.dataLoader = dataLoader;
  }
}

export class MyForecast {
  oid: number;
  nome: string;
  url: string;
  stato: StatoMyForecast;
}

export class DerivedPriceModel {
  derivedPrices: DerivedPrice[];
}

export class DerivedPrice {
  id: string;
  persone: number;
  variazione: number;
  tipoVariazione: TipoValore;
}

export class PubblicaDerivedPricesRQ {
  oidTariffaOTAXTipoCameraOTA: number;
}

export class PubblicaDerivedPricesRS {
  tipoEsito: number;
  dettaglioErrore: string;
  dettaglioWarning: string;
}

export class GetRoomingListRQ {
  uid: string;
  isMobile: boolean;
  lingua: string;
}

export class PrenotazioneRoomingList {
  prenotazione: Prenotazione;
  ospiti: ComponenteXPrenotazione[];
  expanded: boolean;
  isCheckInPossibile: boolean;
}

export class AlbergoRoomingList {
  oid: number;
  nome: string;
}

export class PortaleRoomingList {
  nome: string;
  nomeStruttura: string;
  urlImmagineSfondo: string;
  urlImmagineLogo: string;
  urlIFrameGoogleMap: string;
  email: string;
  telefono: string;
  indirizzo: string;
  cap: string;
  citta: string;
  provincia: string;
  isVisualizzaTuttiDatiSelfCheckIn: boolean;
  isBloccaModificaDatiCheckIn: boolean;
  orarioDiArrivoMinimo: string;
  orarioDiArrivoMassimo: string;
  campiObbligatori: CampoObbligatorioSelfCheckIn[];
}

export class GetRoomingListRS extends WebApiResponse {
  data: {
    roomingList: RoomingList,
    password: string,
    lingua: string,
    prenotazioni: PrenotazioneRoomingList[],
    portale: PortaleRoomingList,
    albergo: AlbergoRoomingList
  }
}

export class SincronizzaDisponibilitaRQ {
  oidPortale: number;
  dal: string;
  al: string;
  isAggiornaPrezzo: boolean;
}

export class EseguiWorkFlowPreventivoRQ {
  oidPreventivo: number;
  oidWorkFlow: number;
}

export class EseguiWorkFlowPreventivoRS extends WebApiResponse {
  data: { workFlowsEseguiti: WorkFlow[] };
}

export class EseguiWorkFlowPrenotazioneRQ {
  oidPrenotazione: number;
  oidWorkFlow: number;
}

export class EseguiWorkFlowPrenotazioneRS extends WebApiResponse {
  data: { workFlowsEseguiti: WorkFlow[] };
}

export class WorkFlowDetailRS extends WebApiResponse {
  data: {
    ultimeEsecuzioni: WorkFlowDetail[],
    prossimeEsecuzioni: WorkFlowDetail[]
  };
}

export class WorkFlowDetail {
  data: string;
  descrizione: string;
}

export class GetOfferRQ {
  oidPromozione: number;
  lingua: string;
  isMobile: boolean;
}

export class PortaleOffer {
  oid: number;
  nome: string;
  nomeStruttura: string;
  urlImmagineSfondo: string;
  urlImmagineLogo: string;
  urlIFrameGoogleMap: string;
  email: string;
  telefono: string;
  indirizzo: string;
  cap: string;
  citta: string;
  provincia: string;
}

export class OfferRS {
  oid: number;
  nome: string;
  descrizione: string;
  descrizioneDettagliata: string;
  codice: string;
  urlImmagineEvidenza: string;
  validaDal: string;
  validaAl: string;
  prenotabileDal: string;
  prenotabileAl: string;
}

export class GetOfferRS extends WebApiResponse {
  data: {
    promozione: OfferRS,
    portale: PortaleOffer
  };
}

export class VerificaCartaCreditoRQ {
  oidAlbergo: number;
  oidPortaleXAlbergo: number;
  intestatarioCC: string;
  numeroCC: string;
  tipoCartaCC: string;
  annoCC: number;
  meseCC: number;
  codiceSicurezzaCC: string;
}

export class VerificaCartaCreditoRS extends WebApiResponse {
  data: { tipoEsito: number, dettaglioErrore: string };
}

export class CalcolaPrezziOutput {
  proposta: UpdateDettagliFromBookingSolutionRQ;
  arrivo: string;
  partenza: string;
}

export class GiornoListino {
  data: string;
  prezzo: number;
  oidTariffa: number;

  constructor(data?: string, prezzo?: number, oidTariffa?: number) {
    this.data = data;
    this.prezzo = prezzo;
    this.oidTariffa = oidTariffa;
  }
}

export class ReplaceTagsTemplateRQ {
  oidLingua: number;
  oidTemplate: number;
  uidPreventivo: string;
  oidPreventivo: number;
  oidPrenotazioni: number[];
  oidRichiesta: number;
  oidCliente: number;
  oidTransazione: number;
  oidRisposta: number;
  oidPrenotazioneExtra: number;
  oidComponente: number;
  oidVoucher: number;
  oidAlbergo: number;
}

export class ReplaceTagsTemplateRS extends WebApiResponse {
  data: {
    titolo: string,
    testo: string
  }
}

export class GetLogOperazioneDettagliRQ {
  oidAlbergo: number;
  oidOperazione: number;
}

export class GetLogOperazioneDettagliRS extends WebApiResponse {
  data: {
    richiesta: string,
    risposta: string
  }
}

export class SendTestEmailRS extends WebApiResponse {
  data: {
    success: boolean,
    message: string
  }
}

export class SendSmsRQ {
  oidApiKey: number;
  mittente: string;
  numero: string;
  testo: string;
}

export class SendSmsRS extends WebApiResponse {
  data: { success: boolean; };
}

export class GetPortaleXAlbergoFormRQ {
  oidPortaleXAlbergo?: number;
}

export class GetPortaleXAlbergoForm {
  isCanActivateGoogleHotelsTravel: boolean;
  countries: ViewCultureInfoDto[];
  oidPortalePassepartout: number;
  codiciTrattamento: TariffaOTAXPortale[];
}

export class GetPortaleXAlbergoFormRS extends WebApiResponse {
  data: GetPortaleXAlbergoForm;
}

export class ViewCultureInfoDto {
  twoLetterISOLanguageName: string;
  displayName: string;
  englishName: string;
  data: { success: boolean };
}

export class TrentinoRQ {
  oidApiKey: number;
}

export class TrentinoRS extends WebApiResponse {
  data: {
    esito: boolean,
    qrCode: string,
    motivo: string[]
  };
}

export class TrentinoCard {
  qrCode: string;
  idTipologiaCard: number;
  tipologiaCard: string;
  dataInizioValidita: string;
  scadenzaAssolutaCard: string;
  dataEmissione: string;
  personeMax: number;
  nAdulti: number;
  nBambini: number;
  elEtaBambini: number[];
  extraSfwAlbergatori: string;
  attiva: boolean
  completa: boolean;
}

export class TrentinoCardType {
  idTipologiaCard: number;
  tipologiaCard: string;
}

export class TrentinoGetTipiCarteRQ extends TrentinoRQ { }

export class TrentinoGetTipiCarteRS extends WebApiResponse {
  data: TrentinoCardType[];
}

export class TrentinoLeggiCarteRQ extends TrentinoRQ {
  dal: string;
  al: string;
  page: number;
  recordPP: number;
}

export class TrentinoLeggiCarteRS extends WebApiResponse {
  data: {
    nRecord: number,
    recordPP: number,
    currentPage: number,
    totalPages: number,
    data: TrentinoCard[]
  };
}

export class TrentinoEmettiCartaRQ extends TrentinoRQ {
  idTipologiaCard: number;
  dal: string;
  al: string;
  email: string;
  personeMax: number;
}

export class TrentinoEmettiCartaRS extends TrentinoRS { }

export class TrentinoAttivaDisattivaCartaRQ extends TrentinoRQ {
  qrCode: string;
  isAttiva: boolean;
}

export class TrentinoAttivaDisattivaCartaRS extends TrentinoRS { }

export class TrentinoModificaCartaRQ extends TrentinoRQ {
  qrCode: string;
  dal: string;
  al: string;
  anniMinori: string;
  extraSftAlbergatori: string;
  idTipologiaCard: number;
  nAdulti: number;
}

export class TrentinoModificaCartaRS extends TrentinoRS { }

export class VerificaCodicePromozioneRQ {
  oidAlbergo: number;
  oidPortale: number;
  codice: string;
  extras: ExtraBooking[];
}

export class VerificaCodicePromozioneRS extends WebApiResponse {
  data: {
    oidCodicePromozione: number,
    sconto: number,
    extras: ExtraBooking[];
  };
}

export class VerificaVoucherRQ {
  oidAlbergo: number;
  oidPortale: number;
  codice: string;
  email: string;
  arrivo: string;
}

export class VerificaVoucherRS extends WebApiResponse {
  data: {
    oidVoucher: number,
    sconto: number
  };
}

export class CreaPrenotazioneExtraRQ {
  oidPrenotazione: number;
  articoli: ArticoloMySelf[];
  pagamento: PaymentModel;
  isUpSelling: boolean;
}

export class CreaPrenotazioneExtraRS extends WebApiResponse {
  data: { success: boolean };
}

export class RichiediCancellazionePrenotazioneRQ {
  oidPrenotazioni: number[];
  noteCancellazione: string;
}

export class RichiediUpSellingPrenotazioneRQ {
  oidPrenotazione: number;
  oidTipoCamera: number;
  prezzo: number;
}

export class RichiediUpSellingPrenotazioneRS {
  data: { success: boolean };
}

export class UpdatePaxPreventivoRQ {
  oidPreventivo: number;
  camere: UpdatePaxPreventivoRichiestaCameraRQ[];
}

export class UpdatePaxRichiestaRQ {
  oidRichiesta: number;
  camere: UpdatePaxPreventivoRichiestaCameraRQ[];
}

export class UpdatePaxPreventivoRichiestaCameraRQ {
  pax: RichiestaPreventivoPax[];
  isDeleted: boolean;
}

export class RichiestaPreventivoPax {
  quantita: number;
  tipo: TipoComponentePrenotazione;
  anni: number;
  riduzione: Riduzione;
}

export class CheckDisponibilitaFuturePubblicateRQ {
  oidPortale: number;
  oidTariffa: number;
  oidRisorsa: number;
}

export class InviaPrenotazioniRQ {
  oidApiKey: number;
  oidPrenotazioni: number[];
}

export class InviaPrenotazioniRS extends WebApiResponse {
  data: { success: boolean };
}

export class QualitelisInviaPrenotazioniRQ extends InviaPrenotazioniRQ { }

export class QualitelisInviaPrenotazioniRS extends InviaPrenotazioniRS { }

export class TrustyouInviaPrenotazioniRQ extends InviaPrenotazioniRQ { }

export class TrustyouInviaPrenotazioniRS extends WebApiResponse {
  data: { success: boolean, csv: string };
}

export class ScrollideaInviaPrenotazioniRQ extends InviaPrenotazioniRQ { }

export class ScrollideaInviaPrenotazioniRS extends InviaPrenotazioniRS { }

export class PhilipsCMNDInviaPrenotazioniRQ extends InviaPrenotazioniRQ { }

export class PhilipsCMNDInviaPrenotazioniRS extends InviaPrenotazioniRS { }

/*export class HoauInviaPrenotazioniRQ extends InviaPrenotazioniRQ { }

export class HoauInviaPrenotazioniRS extends InviaPrenotazioniRS { }*/

export class InviaClientiRQ {
  oidApiKey: number;
  oidClienti: number[];
}

export class InviaClientiRS extends WebApiResponse {
  data: { success: boolean };
}

export class MailchimpInviaClientiRQ extends InviaClientiRQ { }

export class MailchimpInviaClientiRS extends InviaClientiRS { }

export class ActiveCampaignInviaClientiRQ extends InviaClientiRQ { }

export class ActiveCampaignInviaClientiRS extends InviaClientiRS { }

export class HubSpotInviaClientiRQ extends InviaClientiRQ { }

export class HubSpotInviaClientiRS extends InviaClientiRS { }

export class TestMailRQ {
  oid: number;
  email: string;
  oidAlbergo: number;
  oidTemplate: number;
}

export class GetModalitaPagamentoDefaultRQ {
  lingua: string;
  oidAlbergo: number;
}

export class InviaEmailVoucherRQ {
  oidVoucher: number;
  oidPrenotazione: number;
  oidTemplate: number;
  oggetto: string;
  testo: string;
  cc: string;
  replaceTags: boolean;
}

export class InviaEmailVoucherRS extends WebApiResponse {
  data: { success: boolean };
}

export class DetailAlbergoMasterRS extends WebApiResponse {
  data: {
    immagini: AlbergoMasterImmagini[],
    portaliCollegati: PortaleXAlbergo[]
  };
}

export class DetailServizioDmsRS extends WebApiResponse {
  data: {
    serviziCollegati: Servizio[]
  };
}

export class UpdatePianoTariffarioRQ {
  pianoTariffario: PianoTariffario;
  dettagli: DettaglioPianoTariffario[];
}

export class CopiaDisponibilitaRQ {
  oidPortale: number;
  dalDa: string;
  alDa: string;
  dalA: string;
  alA: string;
  giorni: DayOfWeeks;
  oidTipiCamera: number[];
  oidTariffe: number[];
  oidTariffaDa: number;
  oidTariffaA: number;
  isCopiaSingolaTariffa: boolean;
  isCopiaDurataMinimaMassimaSoggiorno: boolean;
  isAzzeraPrenotate: boolean;
  variazionePrezzo: number;
  tipoVariazionePrezzo: TipoValore;
  isApplicaPrezzoListino: boolean;
  isBloccaPrezzo: boolean;

  constructor() {
    this.oidTipiCamera = [];
    this.oidTariffe = [];
    this.isCopiaDurataMinimaMassimaSoggiorno = false;
    this.variazionePrezzo = 0;
    this.tipoVariazionePrezzo = TipoValore.Euro;
    this.isApplicaPrezzoListino = false;
    this.isBloccaPrezzo = null;
  }
}

export class DmsSearchEvent {
  portali: ImmaginiXPortale[];
  arrivo: string;
  partenza: string;
  camere: BookingSolutionRoomRQ[];
}

export class GetMailRQ {
  folder: string;
  skip: number;
  take: number;
  subject: string;
}

export class MailFolder {
  name: string;
  fullName: string;
  messageNotSeenCount: number;
  isInbox: boolean;
  isAllEmails: boolean;
  folders: MailFolder[];
}

export class MailMessage {
  id: number;
  subject: string;
  body: string;
  isBodyHtml: boolean;
  from: string;
  fromDisplayName: string;
  replyTo: string;
  date: string;
  isSeen: boolean;
}

export class GetMailRS extends WebApiResponse {
  data: {
    folders: MailFolder[],
    messages: MailMessage[],
    messageCount: number
  };
}

export class DeleteMailRQ {
  folder: string;
  id: number;
  ids: number[];
}

export class SetMailAsSeenRQ {
  folder: string;
  id: number;
  isSeen: boolean;
}

export class MoveMailRQ {
  folder: string;
  moveToFolder: string;
  id: number;
}

export class SendMailRQ {
  titolo: string;
  testo: string;
  email: string;
  to: string;
  emailCCn: string;
}

export class SendMailRS extends WebApiResponse {
  data: {
    success: boolean;
    errore: string;
  };
}

export class ViewTipoCameraTariffa {
  portaleXAlbergo: PortaleXAlbergo;
  tipoCameraOTA: TipoCameraOTA;
  tariffaOTA: TariffaOTA;
  note: string;
  isValid: boolean;
}

export class GetConfigurazioneMaster {
  tipoCamera: TipoCameraOTA;
  viewTipoCamereTariffe: ViewTipoCameraTariffa[];
  hidden: boolean;
}

export class GetConfigurazioneMasterRS extends WebApiResponse {
  data: GetConfigurazioneMaster[];
}

export class CheckTemplatesPrenotazioneRS extends WebApiResponse {
  data: {
    templatePrenotazione: Template,
    templatePrenotazioneConfermata: Template,
    templatePrenotazioneECommmerce: Template
  };
}

export class GetServiziRQ {
  nome: string;
  oidAlbergo: number;
}

export class PrenotazioneAssociataRS {
  prenotazione: Prenotazione;
  ospiti: ComponenteXPrenotazione[];
}

export class GetPrenotazioniAssociateRS extends WebApiResponse {
  data: PrenotazioneAssociataRS[];
}

export class CreaPrenotazioneTransazioneRQ {
  prenotazioni: Prenotazione[];
  oidTransazione: number;
  oidPreventivo: number;
  codicePreventivo: string;
}

export class CreaPrenotazioneTransazioneRS extends WebApiResponse {
  data: { success: boolean };
}

export class GetStoricoRQ {
  dal: string;
  al: string;
  tipoDato: TipoDatoStorico;
}

export class GetStoricoRS extends WebApiResponse {
  data: {
    dati: Storico[],
    datiAnnoPrecedente: Storico[],
    grafico: NgxAdvancedChart
  };
}

export class PortaleUnsubscribe {
  oid: number;
  nome: string;
  nomeStruttura: string;
  urlImmagineSfondo: string;
  urlImmagineLogo: string;
  urlIFrameGoogleMap: string;
  email: string;
  telefono: string;
  indirizzo: string;
  cap: string;
  citta: string;
  provincia: string;
}

export class ClienteUnsubscribe {
  oid: number;
  nome: string;
  cognome: string;
  email: string;
  cellulare: string;
  lingua: string;
  isSubscribed: boolean;
}

export class GetUnsubscribeRS extends WebApiResponse {
  data: {
    portale: PortaleUnsubscribe,
    cliente: ClienteUnsubscribe
  };
}

export class GetUnsubscribeRQ {
  uid: string;
  isMobile: boolean;
}

export class ArchiviaPreventiviRQ {
  oidPreventivi: number[];
}

export class CancellaPreventiviRQ {
  oidPreventivi: number[];
  oidCausale: number;
}

export class InviaMessaggioPreventiviRQ {
  oidPreventivi: number[];
  testo: string;
}

export class RiduzioneLingua {
  riduzione: Riduzione;
  riduzioniXLingua: ArticoloXLingua[];
}

export class PreventiviViewRS extends WebApiResponse {
  data: {
    contenuti: Template[],
    articoli: Articolo[],
    causaliOperazioneCancellazione: CausaleOperazione[],
    causaliOperazioneRifiuto: CausaleOperazione[],
    riduzioni: RiduzioneLingua[],
    isAttivaSelezionaCamera: boolean
  }
}

export class GetPagineDmsRQ {
  oidAlbergo: number;
  lingua: string;
}

export class GetTagsTemplateRQ {
  tipoTemplate: TipoTemplate;
}

export class PlanningMasterRQ {
  dal: string;
  al: string;
  oidTipoCamera: number;
  oidTrattamento: number;
  filtroTipiCameraTariffe: FiltroTipoCameraTariffe[];
  oidAlbergo: number;
  oidPortaleXAlbergo: number;
}

export class PlanningMaster {
  tipiCamere: PlanningTipoCameraMasterRS[];
  giorni: string[];
  giorniChiusura: GiorniChiusura[];
  eventi: EventoPlanning[];
  filtri: PortaleXAlbergoFiltri[];
}

export class PlanningMasterRS extends WebApiResponse {
  data: PlanningMaster;
}

export class PlanningTipoCameraMasterRS {
  oid: number;
  nome: string;
  tipoCameraHotel: string;
  disponibiliMassime: number;
  ordinamento: number;
  portali: PlanningMasterPortaleRS[];
  tariffe: PlanningMasterTariffaRS[];
  giorni: PlanningGiornoTipoCameraMasterRS[];
}

export class PlanningGiornoTipoCameraMasterRS {
  data: string;
  disponibili: number;
  stato: StatoPortaleXAlbergo;
  empty: boolean;
}

export class PlanningMasterTariffaRS {
  oid: number;
  nome: string;
  ordinamento: number;
  portaliTipiCamera: PlanningMasterPortaleTipoCameraRS[];
}

export class PlanningMasterPortaleTipoCameraRS {
  portale: PortaleXAlbergo;
  tipoCamera: TipoCameraOTA;
}

export class PlanningMasterPortaleRS {
  oid: number;
  nome: string;
  icona: string;
  ordinamento: number;
  hidden: boolean;
  tipiCameraTariffe: PlanningMasterPrezziTipoCameraTariffaRS[];
}

export class PlanningMasterPrezziTipoCameraTariffaRS {
  tipoCamera: TipoCameraOTA;
  tariffa: TariffaOTA;
  giorni: PlanningMasterGiornoTipoCameraTariffaRS[];
}

export class PlanningMasterGiornoTipoCameraTariffaRS {
  oid: number;
  data: string;
  disponibili: number;
  prezzo: number;
  stato: StatoPortaleXAlbergo;
  statoPubblicazione: StatoPubblicazionePortale;
  durataMinimaSoggiorno: number;
  durataMassimaSoggiorno: number;
  statoCta: StatoCtaCtd;
  statoCtd: StatoCtaCtd;
  prezzoUsoSingola: number;
  fascia: Fascia;
  isStatoBloccato: boolean;
  isPrezzoBloccato: boolean;
  empty: boolean;
}

export class LogPrenotazione {
  data: string;
  dataVisualizzata: string;
  logOperazione: LogOperazionePortaleXAlbergo;
  logDisponibilita: LogDisponibilitaPortaleXAlbergo;
  logNotifica: NotificaEmail;

  constructor(data: string, dataVisualizzata: string, logOperazione?: LogOperazionePortaleXAlbergo, logDisponibilita?: LogDisponibilitaPortaleXAlbergo, logNotifica?: NotificaEmail) {
    this.data = data;
    this.dataVisualizzata = dataVisualizzata;
    this.logOperazione = logOperazione;
    this.logDisponibilita = logDisponibilita;
    this.logNotifica = logNotifica;
  }
}

export class VerificaCodiceMasterRQ {
  codiceMaster: string;

  constructor(codiceMaster: string) {
    this.codiceMaster = codiceMaster;
  }
}

export class GetRecensioniRQ {
  oidPortale: number;
  lingua: string;
}

export class StoricoCliente {
  oid: number;
  uid: string;
  codice: string;
  data: string;
  arrivo: string;
  partenza: string;
  totale: number;
  tipo: TipoStoricoCliente;
  stato: string;
}

export class GetPreventiviClienteRQ {
  oidCliente: number;
  oidDaEscludere: number;
}

export class PropostaCalcolaPrezzi {
  oidTipoCamera: number;
  tariffe: BookingSolutionRateRS[];
}

export class UpdateDettagliFromBookingSolutionRQ {
  oidProposta: number;
  oidTipoCamera: number;
  tariffa: BookingSolutionRateRS;
}

export class AllegatiOutput {
  allegati: Allegato[];
  allegatiAggiunti: number[];
  allegatiEliminati: number[];

  constructor() {
    this.allegati = [];
    this.allegatiAggiunti = [];
    this.allegatiEliminati = [];
  }
}

export class SetErroreEsaminatoRQ {
  oid: number;
}

export class WelcomeServerRequest {
  oidAlbergo: number;
  dominio: string;
  server: string;
  porta: string;
  database: string;
  //token: string;
  urlApiWelcome: string;
}

export class WelcomeServerAuthenticateRQ extends WelcomeServerRequest {
  username: string;
  password: string;
  passwordCrypted: string;
  idClientApp: string;
  isGeneraToken: boolean;
}

export class WelcomeServerAuthenticateUtenteRS {
  token: string;
}

export class WelcomeServerAuthenticateAlbergoRS {
  oidAlbergoWeb: number;
}

export class WelcomeServerAuthenticateRS {
  utente: WelcomeServerAuthenticateUtenteRS;
  albergo: WelcomeServerAuthenticateAlbergoRS;
  authToken: string;
}

export class GetCamereLibereWelcomeRQ extends WelcomeServerRequest {
  dal: string;
  al: string;
  oidUbicazioneIstat: number;
  oidTipoCamera: number;
}

export class CameraLiberaGiorno {
  data: string;
  isCameraLibera: boolean;
}

export class GiorniLiberiRisorsa {
  risorsa: Risorsa;
  giorni: CameraLiberaGiorno[];
}

export class GetCamereLibereWelcomeRS {
  risorse: GiorniLiberiRisorsa[];
}

export class GetInfoDisponibilita {
  listino: string;
  trattamento: string;
  variazioniXTipoPasto: string[];
  variazioniXTrattamento: string[];
  isModificaDisponibiliAttiva: boolean;
}

export class GetInfoDisponibilitaRS extends WebApiResponse {
  data: GetInfoDisponibilita;
}

export class GetArticoliMySelfRQ {
  oidArticoli: number[];
  oidPrenotazione: number;
  lingua: string;
}

export class TestConnectionRQ {
  oidPortaleXAlbergo: number;

  constructor(oidPortaleXAlbergo: number) {
    this.oidPortaleXAlbergo = oidPortaleXAlbergo;
  }
}

export class SbmRS {
  tipoEsito: TipoEsitoSbm;
  descrizione: string;
  dettaglioErrore: string;
  dettaglioWarning: string;
  errori: ErroreSbm[];
  warnings: WarningSbm[];
}

export class TestConnectionData extends SbmRS {
  isTestOk: boolean;
  isErrorResponse: boolean;
}

export class TestConnectionRS extends WebApiResponse {
  data: TestConnectionData;
}

export class ErroreSbm {
  nomePortale: string;
  codice: string;
  docUrl: string;
  linguaggio: string;
  nodeList: string;
  recordID: string;
  status: string;
  valore: string;
  tag: string;
  type: string;
}

export class WarningSbm {
  nomePortale: string;
  codice: string;
  docUrl: string;
  linguaggio: string;
  recordID: string;
  status: string;
  valore: string;
  tag: string;
  type: string;
}

export class MeseCalendarioMenu {
  giorni: UbicazioneIstatMenu[];
}

export class GetCalendarioMenuRS extends WebApiResponse {
  data: {
    mesi: MeseCalendarioMenu[]
  };
}

export class GetCalendarioMenuRQ {
  year: number;
  oidUbicazioneIstat: number;
}

export class ModificaMultiplaMenuGiorniRQ {
  dal: string;
  al: string;
  giorni: DayOfWeeks;
  menu: Menu;
  oidAlbergo: number;
  oidUbicazioneIstat: number;
}

export class CalendarioMenuEventsDataSource implements CalendarEventsDataSource {
  events: CalendarEvent[];

  constructor() {
    this.events = [];
  }

  getEventToDisplay(calendarDate: CalendarDate): CalendarEvent {
    if (calendarDate != null && calendarDate.events != null && calendarDate.events.length > 0) {
      return calendarDate.events[0];
    }

    return null;
  }
}

export class GetCalendarioMenuViewRQ {
  oidAlbergo: number;
}

export class GetCalendarioMenuViewRS extends WebApiResponse {
  data: {
    ubicazioniIstat: UbicazioneIstat[],
    menu: Menu[]
  };
}

export class GetTrasferisciPrenotazioniViewRQ {
  oidPortale: number;
}

export class GetTrasferisciPrenotazioniViewRS extends WebApiResponse {
  data: {
    tipiCamera: TipoCameraOTA[],
    tariffe: TariffaOTA[]
  };
}

export class TrasferisciPrenotazioneRQ {
  oidPrenotazione: number;
  oidTipoCamera: number;
  oidTariffa: number;
  noteTrasferimento: string;
  disponibili: number;
  totale: number;
  totaleNuovaPrenotazione: number;
}

export class TrasferisciPrenotazioniRQ {
  oidPortale: number;
  oidTemplate: number;
  prenotazioni: TrasferisciPrenotazioneRQ[];

  constructor() {
    this.prenotazioni = [];
  }
}

export class GetDisponibiliCrsRQ {
  oidPrenotazione: number;
  oidTipoCamera: number;
  oidTariffa: number;
  oidPortale: number;
}

export class GetDisponibiliCrsRS extends WebApiResponse {
  data: {
    disponibili: number,
    totale: number
  };
}

export class GetPlanningDisponibilitaCrsRQ {
  dal: string;
  al: string;
  nomeTipoCamera: string;
  nomeTipoCameraStandard: string;
  oidAlberghi: number[];

  constructor() {
    this.oidAlberghi = [];
  }
}

export class GetPlanningDisponibilitaCrsGiornoRS {
  data: string;
  disponibili: number;
}

export class GetPlanningDisponibilitaCrsTipoCameraRS {
  descrizione: string;
  giorni: GetPlanningDisponibilitaCrsGiornoRS[];
}

export class GetPlanningDisponibilitaCrsPortaleRS {
  nome: string;
  icona: string;
  tipiCamera: GetPlanningDisponibilitaCrsTipoCameraRS[];
}

export class GetPlanningDisponibilitaCrsRS extends WebApiResponse {
  data: {
    giorni: string[],
    portali: GetPlanningDisponibilitaCrsPortaleRS[]
  };
}

export class GetPrenotazioneDetailsMySelfRQ {
  oidPrenotazione: number;
  lingua: string;
}

export class GetPrenotazioneDetailsMySelfRS extends WebApiResponse {
  data: {
    giorniMenu: GiornoMenuMySelf[],
    articoliUpSelling: ArticoliXVoceAddebitoMySelf[],
    articoliRoomService: ArticoliXVoceAddebitoMySelf[],
    estrattoConto: VoceEstrattoConto[],
    upSellingRooms: BookingSolutionRoomRS[],
    dataUpSelling: string,
    cameraUpSelling: string,
    articoli: ArticoloMySelf[]
  };
}

export class OrdinaPiattiMySelfRQ {
  oidPrenotazione: number;
  data: string;
  piatti: PiattiXTipoPastoMySelf[];
}

export class CancellaOrdinePiattiMySelfRQ {
  oidOrdiniPiatti: number[];
}

export class LogPreventivo {
  cambioStato: PreventivoTimeLine;
  notificaEmail: NotificaEmail;
}

export class DetailPromozioneRS extends WebApiResponse {
  data: {
    quantitaPrenotata: number,
    dettagli: DettaglioPromozione[],
    prezzi: PrezziXArticoloRS[]
  };
}

export class UpdatePromozioneRQ {
  promozione: Promozione;
  promozioniXLingua: PromozioneXLingua[];
  dettagli: DettaglioPromozione[];
  periodi: PrezziXArticoloRS[];

  constructor() {
    this.promozione = new Promozione();
    this.promozioniXLingua = [];
    this.dettagli = [];
  }
}

export class UpdatePromozioneRS extends WebApiResponse {
  data: {
    promozione: Promozione,
    promozioniXLingua: PromozioneXLingua[],
    dettagli: DettaglioPromozione[],
    periodi: PrezziXArticoloRS[]
  };
}

export class DetailListinoRS extends WebApiResponse {
  data: {
    prezzi: PrezziXArticoloRS[]
  };
}

export class GetCreaPagamentoViewRQ {
  oidAlbergo: number;
  oidPrenotazione: number;
}

export class GetCreaPagamentoViewRS extends WebApiResponse {
  data: {
    modalitaPagamento: PaymentMethod[],
    importoPenaleCancellazione: number,
    totalePrenotazioneMultiCamera: number,
    totaleTassaSoggiornoMultiCamera: number,
    isVerificaCartaCredito: boolean;
    isVisualizzaCRO: boolean,
    tipiCarteCredito: TipoCartaCreditoXAlbergo[]
  };
}

export class GetModalitaPagamentoGestPayRQ {
  shopId: string;
}

export class GetTransazioneByIdRQ {
  idTransazione: string;
}

export class GiornoDettaglioSupplementoBooking {
  data: string;
  dettagli: DettaglioSupplementoBooking[];
}

export class DettaglioSupplementoBooking {
  indiceComponente: number;
  quantita: number;
  prezzo: number;
}

export class setDatiCheckInRQ {
  componente: ComponenteXPrenotazione;
  lingua: string;
}

export class setDatiCheckInMultipleRQ {
  componenti: ComponenteXPrenotazione[];
  lingua: string;
}

export class TagCrmLingua {
  tagCrm: TagCrm;
  tagCrmXLingua: TagCrmXLingua[];
}

export class CheckAlbergoRS extends WebApiResponse {
  data: {
    success: boolean,
    oidPortale: number,
    oidUbicazioneIstat: number
  };
}

export class CheckAlbergoMasterRS extends WebApiResponse {
  data: {
    success: boolean,
    oidAlbergo: number,
    oidPortale: number,
    oidUbicazioneIstat: number
  };
}

export class CheckPortaleRS extends WebApiResponse {
  data: {
    success: boolean,
    oidAlbergo: number,
    oidUbicazioneIstat: number
  };
}

export class VariazioniComponenteTipoCameraFilter {
  oidTipoCamera: number;
  adulti: number;
}

export class AddebitoPrenotazione {
  data: string;
  descrizione: string;
  totale: number;
  note: string;
}

export class UpdateFromDisponibiliHotelRQ {
  dal: string;
  al: string;
  oidPortale: number;
  giorni: DayOfWeeks;
  oidTipiCamera: number[];
  isAggiornaDisponibili: boolean;
  isAggiornaFascia: boolean;
  isBloccaPrezzo: boolean;
}

export class ChangeLogsXVersione {
  versione: string;
  changeLogs: ChangeLogsXData[];
}

export class ChangeLogsXData {
  data: string;
  changeLogs: ChangeLogsXCategoria[];
}

export class ChangeLogsXCategoria {
  categoria: string;
  changeLogs: string[];
}

export class GetStoricoPrenotazioneRQ {
  oidStoricoPrenotazione: number;
}

export class GetDetailPrenotazioneRQ {
  oidPrenotazione: number;
  isLeggiLog: boolean;

  constructor(oidPrenotazione: number) {
    this.oidPrenotazione = oidPrenotazione;
  }
}

export class StoricoPrenotazioneWSXML {
  arrivo: string;
  partenza: string;
  pax: number;
  importo: number;
  sconto: number;
  caparra: number;
  noteP: string;
  codiceTariffaOTA: string;
}

export class ImpostaModalitaPagamentoPrenotazioneRQ {
  oidPrenotazione: number;
  oidModalitaPagamento: number;
}

export class GetFunzionalitaPortaliRS extends WebApiResponse {
  data: {
    funzionalita: string[],
    funzionalitaXPortale: FunzionalitaXPortale[]
  };
}

export class FunzionalitaXPortale {
  portale: string;
  urlImmagineIcona: string;
  url: string;
  urlGetPrenotazioni: string;
  urlSetDisponibilita: string;
  funzionalita: PortaleParametri[];
}

export class GetCodiciPromozioneValidiRQ {
  arrivo: string;
  partenza: string;
  oidAlbergo: number;
  oidPortale: number;
  oidTipoCameraOTA: number;
  oidTariffaOTA: number;
  oidTariffe: number[];
}

export class GetStatoPubblicazionePortaliRQ {
  oidAlbergo: number;
}

export class StatoPubblicazionePortaleXAlbergo {
  portaleXAlbergo: PortaleXAlbergo;
  percentualePubblicata: number;
  isErroriPubblicazione: boolean;
  isPubblicazioneAttiva: boolean;
  isPubblicazioneInCorso: boolean;
}

export class RegistraClienteRQ {
  oidPortale: number;
  cliente: Cliente;
}

export class GetPasswordClienteRQ {
  oidAlbergo: number;
  email: string;
}

export class CollegaTariffePortaleMasterRQ {
  oidTariffaPortaleMaster: number;
  oidTariffePortaliCollegati: number[];
}

export class GetVariazioniTassaRS extends WebApiResponse {
  data: {
    variazioniXTrattamento: VariazioneTassaSoggiornoXTrattamento[],
    variazioniXUbicazioneIstat: VariazioneTassaSoggiornoXUbicazioneIstat[]
  }
}

export class AssociazioneTipoCameraTariffe {
  tipoCamera: TipoCameraOTA;
  tariffe: TariffaOTA[];
}

export class GetModificaBlocchiFormRS extends WebApiResponse {
  data: {
    tipiCamera: TipoCameraOTA[],
    tariffe: TariffaOTA[],
    associazioniTipiCamereTariffe: AssociazioneTipoCameraTariffe[]
  };
}

export class CameraNuovoPreventivo {
  numeroAdulti: number;
  numeroBambini: number;
  tipoCamera: TipoCameraOTA;
  tariffa: TariffaOTA;
}

export class RicalcolaPropostePreventivoRQ {
  oidPreventivo: number;
  oidCodicePromozionale: number;
}

export class GetRisorseTariffePromozioniCollegateSupplementoRS extends WebApiResponse {
  data: {
    risorse: TipoCameraOTA[],
    tariffe: TariffaOTA[],
    promozioni: Promozione[]
  };
}

export class SetVariazioniXPeriodoPortaleMasterRQ {
  oidPortale: number;
  variazioniXPeriodo: PortaleXAlbergoVariazioni[];
}

export class GetCollegamentiPoliticaCancellazioneRS extends WebApiResponse {
  data: {
    fasce: string[],
    periodiListino: string[],
    pianiTariffari: string[],
    tariffe: string[],
    promozioni: string[],
    codiciPromozionali: string[]
  };
}

export class FiltroLogDisponibilita {
  pubblicataDal: string;
  pubblicataAl: string;
  dal: string;
  al: string;
  oidAlbergo: number;
  oidPortaleXAlbergo: number;
  oidTipoCameraOTA: number;
  oidTariffaOTA: number;
  skip: number;
  take: number;
  sorting: string;
  sortingType: SortingType;
}

export class FiltroLogOperazione {
  dal: string;
  al: string;
  oraDal: string;
  oraAl: string;
  oidAlbergo: number;
  oidPortaleXAlbergo: number;
  operazione: string;
  tipoOperazione: TipoOperazionePortaleXAlbergo;
  tipoEsito: TipoEsitoOperazionePortaleXAlbergo;
  codiciPrenotazione: string;
  hasPrenotazioni: boolean;
  hasErrori: boolean;
  skip: number;
  take: number;
  sorting: string;
  sortingType: SortingType;
}

export class FiltroLogRicerca {
  dal: string;
  al: string;
  arrivoDal: string;
  arrivoAl: string;
  oidPortaleXAlbergo: number;
}

export class DeleteBookingSolutionRQ {
  oidPortale: number;
  bookingSolutionUid: string;
}

export class GetTransazioniRQ extends WebApiRequestFilter {
  isPagamentiSenzaPrenotazione: boolean;
}

export class GetPreventiviRQ extends WebApiRequestFilter {
  isPagamentoInAttesaDiConferma: boolean;
}

export class GetAlberghiRQ extends WebApiRequestFilter {
  oidPortale: number;
  emailPortale: string;
}

export class GetTemplatesRQ extends WebApiRequestFilter {
  oidUbicazioneIstat: number;
}

export class GetMessaggiRQ extends WebApiRequestFilter {
  oidUbicazioneIstat: number;
}

export class LoginUtenteRQ {
  oidUtente: number;
  clientId: string;
}

export class LogoutUtenteRQ {
  oidUtente: number;
  clientId: string;
}

export class GeneraCodiceGoogleAuthenticatorRS extends WebApiResponse {
  data: {
    codice: string,
    qrCode: string
  };
}

export class VerificaPinGoogleAuthenticatorRQ {
  oidUtente: number;
  pin: string;
}

export class GeneraTokenAirbnbRQ {
  oidPortale: number;
  code: string;
}

export class AssociaRisorseTariffeServizioRQ {
  oidServizio: number;
  oidRisorse: number[];
  oidTariffe: number[];
}

export class GetRisorseTariffeNonAttiveServizioRQ {
  oidServizio: number;
  oidPortale: number;
}

export class GetRisorseTariffeNonAttiveServizioRS extends WebApiResponse {
  data: {
    risorse: TipoCameraOTA[],
    tariffe: TariffaOTA[]
  };
}

export class AssociaRisorseSistemazioneRQ {
  oidSistemazione: number;
  oidRisorse: number[];
}

export class GetRisorseNonAttiveSistemazioneRQ {
  oidSistemazione: number;
  oidPortale: number;
}

export class AssociaTariffePianoTariffarioRQ {
  oidPianoTariffario: number;
  oidTariffe: number[];
}

export class GetTariffePianoTariffarioRQ {
  oidPianoTariffario: number;
  oidPortale: number;
}

export class GetTariffePianoTariffarioRS extends WebApiResponse {
  data: {
    tariffeAttive: TariffaOTA[],
    tariffeNonAttive: TariffaOTA[]
  };
}

export class RifiutaPreventivoMyPageRQ {
  oidPreventivo: number;
  oidCausaleOperazione: number;
  note: string;
}

export class ConfigurazioneTipoCameraAirbnb {
  durataMinimaSoggiornoDefault: number;
  durataMassimaSoggiornoDefault: number;
  minimoOreAnticipoPrenotazione: number;
  spesePulizia: number;
  speseDeposito: number;
  speseBiancheria: number;
  personeInclusePrezzo: number;
  prezzoPersonaExtra: number;
  scontoMassimoGiorniPrimaCheckIn: number;
  giorniMassimiScontoPrimaCheckIn: number;
  scontoMinimoGiorniPrimaCheckIn: number;
  giorniMinimiScontoPrimaCheckIn: number;
  scontoPrenotazioniSettimanali: number;
  scontoPrenotazioniMensili: number;
}

export class GetConfigurazioneTipoCameraAirbnbRS extends WebApiResponse {
  data: ConfigurazioneTipoCameraAirbnb;
}

export class ConfigurazioneAnnuncioAirbnb {
  id: string;
  tipo: string;
  tipoCamera: string;
  letti: number;
  camereDaLetto: number;
  bagni: number;
  numeroPersone: number;
  prezzoGiornalieroDefault: number;
  prezzoWeekend: number;
}

export class GetConfigurazioneAnnuncioAirbnbRS extends WebApiResponse {
  data: ConfigurazioneAnnuncioAirbnb;
}

export class SetAnnuncioAirbnbRS extends WebApiResponse {
  data: {
    success: boolean,
    listingId: string
  };
}

export class GetPagamentoFormViewRQ {
  oidAlbergo: number;
  oidPortale: number;
  lingua: string;
}

export class GetPagamentoFormViewRS extends WebApiResponse {
  data: {
    tipiCarteCredito: TipoCartaCreditoXAlbergo[],
    newsLetterPortale: NewsLetterPortale
  };
}

export class RecuperaPrenotazioniRQ {
  oidPortaleXAlbergo: number;
  codiciPrenotazione: string[];
  isCreaPrenotazione: boolean;
}

export class ConfermaPrenotazioniWSRQ {
  oidPortaleXAlbergo: number;
  codiciPrenotazione: string[];
}

export class RecuperaPrenotazioniRS {
  tipoEsito: TipoEsitoSbm;
  descrizione: string;
  dettaglioErrore: string;
  dettaglioWarning: string;
  risultati: RecuperaPrenotazioniResultRS[];
}

export class RecuperaPrenotazioniResultRS {
  oidPrenotazioneWeb: number;
  codice: string;
  arrivo: string;
  partenza: string;
  tipoCamera: string;
  tariffa: string;
  cognome: string;
  nome: string;
  email: string;
  importo: number;
}

export class GetDisponibilitaNottiRQ {
  oidPortale: number;
  arrivo: string;
  notti: number;
}

export class DisponibilitaNotti {
  notti: number;
  partenza: string;
  isPrenotabile: boolean;
}

export class GetDisponibilitaNottiRS extends WebApiResponse {
  data: DisponibilitaNotti[];
}

export class GetClientiRQ extends WebApiRequestFilter {
  isAccountBloccato?: boolean;
}

export class AggiornaFasceWelcomeRQ {
  oidPortale: number;
  oidTipoCamera: number;
  dal: string;
  al: string;
}

export class ListSelectColumn {
  name?: string;
  property?: string;
  enum?: any;
  enumName?: string;
  caption: string;
}

export class TableColumn {
  property: string;
  caption: string;
  enum?: any;
  enumName?: string;
  dataType?: 'boolean' | 'currency' | 'date' | 'datetime';
}

export class GetContenutiRQ {
  oidUbicazioneIstat: number;
  isMobile: boolean;
  lingua: string;
}

export class GetContenutiRS extends WebApiResponse {
  data: {
    portale: PortaleMySelf,
    ubicazioneIstat: UbicazioneIstatMySelf,
    contenuti: ContenutoMySelf[],
    lingue: Lingua[],
    lingua: Lingua,
    traduzioni: string,
    pagine: PaginaMySelf[],
    oidAlbergo: number
  }
}

export class FiltroTipoCameraTariffe {
  oidTipoCamera: number;
  oidTariffe: number[];
}

export class SbloccaClientiRQ {
  oidAlbergo: number;
}

export class SetCausaliOperazioneXLinguaRQ {
  causaleOperazione: CausaleOperazione;
  causaliOperazioneXLingua: CausaleOperazioneXLingua[];

  constructor() {
    this.causaleOperazione = new CausaleOperazione();
    this.causaliOperazioneXLingua = [];
  }
}

export class WelcomeRequest {
  codiceAlbergo: number;

  constructor(codiceAlbergo: number) {
    this.codiceAlbergo = codiceAlbergo;
  }
}

export class WelcomeEseguiWorkFlowsRQ extends WelcomeRequest {
  oidWorkFlow: number;

  constructor(codiceAlbergo: number, oidWorkFlow: number) {
    super(codiceAlbergo);
    this.oidWorkFlow = oidWorkFlow;
  }
}

export class WelcomeEseguiWorkFlows {
  richiesta: Richiesta;
  prenotazione: Prenotazione;
  preventivo: Preventivo;
  workFlow: WorkFlow;
  oid: number;
  codice: string;
  data: string;
  arrivo: string;
  partenza: string;
  portale: string;
  cliente: Cliente;
}

export class WelcomeEseguiWorkFlowsRS extends WebApiResponse {
  data: WelcomeEseguiWorkFlows[];
}

export class WorkFlowsViewRS extends WebApiResponse {
  data: {
    modalitaPagamento: ModalitaPagamento[],
    tipiCamera: TipoCamera[],
    trattamenti: Trattamento[],
    parametriRicercaMercato: ParametroRicerca[],
    parametriRicercaCanaleVendita: ParametroRicerca[],
    politicheCancellazione: Cancellazione[]
  }
}

export class InviaConfigurazionePortaleRQ {
  oidPortale: number;
}

export class InviaConfigurazionePortaleRS extends WebApiResponse {
  data: { success: boolean };
}

export class GetTemplateConfigurazionePortaleRQ {
  oidPortale: number;
}

export class GetTemplateConfigurazionePortaleRS {
  data: {
    oggetto: string,
    testo: string
  };
}

export class InviaEmailPortaleRQ {
  oidPortale: number;
  oggetto: string;
  testo: string;
  email: string;
  cc: string;
}

export class RecuperaPasswordAPIRQ {
  email: string;
}

export class InviaEmailPortaleRS extends WebApiResponse {
  data: { success: boolean };
}

export class GetQuadroGraficoAccessoriWelcomeRQ extends WelcomeServerRequest {
  dal: string;
  al: string;
  oidQuadroGrafico: number;
  oidPortale: number;
  lingua: string;
}

export class RisorsaXQuadroGraficoWelcome {
  risorsa: Risorsa;
  posX: number;
  posY: number;
  width: number;
  height: number;
  isOvale: boolean;
  isOccupata: boolean;
}

export class ComponenteXRisorsaXQuadroGraficoWelcome {
  risorsa: Risorsa;
  dal: string;
  al: string;
}

export class TariffaXQuadroGraficoWelcome {
  oid: number;
  oidHotelTrattamento: number;
  oidHotelListino: number;
  descrizione: string;
  descrizioneDettagliata: string;
  supplementi: SupplementoXTariffaXQuadroGraficoWelcome[];
  modalitaPagamento: PaymentMethod[];
  servizi: BookingSolutionServiceRS[];
  cancellazione: BookingSolutionCancellationRS;
}

export class SupplementoXTariffaXQuadroGraficoWelcome {
  oid: number;
  oidHotel: number;
  nome: string;
  quantita: number;
  quantitaMassima: number;
  quantitaMassimaGiornaliera: number;
  prezzo: number;
  tipoApplicazione: TipoApplicazioneSupplemento;
}

export class GetQuadroGraficoAccessoriWelcomeRS {
  risorse: RisorsaXQuadroGraficoWelcome[];
  prenotazioni: ComponenteXRisorsaXQuadroGraficoWelcome[];
  width: number;
  height: number;
  urlImmagine: string;
  urlImmagineRisorsaLibera: string;
  urlImmagineRisorsaOccupata: string;
  urlImmagineRisorsa: string;
  tariffe: TariffaXQuadroGraficoWelcome[];
}

export class GetQuantitaMassimaGiornalieraSupplementoWelcomeRQ extends WelcomeServerRequest {
  oidSupplemento: number;
  giorni: string[];
}

export class QuantitaSupplementoXGiornoWelcome {
  data: string;
  quantita: number;
  quantitaDisponibile: number;
  oidSupplemento: number;
  nomeSupplemento: string;
}

export class GetQuantitaMassimaGiornalieraSupplementoWelcomeRS {
  quantitaUtilizzata: QuantitaSupplementoXGiornoWelcome[];
}

export class GetQuantitaMassimaGiornalieraSupplementiWelcomeRQ extends WelcomeServerRequest {
  supplementi: GetQuantitaMassimaGiornalieraSupplementoWelcomeRQ[];
}

export class GetQuantitaMassimaGiornalieraSupplementiWelcomeRS {
  quantitaUtilizzata: QuantitaSupplementoWelcome[];
}

export class QuantitaSupplementoWelcome {
  oidSupplemento: number;
  quantitaUtilizzata: QuantitaSupplementoXGiornoWelcome[];
}

export class GetPrezzoListinoPrenotazioneAccessoriWelcomeRQ extends WelcomeServerRequest {
  dal: string;
  al: string;
  oidRisorsa: number;
  oidTrattamento: number;
  oidListino: number;
  oidSupplementi: number[];
}

export class GetPrezzoListinoPrenotazioneAccessoriWelcomeRS {
  prezzo: number;
  prezzoSupplementi: number[];
}

export class GiornoCalendarioBooking {
  data: string;
  isPast: boolean;
  isOutOfMonth: boolean;
  isSelected: boolean;
  isAvailable: boolean;
  isSelectedNotAvailable: boolean;
  prezzoMinimo: number;
  durataMinimaSoggiorno: number;
  durataMassimaSoggiorno: number;
}

export class GetVersioneBookingEngineRQ {
  oidAlbergo: number;
  oidPortale: number;
}

export class VerificaCodicePromozioneBookingRQ {
  codicePromozione: string;
  arrivo: string;
  partenza: string;
  oidPortale: number;
}

export class TipiClienteViewRS extends WebApiResponse {
  data: { articoli: Articolo[] }
}

export class CheckVoucherRQ extends WelcomeServerRequest {
  voucher: string;
  lingua: string;
}

export class CheckVoucherRS {
  //giorniDisponibili: string[];
  articoli: ArticoloVoucher[];
  cliente: Cliente;
  valoreVoucher: number;
}

export class ArticoliXVoceAddebitoVoucher {
  voceAddebito: string;
  articoli: ArticoloVoucher[];
}

export class ArticoloVoucher {
  oid: number;
  nome: string;
  descrizione: string;
  urlImmagine: string
  quantita: number;
  voceAddebito: string;
  prezzo: number;
  prezzoPieno: number;
  totale: number;
}

export class GetVoucherConfigRQ {
  oidPortale: number;
  lingua: string;
  isMobile: boolean;
}

export class GetVoucherConfigRS extends WebApiResponse {
  data: VoucherConfig;
}

export class VoucherConfig {
  oidAlbergo: number;
  portale: VoucherConfigPortaleRS;
  traduzioni: string;
  lingua: Lingua;
  lingue: Lingua[];
}

export class VoucherConfigPortaleRS {
  oid: number;
  nome: string;
  nomeStruttura: string;
  oidUbicazioneIstat: number;
  isVisualizzaLogo: boolean;
  urlImmagineLogo: string;
  telefono: string;
  telefonoWhatsapp: string;
  email: string;
  urlIFrameGoogleMap: string;
  linkSitoWeb: string;
  stelle: StelleAlbergo;
  urlImmagineSfondo: string;
  indirizzo: string;
  cap: string;
  citta: string;
  provincia: string;
}

export class GetStampaPrenotazioneFormWelcomeRQ extends WelcomeServerRequest {
  oidLinguaMenu: number;
  oidPrenotazione: number;
}

export class ReportWelcome {
  oid: number;
  nome: string;
  descrizione: string;
}

export class LinguaWelcome {
  oid: number;
  lingua: string;
  codiceIso: string;
}

export class GetStampaPrenotazioneFormWelcomeRS {
  reports: ReportWelcome[];
  lingue: LinguaWelcome[];
  oidReport: number;
  oidLinguaMenu: number;
}

export class StampaPrenotazioneWelcomeRQ extends WelcomeServerRequest {
  stampaData: {
    language: string,
    stampaPrenotazioneData: {
      oidPrenotazione: number,
      oidReport: number,
      oidLinguaMenu: number
    }
  }
}

export class StampaPrenotazioneWelcomeRS {
  url: string;
}

export class CheckDisponibilitaVoucherRQ {
  oidAlbergo: number;
  voucher: string;
  data: string;
  ora: string;
}